import React, { useEffect, useState, useRef } from "react";
import {getAxiosResponse, downloadFile, postAxiosResponse, putAxiosResponse, downloadLink} from "../../../services/authApiRoutes/APImethods";
import axios from "axios";
import Select from "react-select";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import APIUrls from "../../../services/APIUrls";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate,useLocation } from "react-router-dom";
import EditProjectDateBid from "./EditProjectDateBid";
import BidNeedMoreTime from "./BidNeedMoreTime";
import FileDownloadMenuItems from "../FileDownloadMenuItems";
import { ActiveAssigneeManIcon,ActiveMultiAssigneeIconWorkFlow, GreenTickIcon, ChatIcon, SkipIcon, SkipPostEditingPencilIcon,AiqeToolTipIcon} from "../../../AppIcons";
import { ConditionalBlock } from "../../../ConditionalBlock";
import { getOrdinal, campaignDetailDate, dateFormat, utcDateTimeWithTimeZone, utcDateTimeWithTimeZoneWithFormat, transformBlankToNull } from "../../../services/Util";
import CustomProgressBar from "../../global/CustomProgressBar";
import { humanize , getLoggedInUserRole} from "../../../services/Util";
import UserAlert from "./UserAlert";
import UserTaskList from "./UserTaskList";
import Constants from "../../../Constants";
import { RotatingLines } from "react-loader-spinner";
import Calendar from "react-calendar";
import $ from "jquery";
import OverviewAlerts from "./OverviewAlerts";
import DiscussionOverviewPopup from "./DiscussionOverviewPopup";
import { useTranslation } from "react-i18next";
import UploadReviseTranslation from "./UploadReviseTranslation";
import RequestTranslationAgain from "./RequestTranslationAgain";
import RequestTranslationAgainVendor from "./RequestTranslationAgainVendor";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import UploadTmPopup from "./UploadTmPopup";
import jQuery from "jquery";
import DateFormat from "../../../pages/DateFormat";
import dateUtil from "../../../services/DateUtil";
import ReactTooltip from "react-tooltip";

const chunkSize = Constants.CHUNK_SIZE;
export const Overview = (prop) => {
  const navigate = useNavigate();
  const projectId = prop.projectDetail.resource.projectResource.id;
  const projectResource = prop.projectDetail.resource.projectResource;
  const projectDetailStatus = prop.projectDetail.displayName[0]
  const param = useParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { t } = useTranslation();
  const translate = t;
  const location = useLocation();
  const state = location.state;
  const [assetApproveErrorMsg,setAssetApproveErrorMsg] = useState('')
  const [projLangDetail, setProjLangDetail] = useState([]);
  const [approveAssetPhaseIsMultiAssignee,setApproveAssetPhaseIsMultiAssignee] = useState(false)
  const [showProgress, setShowProgress] = useState(false);
  const [showPhaseFileProgress, setShowPhaseFileProgress] = useState('');
  const [attachmentShowProgress, setAttachmentShowProgress] = useState(false);
  const [calPhaseId, setCalPhaseId] = useState("");
  const [offlineReviewFeedbackType, setOfflineReviewFeedbackType] = useState("");
  const [showSteps, setShowSteps] = useState([]);
  const [languageForMapping,setLanguageForMapping] = useState([])
  const [showChatPopup, setShowChatPopup] = useState(false);
  const [targetDataIdForDiscussion, setTargetDataIdForDiscussion] = useState(false);
  const [preferedVendors, setPreferredVendors] = useState([]);
  const [preferredVendorRaw,setPreferredVendorRaw] = useState([])
  const [autoVendorsSelected, setAutoVendor] = useState("");
  const [documentVariant, setDocumentVariant] = useState("");
  const [assignees, setAssignees] = useState([]);
  const [potentialWorkflowAssignees, setPotentialWorkflowAssignees] = useState([]);
  const [showBidPopup,setShowBidPopup] = useState(false)
  const [constAssignees, setConstAssignees] = useState([]);
  const [reviewAssignees, setReviewAssignees] = useState([]);
  const [contextId, setContextId] = useState([]);
  const [uplodResponseError,setUplodResponseError] = useState(null)
  const [vendorName,setVendorName]=useState(null);
  const [uploadInProgress,setUploadInProgress] = useState(false)
  const [uploadAssetPhaseId, setUploadAssetPhaseId] = useState("");
  const [assigneeId, setAssigneeId] = useState([]);
  const [selectedAssigneeUsers, setSelectedAssigneeUsers] = useState([]);
  const [sourcePreviewBundle,setSourcePreviewBundle] = useState([])
  const [targetPreviewBundle,setTargetPreviewBundle] = useState([])
  const [showLangLoader, setShowLangLoader] = useState(false);
  const [myTasks, setMyTasks] = useState([]);
  const [showDetail, toggleShowDetail] = useState(false);
  const [uploadingFileName,setUploadingFileName] = useState('')
  const [alertModel, toggleAlertModel] = useState(false);
  const [showRequestTranslationAgain, setShowRequestTranslationAgain] =
    useState(false);
  const [showRequestTranslationVendor,setShowRequestTranslationVendor] = useState(false) 
  const [userAlert, setUserAlert] = useState([]);
  const [options, setOptions] = useState({});
  const [languageDetail, setLanguageDetail] = useState([]);
  const [latestProjectSourceFiles, setLatestProjectSourceFiles] = useState([]);
  const [phaseAssigneeUsers, setAssigneeUsers] = useState([]);
  const [constPhaseAssignee,setConstPhaseAssignee] = useState({})
  const [phaseDetail, setPhaseDetail] = useState([]);
  const [approveAssetData, setApproveAssetData] = useState({});
  const [popUpValue, setPopUpValue] = useState("");
  const [syncErrorsRetry, showSyncErrorRetry] = useState(false);
  const [uploadDisabled,setUploadDisabled] = useState(false)
  const [ignoreValidation, setIgnoreValidation] = useState(null);
  const [targetAssetData, setTargetAssetData] = useState([]);
  const [sourceReferenceData, setSourceReferenceData] = useState([]);
  const [translationMemoryFile, setTranslationMemoryFile] = useState([]);
  const [syncErrors, setSyncErrors] = useState([]);
  const [syncErrorAction, toggleSyncErrorAction] = useState("");
  const [downloadStart, setDownloadStart] = useState(false);
  const [billingualDownloadError, setBillingualDownloadError] = useState("");
  const [masterDeliverableFile, setMasterDeliverableFile] = useState([]);
  const [phaseId, setPhaseId] = useState("");
  const [languageToReview, setLanguageToReview] = useState([]);
  const [toggle, toggleCal] = useState(false);
  const [toggleReferenceRequest, toggleReferenceRequestCal] = useState(false);
  const [fileHistory, setFileHistory] = useState([]);
  const [assetFileHistory, setAssetFileHistory] = useState([]);
  const [revisionRequests, setRevisionRequest] = useState([]);
  const [assetFeedback, setAssetFeedback] = useState([]);
  const [languagePhase, setlanguagePhase] = useState();
  const [languagesStillInTranslation, setLanguagesStillInTranslation] =
    useState([]);
  const [languagesStillInRevision, setLanguagesStillInRevision] = useState([]);
  const [languagesAlreadyApproved, setLanguagesAlreadyApproved] = useState([]);
  const [internalTranslationRequest, setInternalTranslationRequest] = useState(
    []
  );
  const [editableAssignee,setAssigneeEditable] = useState(false)
  const [currentFileIndex, setCurrentFileIndex] = useState(null);
  const [currentFileChunkIndex, setCurrentFileChunkIndex] = useState(null);

  const [cancelationAssets, setCancelationAssets] = useState([]);
  const [projectDeliverableStatus, setProjectDeliverableStatus] = useState([]);
  const [userBootstrapData, setUserBootstrapData] = useState({});
  const [confirmed, setConfirmed] = useState(false);
  const [langCode, setLanguageCode] = useState("");
  const [selectedLanguageDisplayName, setSelectedLanguageDisplayName] =
    useState("");
  const [downloadMenuItems, setDownloadMenuItems] = useState([]);
  const [approvedLangs, setApprovedLangs] = useState([]);
  const [dropDownOptionId, setDownloadOptionId] = useState("");

  const [revisionRequestDueDate, setRevisionRequestDueDate] = useState("");
  const [workflowPhase, setWorkFlowPhase] = useState();
  const [phaseAssignee, setPhaseAssignee] = useState([]);
  const projectStatus = prop.projectDetail.displayName[0].status;

  const projectSourceLanguage =
    prop.projectDetail.displayName[0].sourceLanguage;
  const projectTargetLanguages =
    prop.projectDetail.displayName[0].targetLanguages;

  const langBoxRef = useRef(null)
  const refCalendar = useRef(null);
  const refCalendar2 = useRef(null);
  const [languageTask, setLanguageTasks] = useState([]);
  const [phaseTask, setPhaseTask] = useState([]);
  const [translatedAsset, setTranslatedAsset] = useState([]);
  const [selectedTranslatedAsset, setSelectedTranslatedAsset] = useState({});
  const [historyDownload, toggleHistoryDownload] = useState(false);
  const [showRequestRevisionForm, toggleRequestRevision] = useState(false);
  const [assetId, setAssetId] = useState("");
  const [showReviewers, setShowReviewers] = useState("");
  const [showstaticReviewers, setShowstaticReviewers] = useState("");
  const [offlinePreviewBundle, setOfflinePreviewBundle] = useState([]);
  const [showAssetApproval, setShowAssetApproval] = useState(false);
  const [showAssetBack, setShowAssetBack] = useState(false);
  const [assetsForApproval, setAssetsForApproval] = useState([]);
  const [assetToMoveBack, setAssetToMoveBack] = useState([]);
  const [showDeliverableApprovePopup, setShowDeliverableApprovePopup] =
    useState(false);
  const [selectedCancelAssets, setSelectedCancelAssets] = useState([]);
  const [selectedApproveAssets, setSelectedApproveAssets] = useState([]);
  const [selectedMoveBackAssets, setSelectedMoveBackAssets] = useState([]);
  const [selectedRetryAssets, setSelectedRetryAssets] = useState([]);
  const [projectFollowers,setProjectFollowers] =useState([])
  const [selectedfile, setSelectedFile] = useState("");
  const [selectedPhaseFile, setSelectedPhaseFile] = useState([]);
  const [selectedAttachmentFile, setSelectedAttachmentFile] = useState("");
  const [documentFieldId, setDocumentFileId] = useState(-1);
  const [feebackDocumentFileId, setFeebackDocumentFileId] = useState(-1);
  const [currentChunkIndex, setCurrentChunkIndex] = useState(-1);
  const [hideStep, setHideStep] = useState([]);
  const [uploadRevisePopup, setUploadRevisePopup] = useState(false);
  const [attachmentCurrentChunkIndex, setAttachmentCurrentChunkIndex] =
    useState(-1);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [viewType,setViewType] = useState('month')
  const [nextAriaLabel,setNextAriaLabel] = useState('Go to next month')
  const [prevAriaLabel,setPrevAriaLabel] = useState('Go to previous month')
  const [next2AriaLabel,setNext2AriaLabel] = useState('Go to next year')
  const [prev2AriaLabel,setPrev2AriaLabel] = useState('Go to previous year')
  const [assigneeIndex,setAssigneeIndex]=useState("")
  const [phaseFileUploadProgress, setPhaseFileUploadProgress] = useState(0);
  const [fileAttachmentUploadProgress, setAttachmentFileUploadProgress] =
    useState(0);
  const [currentRevisionOrReviewData, setCurrentRevisionOrReviewData] =
    useState([]);
  const [showSelectedFile, setShowSelectedFile] = useState([]);
  const [translatedAssets,setTranslatedAssets] = useState({})
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const getPermissions = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission
  ).value;
  const [requestRevisionMessage, setRequestRevisionMessage] = useState("");
  const [feedBackMessage, setFeedBackMessage] = useState("");
  const [reviewAssigneeList, setReviewAssigneeList] = useState([]);
  const [showUploadTM, setShowUploadTM] = useState(false);
  const [skipPostEditing, setSkipPostEditing] = useState(false);
  const [expandAll, setExpandAll] = useState(false);
  const [currentPhase,setcurrentPhase] = useState(undefined);

  const vendorMode = !workflowPhase?.assignedToSilo;
  const roleArray = getLoggedInUserRole();
  function filterFunctionthree() {
    var element = document.getElementById("filterBtn3");
    var element2 = document.getElementById("activeId3");
    element.classList.toggle("show-flex");
    element2.classList.toggle("active");
  }
	const projectData = useSelector(
		(reduxStore) => reduxStore.project_info
	).value;
  const assigneeEditable = (phaseId) =>{
    editableAssignee === phaseId ? setAssigneeEditable('') : setAssigneeEditable(phaseId)
  }
  const showBidUpdatePopup = () =>{
    showBidPopup ? setShowBidPopup(false) : setShowBidPopup(true)
  }
const viewChange = (action, activeStartDate, value, view) =>{
    setViewType(view)
    if(view === 'month'){
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_MONTH)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_MONTH)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
    }
    if(view === 'year'){
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
    }
    if(view === 'decade'){
        $('.react-calendar__tile--hasActive').addClass("decade-active");
        $('.react-calendar__tile--hasActive').focus()
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
    }
    if(view === 'century'){
        $('.react-calendar__tile--hasActive').addClass("decade-active");
        $('.react-calendar__tile--hasActive').focus()
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
    }
  }
  const setUploadBoxHeight = () =>{
    
    var fileListHeight = $('.multi-file-left').height()
    $('#multifile-dropDown').height(`${fileListHeight}px`)
  }
  function referenceShow() {
    var element = document.getElementById("reference");
    element.classList.toggle("showTable");
    $('#reference').attr('aria-expanded', function(index, attr){
      return attr === 'true' ? 'false': 'true';
    });
  }
  const matchFileExtension = (fileAdded,existingFile) =>{
    if(fileAdded && !options?.features?.SKIP_XLIFF_STRUCTURE_VALIDATION ){
      var isValid = true;
      var fileAddedExtenstion = fileAdded.substr(fileAdded.lastIndexOf(".") + 1);
      var expectedFileExtension = existingFile.substr(existingFile.lastIndexOf(".") + 1);
      if(custBootstrapDataRedux.roleSet.vendorType || custBootstrapDataRedux.roleSet.customerInternalTranslator){
        if('xlf' === expectedFileExtension.toLowerCase() || 'xliff' === expectedFileExtension.toLowerCase()){
          if(fileAddedExtenstion === expectedFileExtension){
            isValid = true
          }else{
            isValid = false
          }
        }
      }  
      return isValid
    }
    
  }
  const ReferenceEscFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      referenceShow()
      $("#reference").trigger("focus");
    }
    else if(event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true'){
      setTimeout(() => {
        $("#reference").trigger("focus"); 
      });
      referenceShow()
    }
  }
  const ReferenceModalFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
       referenceShow()
       $("#reference").trigger("focus");
    }
    if ($(document.activeElement).is('button:first-of-type')) {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        referenceShow()
        $("#reference").trigger("focus");
      }
  }
  if ($(document.activeElement).is('button:last-child')) {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        referenceShow()
        $("#reference").trigger("focus");
      }
  }
  }
  const allowAutomaticSelect = () => {
    return (
      !options.preferences.TRIAL_MODE_ENABLED &&
      options?.permissions["BID_OUT_TO_CW_CHOSEN_VENDORS"] &&
      !options.features.WHITE_LABEL_VENDOR_EXCLUSIVE
    );
  };
  const getAssigneAndStatus = () => {
    var selectedPhaseAssignee = phaseAssignee.filter((assignee) => {
      return assignee.asset.id === selectedTranslatedAsset.id;
    })[0];

    var html = (
      <>
        <span className="p-3">
          {selectedPhaseAssignee.user.firstName +
            selectedPhaseAssignee.user.lastName}
        </span>{" "}
        {selectedPhaseAssignee.status === "OPEN" ? <span>{Constants.IN_PROGRESS}</span> : <span>{"(" + humanize(selectedPhaseAssignee.status) + ")"}</span>}
        
      </>
    );

    return html;
  };
  const refreshPage = (langCode) => {
    setUploadRevisePopup(false);
    fetchLanguageDetail(langCode);
  };
  useEffect(()=>{
    if(param.langCode){
      fetchLanguageDetail(param.langCode)
      navigate(`/project/${param.id}`, {state:{langCode:param.langCode}},{ replace: true });
    }

  },[param.langCode])
  const generateTicket = () => {
    window.location.href = Constants.TICKET_GENERATE_EXTERNAL_LINK;
  };
 
  useEffect(()=>{
    getProjectFollower()
  },[projectResource])

  const getProjectFollower=()=>{
    getAxiosResponse(APIUrls.PROJECT_FOLLOWERS_BY_GROUP(projectResource?.userGroup?.id)).then(res=>{
      if(res?.data?.data && res?.data?.data?.length > 0){
      let followers=res.data.data.map(data=>{
          return  data.resource.customerUser
         })
        setProjectFollowers(followers)
      }
      
    }).catch(err=>{
      console.log(err)
    })
  }


  const openReviewers = (id,name) => {
    showReviewers === id ? setShowReviewers("") : setShowReviewers(id);
      setTimeout(() => {
        $(".defaultSelect").trigger("focus");
      });
      if(name){
        setAssigneeIndex(name)
      }
  };
  const openReviewersKeydown = (event, id,name) =>{
    if (event.key === Constants.ENTER) {
      showReviewers === id ? setShowReviewers("") : setShowReviewers(id);
      setTimeout(() => {
        $(".defaultSelect").trigger("focus");
      });
      if(name){
      setAssigneeIndex(name)
      }
    }
    if (event.key === Constants.ESCAPE) {
      openReviewers()
    }
    if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
      setShowReviewers("")
    }
  }
  const openReviewersModalFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      openReviewers()
    }
    if (document.activeElement.id === 'contextTextMenuContainer') {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        openReviewers()
      }
  }
  if ($(document.activeElement).is('.max-heightInherit .left.flex button:last-child')) {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        openReviewers()
      }
  }
  }

  const save  = (user) => {
   
    confirmAlert({
      title: "The project has been successfully assigned to "+user?.firstName +" "+ user?.lastName,
      message: <p>{`Kindly share the Assignment details with the assignee as well.`}</p>,
      buttons: [
        {
          label: "ok",
          id: "deleteYes",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  };
  
  
  const openStaticReviewers = (id) => {
    showstaticReviewers === id ? setShowstaticReviewers("") : setShowstaticReviewers(id);
    setTimeout(() => {
      showstaticReviewers === id ? $(document.activeElement).removeAttr("aria-labelledby") :
      $(document.activeElement).attr("aria-labelledby", "assigneeDetails");
    }, 300);
    showDownloadOptions()
  };
  $(document).on("click",".user.mr-15",function() {
    $(this).addClass('clickActive')
  });
  const handleUserEscFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      openStaticReviewers()
      $(".clickActive").trigger("focus");
      $('.user.mr-15').removeClass('clickActive')
    }
    if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
      setTimeout(() => {
        $(".clickActive").trigger("focus");
        $('.user.mr-15').removeClass('clickActive')
      });
      openStaticReviewers()
    }
    
  }
  
  const showCalendarRevisionRequestDate = (e) => {
    e.preventDefault();
    toggleReferenceRequest
      ? toggleReferenceRequestCal(false)
      : toggleReferenceRequestCal(true);
    $('#calSecondFocus').toggleClass('calSecondFocus')
    $('.calSecondFocus').trigger('focus')
    if (toggleReferenceRequest) {
      var requiredElement = document.querySelector(".dashCalendarInternal");
      if (requiredElement !== null) {
        requiredElement.focus();
      }
    }
  };
	const handleShowCalendarRevisionRequestDate = (event) => {
		if (event.key === Constants.ESCAPE) {
		  toggleReferenceRequestCal(false)
			$('.calSecondFocus').trigger('focus')
			$('#calSecondFocus').removeClass('calSecondFocus')
		}
  }
    $("#calSecondFocus").on("keydown", function (e) {
      if (e.key === Constants.ESCAPE) {
        if($('div').hasClass('dashCalendarInternal')){
        toggleCal(false)
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
         }
       }
       if (e.key === Constants.TAB && e.shiftKey) {
        if($('div').hasClass('dashCalendarInternal')){
        toggleCal(false)
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
         }
       }
    });


  const moveBackAssetSelected = (asset) => {
    var hasItem = [];
    hasItem = selectedMoveBackAssets.filter((e) => {
      return e.id === asset.id;
    });
    if (hasItem.length > 0) {
      return true;
    } else {
      return false;
    }
  };
  const retryAssetSelected = (asset) => {
    var hasItem = [];
    hasItem = selectedRetryAssets.filter((e) => {
      return e === asset;
    });
    if (hasItem.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const doesPhaseHaveOpenReviewAssets = (selectedPhaseId) => {
    var phaseBucket = phaseDetail.filter((phase) => {
      return phase.phaseId === selectedPhaseId;
    })[0];
    let key = Object.keys(phaseBucket.review.current);
    if (
      phaseBucket &&
      phaseBucket.review &&
      phaseBucket.review.current &&
      phaseBucket.review.current[key] !== undefined
    ) {
      return true;
    } else {
      return false;
    }
  };

  const refreshProject = () => {
    prop.refresh("overView");
  };

  const AssigneeEditableReadOnly = (prop) => {
    var selectedStep = prop.step;
    var selectedPhase = prop.phase;
    var round = prop.round ? `-${prop.round}` :''
    var phaseIndex = prop.phaseIndex;
    var name = prop.name; 
    var html = [];
    languageDetail?.steps?.map((step,index) => {
      if (step?.stepNumber === selectedStep?.stepNumber) {
        step?.phases?.map((phase) => {
          if (phase?.phaseNumber === selectedPhase?.phaseNumber) {
            if (phase?.assignedToVendor) {
              if (phase?.assigneeType?.code === "customer_user") {
                if (options?.permissions && options?.permissions?.PROJECT_CUD) {
                  html = (
                    <div className="name 65 global-dropdown-select">
                      <div
                        className="role-admin-btn defaultSelect"
                        tabIndex="0"
                        aria-expanded={showReviewers === selectedPhase.phaseId + "-" + phaseIndex+round}
                        onClick={() =>openReviewers(selectedPhase.phaseId + "-" + phaseIndex+round,name)}
                        onKeyDown={(e) => openReviewersKeydown(e, selectedPhase.phaseId + "-" + phaseIndex+round,name)}
                        role="button"
                      >
                        {phaseAssigneeUsers && phaseAssigneeUsers.length > 0 && phaseAssigneeUsers?.map((users, index) => {
                          if (
                            users?.phaseId === selectedPhase?.phaseId &&
                            users?.assigneeType === "customer_user"
                          ) {
                            return users?.users.map((user, userIndex) => {
                              if (users?.allowMultiAssignee) {
                                if (userIndex === 0)
                                  return (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="19"
                                      viewBox="0 0 24 19"
                                      fill="none"
                                    >
                                      <path
                                        d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                        fill="#64748B"
                                        stroke="#64748B"
                                        strokeWidth="0.2"
                                      />
                                    </svg>
                                  );
                                else {
                                  return (
                                    <span
                                      key={userIndex - selectedPhase?.phaseId}
                                    >
                                      {" "}
                                      {user?.fullName}
                                    </span>
                                  );
                                }
                              } else {
                                return (
                                  <span key={userIndex}> {user?.fullName}</span>
                                );
                              }
                            });
                          } else if (
                            users?.assigneeType === "vendor" &&
                            users?.phaseId === selectedPhase?.phaseId
                          ) {
                            return users?.users;
                          }
                        })}
                      </div>
                     <div
                        className={
                          showReviewers ===
                          selectedPhase.phaseId + "-" + phaseIndex+round && name === assigneeIndex
                            ? "global-dropdown action-display-revert-overflow width246 show p-5 max-heightInherit 1"
                            : "global-dropdown action-display-revert-overflow width246 p-5"
                        }
                        style={{ padding: "10px" }}
                        // onKeyDown={(e) => openReviewersModalFocus(e)}
                      >
                        <div className="global-dropdown-select small-dropdown-select assignee-remove-block">
                          <div className="multiselect-output mar-bot16">
                            {phaseAssigneeUsers.length > 0
                              ? phaseAssigneeUsers?.map((users, index) => {
                                  if (
                                    users?.allowMultiAssignee &&
                                    users.phaseId === selectedPhase.phaseId
                                  ) {
                                    return users.users.map((user, index) => {
                                      return (
                                        <button
                                          key={index}
                                          disabled = {!editableAssignee}
                                          onClick={() =>
                                            removeAssignee(
                                              user,
                                              selectedPhase.phaseId
                                            )
                                          }
                                        >
                                          <strong>
                                            {user.firstName +
                                              " " +
                                              user.lastName}
                                          </strong>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="10"
                                            height="9"
                                            viewBox="0 0 10 9"
                                            fill="none"
                                          >
                                            <path
                                              d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                              stroke="#213248"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            ></path>
                                          </svg>
                                        </button>
                                      );
                                    });
                                  }
                                })
                              : null}
                          </div>
                          <div className="mar-bot16 global-dropdown-block">
                            {multipleAssignee(selectedPhase.phaseId) ? (
                              getPhaseAssignee(
                                selectedPhase.phaseId,
                                phase
                              ).length > 0 ?
                              <Select classNamePrefix='cw'
                                isMulti={true}
                                className=" lastOutFocus"
                                hideSelectedOptions={false}
                                closeMenuOnSelect={true}
                                aria-label="Select multiple assignee"
                                options={getPhaseAssignee(
                                      selectedPhase.phaseId,
                                      phase
                                    )} 
                                onChange={(e) =>
                                      selectedAssignees(
                                        e[0].value,
                                        selectedPhase.phaseId
                                      )
                                    }
                              />
                              : ''
                            ) : (
                              <Select classNamePrefix='cw'
                                        className=" lastOutFocus"
                                        aria-label="Select assignee"
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={true}
                                        value={getPhaseAssignee(
                                          selectedPhase?.phaseId,
                                              phase
                                        ).filter((user)=>{
                                          return user.value.userId === assigneeId
                                        })}
                                        options={getPhaseAssignee(
                                              selectedPhase?.phaseId,
                                              phase
                                            )} 
                                        onChange={(e) =>
                                          setAssigneeId(Number(e.value.userId))
                                            }
                                      />
                            )}
                          </div>

                          <div className="left flex btn-gap justify-end">
                            <button
                              className="blue-btn triggerBtn"
                              onClick={() => {setAssigneeEditable(false);setAssigneeId([]);setAssigneeUsers(constPhaseAssignee);openReviewers("")}}
                            >
                              Cancel
                            </button>

                            <button
                              className="blue-btn active"
                              disabled={phaseAssigneeUsers.length === 0}
                              onClick={() => selectAssignee(phase)}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>                      
                    </div>
                  );
                }
                else{
                  html = (
                    <div className="name">
                      {phaseAssigneeUsers && phaseAssigneeUsers?.length > 0 &&  phaseAssigneeUsers.map((users, index) => {
                        if (
                          users?.phaseId === selectedPhase?.phaseId &&
                          users?.assigneeType === "customer_user"
                        ) {
                          return users?.users?.map((user, userIndex) => {
                            return (
                              <span key={userIndex + 3}> {user?.fullName}</span>
                            );
                          });
                        } else if (
                          users?.assigneeType === "vendor" &&
                          users?.phaseId === selectedPhase?.phaseId
                        ) {
                          return (
                            <span key={index + 2} className="vendor-user">
                              {" "}
                              {users.users}
                            </span>
                          );
                        }
                      })}
                    </div>
                  );
                }
              } else {
                html = (
                  <div className="name">
                    {phaseAssigneeUsers && phaseAssigneeUsers?.length > 0 && phaseAssigneeUsers.map((users, index) => {
                      if (users?.phaseId === selectedPhase?.phaseId &&
                        users?.assigneeType === "machine_translator") {
                          // commneted because of conflict will remoe later
                        // return projectData?.translationEngineType?.display
                        return prop.assigneName !==undefined?prop.assigneName:projectData.translationEngineType.display;

                      } else if (
                        users?.phaseId === selectedPhase?.phaseId &&
                        users?.assigneeType === "customer_user"
                      ) {
                        return users?.users?.map((user, userIndex) => {
                          return (
                            <span key={userIndex + 3}> {user?.fullName}</span>
                          );
                        });
                      } else if (
                        users?.assigneeType === "vendor" &&
                        users?.phaseId === selectedPhase?.phaseId
                      ) {
                        return (
                          <span key={index + 2} className="vendor-user">
                            {" "}
                            {users.users}
                          </span>
                        );
                      }
                    })}
                  </div>
                );
              }
            } else{
              phaseAssigneeUsers && phaseAssigneeUsers?.length > 0 && 
              phaseAssigneeUsers?.map((users, index) => {
                if (users?.phaseId === selectedPhase?.phaseId) {
                  if (users?.users && users?.users?.length > 0) {
                    users.users.map((user, userIndex) => {
                      if (phase.allowMultiAssignee) {
                          html = (
                            <div className="name 65 global-dropdown-select">
                              <div
                                className="role-admin-btn defaultSelect"
                                tabIndex="0"
                                aria-expanded={
                                  showReviewers ===
                                  selectedPhase.phaseId + "-" + phaseIndex+round
                                    ? "true"
                                    : "false"
                                }
                                onClick={() =>
                                  openReviewers(
                                    selectedPhase.phaseId + "-" + phaseIndex+round
                                  )
                                }
                                onKeyDown={(e) => openReviewersKeydown(e, selectedPhase.phaseId + "-" + phaseIndex+round)}
                                role="button"
                              >
                               
                                {phaseAssigneeUsers && phaseAssigneeUsers.length > 0 && phaseAssigneeUsers?.map((users, index) => {
                                  if (
                                    users?.phaseId === selectedPhase?.phaseId &&
                                    users?.assigneeType === "customer_user"
                                  ) {
                                    return users?.users.map((user, userIndex) => {
                                      if (phase.allowMultiAssignee) {
                                         if (userIndex === 0){
                                          return (
                                            <span key={userIndex}> {user?.fullName}{users?.users.length > 1 ? <strong className="ml-6">{` + ${users.users.length -1}`}</strong> : ''}</span>
                                          );
                                        }
                                        
                                      } else {
                                        return (
                                          <span key={userIndex}> {user?.fullName}</span>
                                        );
                                      }
                                    });
                                  } else if (
                                    users?.assigneeType === "vendor" &&
                                    users?.phaseId === selectedPhase?.phaseId
                                  ) {
                                    return users?.users;
                                  }
                                })}
                              </div>
                              <div
                                className={
                                  showReviewers ===
                                  selectedPhase.phaseId + "-" + phaseIndex+round
                                    ? "global-dropdown action-display-revert-overflow width246 show p-5 max-heightInherit 2"
                                    : "global-dropdown action-display-revert-overflow width246 p-5"
                                }
                                style={{ padding: "10px" }}
                                onKeyDown={(e) => openReviewersModalFocus(e)}
                              >
                                <div className="global-dropdown-block small-dropdown-select assignee-remove-block">
                                  <div className=" multiselect-output mar-bot16">
                                    {phaseAssigneeUsers.length > 0
                                      ? phaseAssigneeUsers?.map((users, index) => {
                                          if (
                                            users?.allowMultiAssignee &&
                                            users.phaseId === selectedPhase.phaseId
                                          ) {
                                            return users.users.map((user, index) => {
                                              return (
                                                <button
                                                  key={index}
                                                  disabled = {!editableAssignee}
                                                  onClick={() =>
                                                    removeAssignee(
                                                      user,
                                                      selectedPhase.phaseId
                                                    )
                                                  }
                                                >
                                                  <strong>
                                                    {user.firstName +
                                                      " " +
                                                      user.lastName}
                                                  </strong>
                                                  {editableAssignee === selectedPhase.phaseId ?
                                                  <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="10"
                                                  height="9"
                                                  viewBox="0 0 10 9"
                                                  fill="none"
                                                >
                                                  <path
                                                    d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                                    stroke="#213248"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  ></path>
                                                </svg> : ''
                                                  }
                                                  
                                                </button>
                                              );
                                            });
                                          }
                                        })
                                      : null}
                                  </div>
                                  <div className="add-remove-assignee">
                                  {options?.permissions && options?.permissions?.PROJECT_CUD && doesPhaseHaveOpenReviewAssets(selectedPhase.phaseId) ? <button onClick={()=>assigneeEditable(selectedPhase.phaseId)}>Add/Remove</button> : ''}
                                  </div>
                                  {editableAssignee === selectedPhase.phaseId ? 
                                  <div className="mar-bot16 global-dropdown-select width210 1">
                                    {multipleAssignee(selectedPhase.phaseId) ? 
                                     getPhaseAssignee(
                                      selectedPhase.phaseId,
                                      phase
                                    ).length > 0 ?
                                    (
                                      <Select classNamePrefix='cw'
                                        aria-label="Select multiple assignee"
                                        isMulti={true}
                                        className=" lastOutFocus"
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={true}
                                        options={getPhaseAssignee(
                                              selectedPhase.phaseId,
                                              phase
                                            )} 
                                        onChange={(e) =>
                                              selectedAssignees(
                                                e[0].value,
                                                selectedPhase.phaseId
                                              )
                                            }
                                      />
                                       ) : ''
                                     : (
                                      <Select classNamePrefix='cw'
                                        className=" lastOutFocus"
                                        aria-label="Select assignee"
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={true}
                                        value={getPhaseAssignee(
                                          selectedPhase?.phaseId,
                                              phase
                                        ).filter((user)=>{
                                          return user.value.userId === assigneeId
                                        })}
                                        options={getPhaseAssignee(
                                              selectedPhase?.phaseId,
                                               phase
                                            )} 
                                        onChange={(e) =>
                                          setAssigneeId(Number(e.value.userId))
                                            }
                                      />
                                    )}
                                  </div>
                                : ""}
                                 {editableAssignee === selectedPhase.phaseId?
                                  <div className="left flex btn-gap justify-end">
                                    <button
                                      className="blue-btn triggerBtn"
                                      onClick={() => {setAssigneeEditable(false);setAssigneeId([]);setAssigneeUsers(constPhaseAssignee);openReviewers("")}}
                                    >
                                      Cancel
                                    </button>
        
                                    <button
                                      className="blue-btn active"
                                      onClick={() => selectAssignee(phase)}
                                    >
                                      Save
                                    </button>
                                  </div>
                                   :""}
                                </div>
                               
                              </div>
                            </div>
                          );
                      } else {
                        if (
                          doesPhaseHaveOpenReviewAssets(
                            selectedPhase.phaseId
                          ) &&
                          options?.permissions &&
                          options?.permissions?.PROJECT_CUD
                        ) {
                          html = (
                            <div className="name 65 global-dropdown-select">
                              <div
                                className="role-admin-btn defaultSelect"
                                tabIndex="0"
                                aria-expanded={
                                  showReviewers ===
                                  selectedPhase.phaseId + "-" + phaseIndex+round
                                    ? "true"
                                    : "false"
                                }
                                onClick={() =>
                                  openReviewers(selectedPhase.phaseId + "-" + phaseIndex+round)
                                }
                                onKeyDown={(e) => openReviewersKeydown(e, selectedPhase.phaseId + "-" + phaseIndex+round)}
                                role="button"
                              >
                                {phaseAssigneeUsers?.map((users, index) => {
                                  if (
                                    users.phaseId === selectedPhase.phaseId &&
                                    users.assigneeType === "customer_user"
                                  ) {
                                    return users.users.map(
                                      (user, userIndex) => {
                                        if (users?.allowMultiAssignee) {
                                          if (userIndex === 0)
                                            return (
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="19"
                                                viewBox="0 0 24 19"
                                                fill="none"
                                              >
                                                <path
                                                  d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                                  fill="#64748B"
                                                  stroke="#64748B"
                                                  strokeWidth="0.2"
                                                />
                                              </svg>
                                            );
                                          else {
                                            return (
                                              <span key={userIndex}>
                                                {" "}
                                                {user.fullName}
                                              </span>
                                            );
                                          }
                                        } else {
                                          return (
                                            <span key={userIndex}>
                                              {" "}
                                              {user.fullName}
                                            </span>
                                          );
                                        }
                                      }
                                    );
                                  } else if (
                                    users.assigneeType === "vendor" &&
                                    users.phaseId === selectedPhase.phaseId
                                  ) {
                                    return users.users;
                                  }
                                })}
                              </div>
                              <div
                                className={
                                  showReviewers ===
                                  selectedPhase.phaseId + "-" + phaseIndex+round
                                    ? "global-dropdown action-display-revert-overflow width246 show p-5 max-heightInherit 3"
                                    : "global-dropdown action-display-revert-overflow width246 p-5"
                                }
                                style={{ padding: "10px" }}
                                onKeyDown={(e) => openReviewersModalFocus(e)}
                                
                              >
                                <div className="global-dropdown-select small-dropdown-select assignee-remove-block">
                                  <div className="multiselect-output mar-bot16">
                                    {phaseAssigneeUsers.length > 0
                                      ? phaseAssigneeUsers?.map(
                                          (users, index) => {
                                            if (
                                              users?.allowMultiAssignee &&
                                              users.phaseId ===
                                                selectedPhase.phaseId
                                            ) {
                                              return users.users.map(
                                                (user, index) => {
                                                  return (
                                                    <button
                                                      key={index}
                                                      disabled = {!(editableAssignee === selectedPhase.phaseId)}
                                                      onClick={() =>
                                                        removeAssignee(
                                                          user,
                                                          selectedPhase.phaseId
                                                        )
                                                      }
                                                    >
                                                      <strong>
                                                        {user.firstName +
                                                          " " +
                                                          user.lastName}
                                                      </strong>
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="10"
                                                        height="9"
                                                        viewBox="0 0 10 9"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                                          stroke="#213248"
                                                          strokeWidth="1.5"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        ></path>
                                                      </svg>
                                                    </button>
                                                  );
                                                }
                                              );
                                            }
                                          }
                                        )
                                      : null}
                                  </div>
                                  <div className="mar-bot16 global-dropdown-block">
                                    <div className="global-dropdown-select" >
                                    {multipleAssignee(selectedPhase.phaseId) ? (
                                       getPhaseAssignee(
                                        selectedPhase.phaseId,
                                        phase
                                      ).length > 0 ?
                                      <Select classNamePrefix='cw'
                                        aria-label="Select multiple assignee"
                                        isMulti={true}
                                        className=" lastOutFocus"
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={true}
                                        options={getPhaseAssignee(
                                              selectedPhase.phaseId,
                                              selectedPhase
                                            )} 
                                        onChange={(e) =>
                                              selectedAssignees(
                                                e[0].value,
                                                selectedPhase.phaseId
                                              )
                                            }
                                      />
                                      : ''
                                    ) : (
                                      <Select classNamePrefix='cw'
                                        className=" lastOutFocus"
                                        aria-label="Select assignee"
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={true}
                                        options={getPhaseAssignee(
                                              selectedPhase?.phaseId,
                                               selectedPhase
                                            )} 
                                        value={getPhaseAssignee(
                                          selectedPhase?.phaseId,
                                           selectedPhase
                                        ).filter((user)=>{
                                          return user.value.userId === assigneeId
                                        })}
                                        onChange={(e) =>
                                          setAssigneeId(Number(e.value.userId))
                                            }
                                      />
                                     
                                    )}
                                  </div>
                                   </div>         
                                  <div className="left flex btn-gap justify-end">
                                    <button
                                      className="blue-btn triggerBtn"
                                      onClick={() => {setAssigneeEditable(false);setAssigneeId([]);setAssigneeUsers(constPhaseAssignee);openReviewers("")}}
                                    >
                                      Cancel
                                    </button>

                                    <button
                                      id="reviewerBtn"
                                      className="blue-btn active"
                                      onClick={() => selectAssignee(phase)}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        } else {
                          html = (
                            <div>
                              <span key={userIndex}> {user.fullName}</span>
                            </div>
                          );
                        }
                      }
                    });
                  } else {
                    html = (
                      <div className="name 65 global-dropdown-select">
                        <div
                          className="role-admin-btn defaultSelect"
                          tabIndex="0"
                          aria-expanded={
                            showReviewers ===
                            selectedPhase.phaseId + "-" + phaseIndex+round
                              ? "true"
                              : "false"
                          }
                          onClick={() =>openReviewers(selectedPhase.phaseId + "-" + phaseIndex+round)
                          }
                          onKeyDown={(e) => openReviewersKeydown(e, selectedPhase.phaseId + "-" + phaseIndex+round)}
                          role="button"
                        >
                          {(()=> {
                           
                          if(phase.allowMultiAssignee ){
                           return(
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="19"
                                viewBox="0 0 24 19"
                                fill="none"
                              >
                                <path
                                  d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                  fill="#64748B"
                                  stroke="#64748B"
                                  strokeWidth="0.2"
                                />
                              </svg>
                            )
                         
                        }else{
                          phaseAssignee.map((assignee) => {
                            return (
                              <span>
                                {assignee.user.firstName +
                                  " " +
                                  assignee.user.lastName}
                              </span>
                            );
                          })
                        }
                      })()}
                     
                        </div>
                        <div
                          className={
                            showReviewers ===
                            selectedPhase.phaseId + "-" + phaseIndex+round
                              ? "global-dropdown action-display-revert-overflow width246 show p-5 max-heightInherit 4"
                              : "global-dropdown action-display-revert-overflow width246 p-5"
                          }
                          style={{ padding: "10px" }}
                          onKeyDown={(e) => openReviewersModalFocus(e)}
                        >
                          <div className="global-dropdown-select small-dropdown-select assignee-remove-block">
                            <div className="multiselect-output mar-bot16">
                              {phaseAssigneeUsers.length > 0
                                ? phaseAssigneeUsers?.map((users, index) => {
                                    if (
                                      users?.allowMultiAssignee &&
                                      users.phaseId === selectedPhase.phaseId
                                    ) {
                                      return users.users.map((user, index) => {
                                        return (
                                          <button
                                            key={index}
                                            disabled = {!(editableAssignee === selectedPhase.phaseId)}
                                            onClick={() =>
                                              removeAssignee(
                                                user,
                                                selectedPhase.phaseId
                                              )
                                            }
                                          >
                                            <strong>
                                              {user.firstName +
                                                " " +
                                                user.lastName}
                                            </strong>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="10"
                                              height="9"
                                              viewBox="0 0 10 9"
                                              fill="none"
                                            >
                                              <path
                                                d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                                stroke="#213248"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              ></path>
                                            </svg>
                                          </button>
                                        );
                                      });
                                    }
                                  })
                                : null}
                            </div>
                            <div className="mar-bot16 global-dropdown-block ">
                              <div className="global-dropdown-select width210" >
                              {multipleAssignee(selectedPhase.phaseId) ? (
                                 getPhaseAssignee(
                                  selectedPhase.phaseId,
                                  phase
                                ).length > 0 ?
                                <Select classNamePrefix='cw'
                                  aria-label="Select multiple assignee"
                                  isMulti={true}
                                  className=" lastOutFocus"
                                  hideSelectedOptions={false}
                                  closeMenuOnSelect={true}
                                  options={getPhaseAssignee(
                                        selectedPhase.phaseId,
                                        selectedPhase
                                      )} 
                                  onChange={(e) =>
                                        selectedAssignees(
                                          e[0].value,
                                          selectedPhase.phaseId
                                        )
                                      }
                                />
                                : ''
                              ) : (
                                <Select classNamePrefix='cw'
                                    className=" lastOutFocus"
                                    aria-label="Select assignee"
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={true}
                                    value={getPhaseAssignee(
                                      selectedPhase?.phaseId,
                                       selectedPhase
                                    ).filter((user)=>{
                                      return user.value.userId === assigneeId
                                    })}
                                    options={getPhaseAssignee(
                                          selectedPhase?.phaseId,
                                          selectedPhase
                                        )} 
                                    onChange={(e) =>
                                      setAssigneeId(Number(e.value.userId))
                                        }
                                  />
                                
                              )}
                            </div>
                            </div>

                            <div className="left flex btn-gap justify-end">
                              <button
                                className="blue-btn triggerBtn"
                                onClick={() => {setAssigneeEditable(false);setAssigneeId([]);setAssigneeUsers(constPhaseAssignee);;openReviewers("")}}
                              >
                                Cancel
                              </button>

                              <button
                                className="blue-btn active"
                                onClick={() => selectAssignee(phase)}
                                disabled={phaseAssigneeUsers.length > 0}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                } else if (
                  users.assigneeType === "vendor" &&
                  users.phaseId === selectedPhase.phaseId
                ) {
                  html = (
                    <div>
                      <span key={index}> {users.users}</span>
                    </div>
                  );
                }
              });
            }
          }
        });
      }
    });
    return html;
  };
  const isPhaseCompleted = (phase, stepNumber, currentStep, currentPhase) => {
    // this is based on this.currentStep and this.currentPhase
    if (
      !currentStep ||
      !currentPhase ||
      !currentStep.stepNumber ||
      !currentPhase.phaseNumber
    ) {
      return false;
    }

    if (currentStep.stepNumber > stepNumber) {
      // If the current step number is after this phase's step number, this phase is completed
      return true;
    } else if (currentStep.stepNumber < stepNumber) {
      // Conversely, if the current step number is after this phase's step number, this phase is incomplete
      return false;
    } else {
      // this means this step is the active step
      return phase.phaseNumber < currentPhase.phaseNumber;
    }
  };

  const setRevisonRequestDate = (event) => {
    setRevisionRequestDueDate(event);
    toggleReferenceRequestCal(false);
		$('.calSecondFocus').trigger('focus')
    $('#calSecondFocus').removeClass('calSecondFocus')
  };

  const showDownloadOptions = (id) => {
    dropDownOptionId === id ? setDownloadOptionId("") : setDownloadOptionId(id);
  };
  $(document).on("click",".downloadLangdoc",function() {
      $(this).addClass('clickActive')
  });
  const handleEscFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      showDownloadOptions()
      $(".clickActive").trigger("focus");
      $('.downloadLangdoc').removeClass('clickActive')
    }
    if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
      setTimeout(() => {
        $(".clickActive").trigger("focus");
        $('.downloadLangdoc').removeClass('clickActive')
      });
      showDownloadOptions()
    }
    
  }
  const handleModalFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      showDownloadOptions()
      $(".clickActive").trigger("focus");
      $('.downloadLangdoc').removeClass('clickActive')
    }
    if ($(document.activeElement).is('li:first-child a')) {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        showDownloadOptions()
        $(".clickActive").trigger("focus");
        $('.downloadLangdoc').removeClass('clickActive')
      }
  }
  if ($(document.activeElement).is('li:last-child a')) {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        showDownloadOptions()
        $(".clickActive").trigger("focus");
        $('.downloadLangdoc').removeClass('clickActive')
      }
  }
  }
  const showHistoryDownloadOptions = () => {
    historyDownload ? toggleHistoryDownload(false) : toggleHistoryDownload(true);
  };
  $(document).on("click",".offlinedownloadLangdoc",function() {
    $(this).addClass('clickActive')
  });
  const handleofflineEscFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      showHistoryDownloadOptions()
      $(".clickActive").trigger("focus");
      $('.offlinedownloadLangdoc').removeClass('clickActive')
    }
    if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
      setTimeout(() => {
        $(".clickActive").trigger("focus");
        $('.offlinedownloadLangdoc').removeClass('clickActive')
      });
      showHistoryDownloadOptions()
    }
    
  }
  const handleofflineModalFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      showHistoryDownloadOptions()
      $(".clickActive").trigger("focus");
      $('.offlinedownloadLangdoc').removeClass('clickActive')
    }
    if ($(document.activeElement).is('li:first-child a')) {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        showHistoryDownloadOptions()
        $(".clickActive").trigger("focus");
        $('.offlinedownloadLangdoc').removeClass('clickActive')
      }
  }
  if ($(document.activeElement).is('li:last-child a')) {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        showHistoryDownloadOptions()
        $(".clickActive").trigger("focus");
        $('.offlinedownloadLangdoc').removeClass('clickActive')
      }
  }
  }
  const showSyncErrorAction = (id) => {
    syncErrorAction ? toggleSyncErrorAction("") : toggleSyncErrorAction(id);
    $('.SyncError-expandLabel .gb-dropBtn').attr('aria-expanded', function(index, attr){
      return attr === 'true' ? 'false': 'true';
    });
  };
  $(document).on("click",".SyncError-expandLabel .gb-dropBtn",function() {
    $(this).addClass('clickActive')
  });
  const syncErrorEscFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      showSyncErrorAction()
      $(".clickActive").trigger("focus");
      $('.SyncError-expandLabel .gb-dropBtn').removeClass('clickActive')
    }
    if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
      setTimeout(() => {
        $(".clickActive").trigger("focus");
        $('.SyncError-expandLabel .gb-dropBtn').removeClass('clickActive')
      });
      showSyncErrorAction()
    }
    
  }
  const syncErrorModalFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      showSyncErrorAction()
      $(".clickActive").trigger("focus");
      $('.SyncError-expandLabel .gb-dropBtn').removeClass('clickActive')
    }
    if ($(document.activeElement).is('li:first-child button')) {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        showSyncErrorAction()
        $(".clickActive").trigger("focus");
        $('.SyncError-expandLabel .gb-dropBtn').removeClass('clickActive')
      }
  }
  if ($(document.activeElement).is('li:last-child button')) {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        showSyncErrorAction()
        $(".clickActive").trigger("focus");
        $('.SyncError-expandLabel .gb-dropBtn').removeClass('clickActive')
      }
  }
  }
  const showAction = (phase_id) => {
    phaseId === phase_id ? setPhaseId("") : setPhaseId(phase_id);
    $('.add-expandLabel .gb-dropBtn').attr('aria-expanded', function(index, attr){
      return attr === 'true' ? 'false': 'true';
    });
  };
  $(document).on("click",".add-expandLabel .gb-dropBtn",function() {
    $(this).addClass('clickActive')
  });
  const actionEscFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      showAction()
      $(".clickActive").trigger("focus");
      $('.add-expandLabel .gb-dropBtn').removeClass('clickActive')
    }
    if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
      setTimeout(() => {
        $(".clickActive").trigger("focus");
        $('.add-expandLabel .gb-dropBtn').removeClass('clickActive')
      });
      showAction()
    }
    
  }
  const actionModalFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      showAction()
      $(".clickActive").trigger("focus");
      $('.add-expandLabel .gb-dropBtn').removeClass('clickActive')
    }
    if ($(document.activeElement).is('li:first-child a')) {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        showAction()
        $(".clickActive").trigger("focus");
        $('.add-expandLabel .gb-dropBtn').removeClass('clickActive')
      }
  }
  if ($(document.activeElement).is('li:last-child a')) {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        showAction()
        $(".clickActive").trigger("focus");
        $('.add-expandLabel .gb-dropBtn').removeClass('clickActive')
      }
  }
  }
  
  const confirmApproval = (e) => {
    setConfirmed(e.target.checked);
  };
  const retryMultipleSyncError = () => {
    showSyncErrorRetry(true);
    showModel();
  };
  const confirmSyncErrorActions = (type, syncError, id) => {
    if (type === "retry") {
      setTimeout(() => {
        $("#deleteNo").trigger("focus");
        $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Asset Sync Error" } );
      }, 500);
      var msg = `Retry asset sync for asset ${syncError.asset.name}?`;
      confirmAlert({
        title: "Asset Sync Error",
        message: <p>{`${msg}`}</p>,
        buttons: [
          {
            label: "Yes",
            id: "deleteYes",
            onClick: () =>
              postAxiosResponse(APIUrls.RETRY_ASSET_SYNC(projectId, langCode), [
                id,
              ]).then((res) => {
                prop.refresh("overView");
              }),
              onKeyDown: (e) => {
                if (e.key === "Tab") {
                  if (e.shiftKey === true) {
                    e.preventDefault();
                    $("#deleteNo").trigger("focus");
                  }
                }
              },
          },
          {
            label: "No",
            id: "deleteNo",
            onClick: () => {
              showSyncErrorAction();
              $('.SyncError-expandLabel .gb-dropBtn').trigger('focus');
            },
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === false) {
                  e.preventDefault();
                  $("#deleteYes").trigger("focus");
                }
              }
              if (e.key === Constants.ESCAPE) {
                showSyncErrorAction();
                $('.SyncError-expandLabel .gb-dropBtn').trigger('focus');
              }
            },
          },
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        overlayClassName: "delete_overlay",
      });
    }
    if (type === "cancel") {
      setTimeout(() => {
        $("#deleteNo").trigger("focus");
        $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Cancel asset translation" } );
      }, 500);
      var msg = `Cancel translation of asset ${syncError.asset.name}?`;
      confirmAlert({
        title: "Cancel asset translation",
        message: <p>{`${msg}`}</p>,
        buttons: [
          {
            label: "Yes",
            id: "deleteYes",
            onClick: () =>
              postAxiosResponse(
                APIUrls.CANCEL_TARGET_PROJECT_ASSET(projectId, id)
              ).then((res) => {
                prop.refresh("overView");
              }),
              onKeyDown: (e) => {
                if (e.key === "Tab") {
                  if (e.shiftKey === true) {
                    e.preventDefault();
                    $("#deleteNo").trigger("focus");
                  }
                }
              },
          },
          {
            label: "No",
            id: "deleteNo",
            onClick: () => {
              showSyncErrorAction();
              $('.SyncError-expandLabel .gb-dropBtn').trigger('focus');
            },
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === false) {
                  e.preventDefault();
                  $("#deleteYes").trigger("focus");
                }
              }
              if (e.key === Constants.ESCAPE) {
                showSyncErrorAction();
                $('.SyncError-expandLabel .gb-dropBtn').trigger('focus');
              }
            },
          },
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        overlayClassName: "delete_overlay",
      });
    }
    if (type === "request-revision") {
      setTimeout(() => {
        $("#deleteNo").trigger("focus");
        $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Revision request" } );
      }, 500);

      var payloadData = projectResource.syncErrors.filter((error) => {
        return error.asset.id === syncError.asset.id;
      });
      var payload = {}
      if(payloadData.length > 0){
        payload = transformBlankToNull(payloadData[0]);
      }else{
        payload = transformBlankToNull(syncError);
      }
      
      payload.lpa = null;
      payload.iconClass = "icon-text-file";
      payload.asset.assetType = {
        typeString: "Uncategorized",
        compType: "Uncategorized",
        code: "UNCATEGORIZED",
      };
      var msg = `Send asset ${syncError.asset.name} back to the translator to revise ? `;
      confirmAlert({
        title: "Revision request",
        message: <p>{`${msg}`}</p>,
        buttons: [
          {
            label: "Yes",
            id: "deleteYes",
            onClick: () =>
              putAxiosResponse(
                APIUrls.REQUEST_REVISION_SYNC_ERROR(projectId, id),
                payload
              ).then((res) => {
                prop.refresh("overView");
              }),
              onKeyDown: (e) => {
                if (e.key === "Tab") {
                  if (e.shiftKey === true) {
                    e.preventDefault();
                    $("#deleteNo").trigger("focus");
                  }
                }
              },
          },
          {
            label: "No",
            id: "deleteNo",
            onClick: () => {
              showSyncErrorAction();
              $('.SyncError-expandLabel .gb-dropBtn').trigger('focus');
            },
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === false) {
                  e.preventDefault();
                  $("#deleteYes").trigger("focus");
                }
              }
              if (e.key === Constants.ESCAPE) {
                showSyncErrorAction();
                $('.SyncError-expandLabel .gb-dropBtn').trigger('focus');
              }
            },
          },
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        overlayClassName: "delete_overlay",
      });
    }
    if (type === "reopen-language") {
      setTimeout(() => {
        $("#deleteNo").trigger("focus");
        $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':`Reopen language: ${languageSelected[0].display}` } );
      }, 500);
      var languageSelected =
        prop.projectDetail.displayName[0].targetLanguages.filter((language) => {
          return language.code === langCode;
        });
      var msg = `By reopening ${languageSelected[0].display}:
      It will not be considered as approved anymore
      A new review task will be created and assigned to the original reviewer
      Notifications will be sent to the appropriate people`;
      confirmAlert({
        title: `Reopen language: ${languageSelected[0].display}`,
        message: <p>{`${msg}`}</p>,
        buttons: [
          {
            label: "Yes",
            id: "deleteYes",
            onClick: () => reopenWorkflow(),
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === true) {
                  e.preventDefault();
                  $("#deleteNo").trigger("focus");
                }
              }
            },
          },
          {
            label: "No",
            id: "deleteNo",
            onClick: () => {
              $('.assignsilo button').trigger('focus');
           },
           onKeyDown: (e) => {
            if (e.key === "Tab") {
              if (e.shiftKey === false) {
                e.preventDefault();
                $("#deleteYes").trigger("focus");
              }
            }
            if (e.key === Constants.ESCAPE) {
              $('.assignsilo button').trigger('focus');
            }
          },
          },
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        overlayClassName: "delete_overlay",
      });
    }
  };
  const cancelApproveAsset = () => {
    hideModel();
    setSelectedApproveAssets([]);
    setShowAssetApproval(false);
  };
  const cancelMoveBackAsset = () => {
    hideModel();
    setSelectedMoveBackAssets([]);
    setShowAssetBack(false);
  };
  const cancelRetryAsset = () => {
    hideModel();
    setSelectedRetryAssets([]);
    showSyncErrorRetry(false);
  };
  $(document).on("click",".approveClick",function() {
    setTimeout(() => {
    $(this).addClass('focusAdd');
   
      $(".approveFirstFocus").trigger("focus");
     
      $(".approveSelectAll").on("keydown", function (e) {
        if (e.key === Constants.TAB && e.shiftKey) {
          e.preventDefault();
          if($('.disabled.approveSecondFocus').prop('disabled')){
            $(".approveFirstFocus").trigger("focus");
          }
          else{
            $(".approveSecondFocus").trigger("focus");
          }
      }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideApproveTranslatedDeliverableModel();
          $('.focusAdd').trigger('focus');
          $('.approveClick').removeClass('focusAdd');
        }
      });
    })
  });
  const handleKeyApproveTranslateflow = (event) => {
    if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        $(".approveSelectAll").trigger("focus");
    }
  };
  const handleKeyApproveTranslateflow2 = (e) => {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === false) {
         e.preventDefault();
         if($('.disabled.approveSecondFocus').prop('disabled')){
           $(".approveSelectAll").trigger("focus");
         }
         else{
          $(".approveSecondFocus").trigger("focus");
         }
        }
     }
   
  };
  $(document).on("click",".modal-footer .approveFirstFocus",function() {
   $('.focusAdd').trigger('focus');
   $('.approveClick').removeClass('focusAdd');
 });
  const hideApproveTranslatedDeliverableModel = () =>{
    setPopUpValue('')
    hideModel()
  }
  const isTranslator = () => {
    return (
      options.roleSet?.vendorType ||
      projectResource.projectVendorType === "INTERNAL"
    );
  };
  const isCurrentUser = (step, phaseIndex) => {
    var selectedPhase = step.phases.filter((phase) => {
      return phase.id === phaseIndex;
    });
    var selectedPhaseAssigneeUserIds = [];
    if (selectedPhase.length > 0) {
      selectedPhase[0].assigneeUsers.map((users) => {
        selectedPhaseAssigneeUserIds.push(users.userId);
      });
    }
    var assigneUserSameAsLoginUser = false;
    if (selectedPhaseAssigneeUserIds.includes(options?.user?.userId)) {
      assigneUserSameAsLoginUser = true;
    }
    if (options.user !== undefined) {
      if (
        assigneUserSameAsLoginUser ||
        options.user.roleSet.value === "ROLE_VENDOR_SYSTEM" ||
        options.user.roleSet.value === "ROLE_VENDOR" ||
        options.user.roleSet.value === "ROLE_CUSTOMER" ||
        options.user.roleSet.value === "ROLE_CUSTOMER_PROJECT_MANAGER" ||
        options.user.roleSet.value === "ROLE_CUSTOMER_SYSTEM"
      ) {
        return true;
      } else {
        return false;
      }
    }
  };
  var template = [];

  function showModel() {
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $('.modelPopup .close').trigger('focus');
    }, 300);
  }

  function closeModel() {
    jQuery("body").removeClass("modal-open");
  }

  const showRequestTranslationAgainModel = () => {
    $(document.activeElement).addClass('focusAdd');
    document.body.classList.add("modal-open-7");
  };
  const closeCalendar = (e) => {
    if (e.code === Constants.ESCAPE) {
      setCalPhaseId("")
      if ($('.calFirstFocus').length) {
        toggleCal(false);
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
      } else if ($('.calSecondFocus').length) {
        toggleReferenceRequestCal(false);
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
      }
    }
  };
  const showAlertModel = () => {
    if (alertModel) {
      toggleAlertModel(false);
      hideModel();
    } else {
      toggleAlertModel(true);
      showModel();
    }
  };

  const showRequestTranslationAgainAlertModel = () => {
    if(projectStatus.code === "vendor_rejected"){
      if (showRequestTranslationVendor) {
        setShowRequestTranslationVendor(false);
        hideRequestTranslationAgainModel();
      } else {
        setShowRequestTranslationVendor(true);
        showRequestTranslationAgainModel();
        setTimeout(() => {
          $('.close').trigger('focus');
        }, 300);
      }
    }
    else{
      if (showRequestTranslationAgain) {
        setShowRequestTranslationAgain(false);
        hideRequestTranslationAgainModel();
      } else {
        setShowRequestTranslationAgain(true);
        showRequestTranslationAgainModel();
      }
    }
  };
  const multipleAssignee = (phaseId) => {
    var status = phaseAssigneeUsers.filter((phase) => {
      return phase.phaseId == phaseId;
    });
    return status[0]?.allowMultiAssignee;
  };
  const hideModel = () => {
    document.body.classList.remove("modal-open");
  };
  const hideRequestTranslationAgainModel = () => {
    document.body.classList.remove("modal-open-7");
  };
  const showCancelTranslation = (phase) => {
    showModel();
    setCancelationAssets(phase.work.current);
    setTimeout(() => {
      $(".cancelBtnFocus").trigger("focus");
      $(".AssetTranslationCheckall").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
            e.preventDefault();
            $("#acceptAssetForPhase").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideCancelAsset();
          $('.focusAdd').trigger('focus');
          $('.cancelTranslation').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const handleKeyEditflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $(".AssetTranslationCheckall").trigger("focus");
      }
    }
  };
  $(document).on("click",".cancelTranslation",function() {
    $(this).addClass('focusAdd');
  });
  $(document).on("click",".modal-footer .cancelBtnFocus",function() {
   $('.focusAdd').trigger('focus');
   $('.cancelTranslation').removeClass('focusAdd');
 });
  const selectCancelAsset = (e, asset) => {
    if (e.target.value === "all") {
      setSelectedCancelAssets(asset);
    } else if (e.target.value === "remove") {
      setSelectedCancelAssets([]);
    } else {
      if (e.target.checked) {
        setSelectedCancelAssets((current) => [...current, asset]);
      } else {
        var removeSelected = selectedCancelAssets.filter((assets) => {
          return assets.id !== asset.id;
        });
        setSelectedCancelAssets(removeSelected);
      }
    }
  };
  const cancelAssetSelected = (asset) => {
    var hasItem = [];
    hasItem = selectedCancelAssets.filter((e) => {
      return e.id === asset.id;
    });
    if (hasItem.length > 0) {
      return true;
    } else {
      return false;
    }
  };
  const cancelAssetForPhase = () => {
    if (selectedCancelAssets.length > 0) {
      var assetIds = [];
      var phaseId = selectedCancelAssets[0].currentPhaseId;
      selectedCancelAssets.map((assets) => {
        assetIds.push(assets.id);
      });
      var payload = { values: assetIds };
      hideCancelAsset();
      postAxiosResponse(
        APIUrls.CANCEL_ASSET_TRANSLATION_FOR_PHASE(
          projectId,
          langCode,
          phaseId
        ),
        payload
      ).then((res) => {
        fetchLanguageDetail(langCode);
      });
    }
  };
  const hideCancelAsset = () => {
    setCancelationAssets([])
    setSelectedCancelAssets([]);
    hideModel();
  };
  
  const selectApproveAsset = (e, asset) => {
    if (e.target.value === "all") {
      setSelectedApproveAssets(asset);
    } else if (e.target.value === "remove") {
      setSelectedApproveAssets([]);
    } else {
      if (e.target.checked) {
        setSelectedApproveAssets((current) => [...current, asset]);
      } else {
        var removeSelected = selectedApproveAssets.filter((assets) => {
          return assets.id !== asset.id;
        });
        setSelectedApproveAssets(removeSelected);
      }
    }
  };
  const selectMoveBackAsset = (e, asset) => {
    if (e.target.value === "all") {
      setSelectedMoveBackAssets(asset);
    } else if (e.target.value === "remove") {
      setSelectedMoveBackAssets([]);
    } else {
      if (e.target.checked) {
        setSelectedMoveBackAssets((current) => [...current, asset]);
      } else {
        var removeSelected = selectedMoveBackAssets.filter((assets) => {
          return assets.id !== asset.id;
        });
        setSelectedMoveBackAssets(removeSelected);
      }
    }
  };
  const assetSelected = (asset) => {
    var hasItem = [];
    hasItem = selectedApproveAssets.filter((e) => {
      return e.id === asset.id;
    });
    if (hasItem.length > 0) {
      return true;
    } else {
      return false;
    }
  };
  
  const selectRetryAsset = (e, assetId) => {
    if (e.target.value === "all") {
      var allIds = [];
      allIds.push(
        Object.keys(syncErrors).map((obj, key) => {
          return obj;
        })
      );
      setSelectedRetryAssets(allIds[0]);
    } else if (e.target.value === "remove") {
      setSelectedRetryAssets([]);
    } else {
      if (e.target.checked) {
        setSelectedRetryAssets((current) => [...current, assetId]);
      } else {
        var removeSelected = selectedRetryAssets.filter((assets) => {
          return assets !== assetId;
        });
        setSelectedRetryAssets(removeSelected);
      }
    }
  };
  const approveCurrentAssets = () => {
    if (selectedApproveAssets.length > 0) {
      var assetIds = [];
      var phaseId = selectedApproveAssets[0].currentPhaseId;
      selectedApproveAssets.map((assets) => {
        assetIds.push(assets.id);
      });
      var payload = { values: assetIds };
      var apiUrl = ''
      hideModel();
      setShowAssetApproval(false);
      if(approveAssetPhaseIsMultiAssignee){
        apiUrl = APIUrls.CLOSE_REVIEW_EARLY_ASSET_FOR_PHASE
      }else{
        apiUrl = APIUrls.BULK_APPROVE_ASSET_FOR_PHASE
      }
      postAxiosResponse(
        apiUrl(projectId, langCode, phaseId),
        payload
      ).then((res) => {
        if(res.data.handledMessage){
          setSelectedApproveAssets([]);
          setAssetApproveErrorMsg(res.data.handledMessage)
          setTimeout(()=>{
            setAssetApproveErrorMsg('')
          },15000)
        }else{
          hideModel();
          setSelectedApproveAssets([]);
          fetchLanguageDetail(langCode);
        }
      });
    }
  };
  const moveBackCurrentAssets = () => {
    var currentPhaseId = selectedMoveBackAssets[0].currentPhaseId;
    var indexMatch = "";
    phaseDetail.map((phase, index) => {
      if (phase.phaseId === currentPhaseId) {
        indexMatch = index - 1;
        return index;
      }
    });

    var previousPhaseId = phaseDetail[indexMatch].phaseId;
    if (selectedMoveBackAssets.length > 0) {
      var assetIds = [];
      var phaseId = selectedMoveBackAssets[0].currentPhaseId;
      selectedMoveBackAssets.map((assets) => {
        assetIds.push(assets.id);
      });
      var payload = { values: assetIds };
      
      hideModel();
      cancelMoveBackAsset()
      setShowAssetApproval(false);
      postAxiosResponse(
        APIUrls.MOVE_ASSET_BACK(projectId, langCode, phaseId, previousPhaseId),
        payload
      ).then((res) => {
        setSelectedMoveBackAssets([]);
        fetchLanguageDetail(langCode);
        cancelMoveBackAsset()
       });
    }
  };
  const approveRetryAssets = () => {
    postAxiosResponse(
      APIUrls.RETRY_ASSET_SYNC(projectId, langCode),
      selectedRetryAssets
    ).then((res) => {
      prop.refresh("overView");
    });
  };
  const showDueDateCal = (phase) => {
    calPhaseId ? setCalPhaseId("") : setCalPhaseId(phase);
    $('#calFirstFocus').attr('aria-expanded', function(index, attr){
      return attr === 'true' ? 'false': 'true';
    });
    $('#calFirstFocus').toggleClass('calFirstFocus')
    $('.calFirstFocus').trigger('focus')
  };
  $("#calFirstFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE && e.target.ariaExpanded === 'true') {
      if($('div').hasClass('dashCalendarDeadLine')){
        showDueDateCal()
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
       }
     }
     if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendarDeadLine')){
        setCalPhaseId("")
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
       }
     }
    });
  const setReviewPhaseDueDate = (e, phase) => {
    var datetime = new Date(e);
    var payload = { id: phase.phaseId, dueDate: dateUtil.convertAndFormatForSubmitOld(datetime) };
    setCalPhaseId("");
    $('.calFirstFocus').trigger('focus')
    $('#calFirstFocus').removeClass('calFirstFocus')
    putAxiosResponse(APIUrls.UPDATE_PHASE_DETAIL(phase.phaseId), payload).then(
      (res) => {
        fetchLanguageDetail(langCode);
       }
      
    );
  };
  useEffect(()=>{
    $.each($('.react-calendar__tile'), function( index, value ) {
      if(viewType === 'month' || viewType === 'year'){
        $(value).attr('aria-label', value.children[0].ariaLabel);
      }
    });
  });

  const removeAssignee = (removalUser, phaseId) => {
    var copyPhaseAssignee = structuredClone(phaseAssigneeUsers);
    var selectedPhase = copyPhaseAssignee.filter((phaseAssignee) => {
      return phaseAssignee.phaseId === phaseId;
    });
    var filteredUsers = selectedPhase[0].users.filter((user) => {
      return user.userId !== removalUser.userId;
    });
    selectedPhase[0].users = filteredUsers;
    copyPhaseAssignee.map((phaseUsers, index) => {
      if (phaseUsers.phaseId === selectedPhase[0].phaseId) {
        copyPhaseAssignee[index] = selectedPhase[0];
      }
    });
    setAssigneeUsers(copyPhaseAssignee);
  };
  const selectedAssignees = (user, phaseId) => {
    var value = user.userId
    var copyPhaseAssignee = structuredClone(phaseAssigneeUsers);
    if(assignees && assignees?.findIndex(data=>data.userId === user.userId) === -1){
      assignees.unshift(user)
    }else{
      setAssignees(
        assignees.filter((assignee) => {
          return assignee.userId !== Number(value);
        })
      );
    }
    assignees.map((assignee) => {
      if (assignee.userId == Number(value)) {
        copyPhaseAssignee.map((phase, index) => {
          if (phase.phaseId === phaseId) {
            copyPhaseAssignee[index].users.push(assignee);
          }
        });
      }
    });
    setAssigneeUsers(copyPhaseAssignee);
    setAssigneeId((current) => [...current, value]);
    let data=assignees.filter((assignee) => {
      return assignee.userId !== Number(value);
    })
  };
  const selectAssignee = (phase) => {
    var selectedUser = [];
    var userType="single";
    var payload = {};
    var phaseId = "";
    if (phase.phaseId) {
      phaseId = phase.phaseId;
    } else if (phase.id) {
      phaseId = phase.id;
    }
    if(phase.allowMultiAssignee){
      var payloadUsers = []
      var selectedPhaseUsers = phaseAssigneeUsers.filter((userPhase)=>{
        return userPhase.phaseId === phaseId
      })[0].users
      if(selectedPhaseUsers.length === 0){
        return
      }else{
        payloadUsers = constAssignees.filter(y => selectedPhaseUsers.some(x => x.userId === y.userId))
      }
      payload = { id: phaseId, assigneeUsers: transformBlankToNull(payloadUsers) };
      userType="multiple"
    }else{
          selectedUser = constAssignees.filter((assignee) => {
            return assignee.userId === Number(assigneeId);
          });
          setSelectedAssigneeUsers(selectedUser);
          var assigneeUser = transformBlankToNull(selectedUser[0]);
          payload = { id: phaseId, assigneeUsers: [assigneeUser] };
    }
     
    putAxiosResponse(APIUrls.UPDATE_PHASE_DETAIL(phaseId), payload).then(
      (res) => {
        setShowReviewers("");
        fetchLanguageDetail(langCode, "force");
        if(userType==="single"){
          save(payload?.assigneeUsers[0])
        }
     }
    );
  };
  
  const downloadResource = (fileName, docId) => {
    downloadFile(
      APIUrls.DOWNLOAD_REFERENCE_FILE_CONTENT(param.id, docId),
      fileName
    );
  };

  const requestRevisionPossible = () => {
    var status =
      !prop.projectDetail.resource.projectResource.vendor
        .machineTranslationVendor &&
      !prop.projectDetail.resource.projectResource.useAssetWorkflow;
    return status;
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";
    const k = 1024;
    let dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };

  const bulkApprove = (phaseId, lastPhaseData, phaseCurrent, e,multiAssignee) => {
    setApproveAssetPhaseIsMultiAssignee(multiAssignee)
    setShowAssetApproval(true);
    showAction("");
    showModel();
    setAssetsForApproval(lastPhaseData);
    e.preventDefault();
    var assetIds = [];
    lastPhaseData.map((phaseData) => {
      assetIds.push(phaseData.id);
    });
    setTimeout(() => {
      $(".cancelApproveAsset").trigger("focus");
      $(".approveAssetsCheckall").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
            e.preventDefault();
            $("#approveCurrentAssets").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          cancelApproveAsset();
          $('.focusAdd').trigger('focus');
          $('.add-expandLabel .gb-dropBtn').removeClass('focusAdd');
        }
      });
    }, 500);

  };
  const handleKeyapproveflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $(".approveAssetsCheckall").trigger("focus");
      }
    }
  };
  $(document).on("click",".approveAction",function() {
    $(this).parents('.add-expandLabel').find('.gb-dropBtn').addClass('focusAdd');
  });
  $(document).on("click",".modal-footer .cancelApproveAsset",function() {
   $('.focusAdd').trigger('focus');
   $('.add-expandLabel .gb-dropBtn').removeClass('focusAdd');
 });
  const moveAssetBack = (phaseId, lastPhaseData, phaseCurrent, e) => {
    showModel();
    let assetToMoveBack = lastPhaseData.filter(asset=>!asset.lockedForPostEditing)
    setAssetToMoveBack(assetToMoveBack);
    setShowAssetBack(true);
    setTimeout(() => {
      $(".cancelMoveAsset").trigger("focus");
      $(".moveAssetsCheckall").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
            e.preventDefault();
            $("#moveCurrentAssets").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          cancelMoveBackAsset();
         $('.focusAdd').trigger('focus');
          $('.add-expandLabel .gb-dropBtn').removeClass('focusAdd');
        }
      });
    }, 200);
    
  };
  const handleKeyMoveflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $(".moveAssetsCheckall").trigger("focus");
      }
    }
  };
  $(document).on("click",".moveAssetBack",function() {
    showAction()
    setTimeout(() => {
      $(this).parents('.add-expandLabel').find('.gb-dropBtn').addClass('focusAdd');
    }, 500);
  });
  $(document).on("click",".modal-footer .cancelMoveAsset",function() {
   $('.focusAdd').trigger('focus');
   $('.add-expandLabel .gb-dropBtn').removeClass('focusAdd');
 });
  const uploadTranslation = (phaseId, currRevisionOrReviewData, status) => {
    if (currRevisionOrReviewData !== null) {
      status === "IN_REVIEW"
        ? setCurrentRevisionOrReviewData({ current: currRevisionOrReviewData })
        : status === "IN_REVISION_OFFLINE"
        ? setCurrentRevisionOrReviewData({
            current: [currRevisionOrReviewData],
          })
        : setCurrentRevisionOrReviewData(currRevisionOrReviewData);
    }
    setUploadAssetPhaseId(phaseId);
    showModel();
    uploadRevisePopup
      ? setUploadRevisePopup(false)
      : setUploadRevisePopup(true);
    setPhaseId("");

    
    setTimeout(() => {
      $(".clickPoupIcon").trigger("focus");
      $(".clickPoupIcon").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
            e.preventDefault();
            $(".input-file input").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          cancelMoveBackAsset();
         $('.focusAdd').trigger('focus');
          $('.add-expandLabel .gb-dropBtn').removeClass('focusAdd');
        }
      });
    });
  };
  $(document).on("click",".uploadRevised",function() {
    showAction()
    setTimeout(() => {
      $(this).parents('.add-expandLabel').find('.gb-dropBtn').addClass('focusAdd');
    }, 500);
  });
  $(document).on("click",".clickPoupIcon",function() {
   $('.focusAdd').trigger('focus');
   $('.add-expandLabel .gb-dropBtn').removeClass('focusAdd');
 });
 $(".input-file input").on("keydown", function (e) {
  if (e.key === Constants.TAB) {
    if (e.shiftKey === false && $(".clickPoupIcon").length) {
      e.preventDefault();
      $(".clickPoupIcon").trigger("focus");
    }
  }
});

  const approveLanguagesKeydown = (event, langs) => {
    if (event.keyCode === 32) {
      approveLanguages(event, langs);
    }
  }
 
  const approveLanguages = (e, langs) => {
    var data = [];
    if (e.target.value === "all") {
      languageToReview.map((del) => {
        if (del.resource.languageStatus !== "APPROVED") {
          data.push({
            approved: true,
            targetLanguage: del.displayName[0],
            projectWorkflowPhaseId: del.resource.pendingPhase.id,
          });
        }
      });
      setApprovedLangs(data);
    } else if (e.target.value === "remove") {
      setApprovedLangs([]);
    } else {
      var payload = {
        approved: true,
        targetLanguage: langs.displayName[0],
        projectWorkflowPhaseId: langs.resource.pendingPhase.id,
      };
      if (
        approvedLangs.some(
          (target) => target.targetLanguage.name === langs.displayName[0].name
        )
      ) {
        setApprovedLangs((current) =>
          current.filter(
            (lang) => lang.targetLanguage.name !== langs.displayName[0].name
          )
        );
      } else {
        setApprovedLangs((current) => [...current, payload]);
      }
    }
  };
  
  const approveTranslation = () => {
    var payload = approvedLangs;
    approvedLangs.map((langs, index) => {
      payload[index].targetLanguage = langs.targetLanguage.name;
    });
    postAxiosResponse(
      APIUrls.APPROVE_DELIVERABLE(param.id),
      approvedLangs
    ).then((res) => {
      hideModel();
      prop.refresh();
    });
  };

  const closeUploadTranslation = () => {
    setUploadRevisePopup(false);
    hideModel();
  };
  const redirectToChat = () => {
    prop.funct("discussions");
  };
  const goToTab = (type) =>{
    if(type === 'chat'){
      prop.funct('createNewDiscussion')
    }else {
      prop.funct(type)
    }
  }
  const downloadTranslation = (fileName) => {
    downloadFile(
      APIUrls.DOWNLOAD_LATEST_MASTER_DELIVERABLE_DOCUMENT_FILE(param.id),
      fileName
    );
  };

  const downloadLangaugeTranslationLink = () => {
    return downloadLink(APIUrls.DOWNLOAD_LATEST_LANGUAGE_DELIVERABLE_DOCUMENT_FILE(
        param.id,
        langCode
    ));
  }

  const downloadTm = (fileName) => {
    downloadFile(APIUrls.DOWNLOAD_TM(param.id), fileName);
  };

  const downloadBilinguals = (fileName) => {
    setDownloadStart(true);
    downloadFile(
      APIUrls.GET_BILINGUALS_FOR_OFFLINE_REVIEW(param.id, langCode),
      fileName
    )
      .then(() => {
        setDownloadStart(false);
      })
      .catch((error) => {
        if (error.code === "ERR_BAD_RESPONSE") {
          setDownloadStart(false);
          setBillingualDownloadError(
            "File type not supported for Offline review."
          );
        }
      });
  };
  const fetchLanguageDetail = (languageCode, reload) => {
    setSkipPostEditing(false);
    setUplodResponseError(null)
    setSelectedPhaseFile([])
      var element = document.getElementById(`${languageCode}`)
      if(element){
        element.scrollIntoView();
      }
    setBillingualDownloadError("");
    if (matchCustomCode(langCode,languageCode) && reload === "") {
      toggleShowDetail(false);
      setLanguageCode("");
      setSelectedLanguageDisplayName("");
      $(".activity-feed-outer").css("max-height", '780px');
      return;
    }
    setShowLangLoader(true);
    
    toggleShowDetail(false);
    var selectedLanguage =
      prop.projectDetail.displayName[0].targetLanguages.filter((langs) => {
        return langs.code === languageCode;
      });
    setLanguageCode(languageCode);
    setSelectedLanguageDisplayName(selectedLanguage[0]?.display);
    var assigneeUserPhaseId = [];
    getAxiosResponse(APIUrls.LANGUAGE_STATUS(param.id, languageCode)).then(
      (res) => {
        if (res.data !== "" && res.data.data !== '') {
          setLanguageDetail(res.data.data);
          const currentPhaseId = res.data.data.currentPhaseId;
          const currentStepId = res.data.data.currentStepId;
          const currentStep = res.data.data.steps.find(step => step.id === currentStepId);
          const currentPhase = currentStep ? currentStep.phases.find(phase => phase.id === currentPhaseId) : undefined;
          setcurrentPhase(currentPhase);
          res.data?.data?.steps.map((step, index) => {
            step.phases.map((phase, phaseIndex) => {
              if (phase.assigneeType.code === "vendor") {
                assigneeUserPhaseId.push({
                  phaseId: phase.id,
                  allowMultiAssignee: phase?.allowMultiAssignee,
                  users: phase.assigneeVendor.name,
                  assigneeType: phase.assigneeType.code,
                });
              } else {
                assigneeUserPhaseId.push({
                  phaseId: phase.id,
                  allowMultiAssignee: phase?.allowMultiAssignee,
                  users: phase.assigneeUsers,
                  assigneeType: phase.assigneeType.code,
                });
              }
            });
          });
          setExpandAll(false);
          setShowPhaseFileProgress('');
          setConstPhaseAssignee(assigneeUserPhaseId)
          setAssigneeUsers(assigneeUserPhaseId);
          toggleShowDetail(true);
          setShowLangLoader(false);
          setTimeout(()=>{
          $(".activity-feed-outer").css("max-height", '100%');
          },3500)
          
        }
      }
    ).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.LANGUAGE_ASIGNEE_(param.id, languageCode)).then(
      (res) => {
        setPhaseAssignee(res.data.data);
      }
    ).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(
      APIUrls.ALL_TASKS +
        `?pId=${param.id}&onlyFollowed=false&langs=${languageCode}`
    )
      .then((res) => {
        if (res.data !== "") {
          setLanguageTasks(res.data.data?.result);
        } else {
          setLanguageTasks([]);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(
      APIUrls.GET_LATEST_PROJECT_SOURCE_FILE(param.id, languageCode)
    )
      .then((res) => {
        if (res.data !== "") {
          setLatestProjectSourceFiles(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(
      APIUrls.PROJECT_LANGUAGE_WORKFOLW_COMPOSED_DATA(param.id, languageCode)
    ).then((res) => {
      setShowSteps(false);
      if (res.data !== "") {        
        setPhaseDetail(res.data.data);
        var count = [];
        res.data.data?.map((phase, phaseIndex) => {
          if (phase.phaseType.originalEnum === "WORK") {
            if (phase.work.current.length > 0) {
              count.push(phase.stepNumber);
            } else if (phase.work.complete.length > 0) {
              count.push(phase.stepNumber);
            }
            if (phase.revision.current.length > 0) {
              count.push(phase.stepNumber);
            }
            if (
              Object.keys(phase.revision.complete).length !== 0 &&
              phase.revision.complete[1] !== null
            ) {
              let key = Object.keys(phase.revision.complete)[0];

              Object.keys(phase.revision.complete).map((round, roundNum) => {
                count.push(phase.stepNumber);
              });
            }
          }
          else if (phase.phaseType.originalEnum === "REVIEW" || phase.phaseType.originalEnum === "POST_EDITING") {
            
            if(phase?.assigneeVendor?.name)
            {
             setVendorName(phase?.assigneeVendor?.name)
            }
            if (!phase.review.current.length) {
              Object.keys(phase?.review?.current).map((round, roundNum) => {
                count.push(phase.stepNumber);
              });
            }
            if (phase.review.complete.length > 0) {
              count.push(phase.stepNumber);
            }
            if (phase.approved?.length > 0) {
              count.push(phase.stepNumber);
            }                    
            if(phase.phaseType.originalEnum === "POST_EDITING" && phase.latestTasks?.REVIEW_PROJECT_ASSETS?.status?.originalEnum === "CLOSED" && phase.latestTasks?.REVIEW_PROJECT_ASSETS?.skipped){
                setSkipPostEditing(true);
            }
          }
        });
      }
      setShowSteps(count);
    }).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.REFERENCE_LIST(param.id)).then((res) => {
      if (res.data !== "") {
        setSourceReferenceData(res.data.data);
      }
    }).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.TARGET_ASSET_DATA(param.id, languageCode)).then(
      (res) => {
        setDownloadMenuItems([]);
        setOfflinePreviewBundle([])
        if (res.data.status === "success") {
          var mergedSyncErrors = [];
          var contextIds = [];
          res.data.data.map((logicalProjectAsset) => {
            contextIds.push(logicalProjectAsset.id);
            if (
              logicalProjectAsset.status &&
              logicalProjectAsset.status === "SYNC_FAILED" &&
              logicalProjectAsset.assets.length > 0
            ) {
              var asset = logicalProjectAsset.assets[0];
              mergedSyncErrors[logicalProjectAsset.id] = {
                asset: asset,
                syncErrorStatus: logicalProjectAsset.status,
                assetType: asset.assetType,
                errorType: "UNCATEGORIZED",
                language: logicalProjectAsset.assets[0].language,
                //lpa: logicalProjectAsset.toJSON(),
              };
            }
          });

          setSyncErrors(mergedSyncErrors);
          
          setContextId(contextIds);
          setTargetAssetData(res.data.data);
        }
      }
    ).catch(err=>{
      console.error(err)
    })
  };
  const getEntryUserAssigneeStatue = (phaseId,entryId) => {
    const loginUserId = options?.user?.userId
    var record = phaseAssignee.find((pa)=>{
      return ((pa.phase.id === phaseId && pa.asset.id === entryId && pa.user.userId === loginUserId))
    })
    return record ? record.status : 'NOT_ASSIGNEE'
  }
  
  useEffect(()=>{
    if(state !== null && state.langCode){
      setLanguageCode(state.langCode)
      fetchLanguageDetail(state.langCode);
    }
  },[state])

  useEffect(()=>{
    if(state!== null && languageDetail.length !== 0 && state.phaseId){
      createReviewLink(state.phaseId,state.entry,state.assetData,state.phase)
    }
  },[state,languageDetail])

  function handleDrop(e,assetId,sourceAssetId) {
    e.preventDefault();
    setUploadDisabled(false)
    if (e.dataTransfer && !uploadInProgress) {
      var indexId = Number(e.target.id)
      var copySelectedPhaseFile = structuredClone(selectedPhaseFile)
      setShowSelectedFile(current => [...current,e.target.id]);
      if(!checkFileAdded(indexId)){
        setSelectedPhaseFile(current => [...current,{id:indexId,assetId:assetId,sourceAssetId:sourceAssetId,file:e.dataTransfer.files[0]}]);
      }else{
        var indexToReplace = copySelectedPhaseFile.findIndex(obj => obj.id === indexId);
        copySelectedPhaseFile[indexToReplace] = {id:indexId,file:e.dataTransfer.files[0]}
        setSelectedPhaseFile(copySelectedPhaseFile)
      }
      // setSelectedFile(e.dataTransfer.files[0]);
    }
  }
  const handleDropMultiFile = (e,assets) =>{
    e.preventDefault();
    setUploadDisabled(false)
    var files = Array.from(e.dataTransfer.files);
    var filteredFile = files.filter((addedFile)=>{
        return assets.some(item => addedFile.name === getSourceFileData(item).fileName)
      })
    var copySelectedPhaseFile = structuredClone(selectedPhaseFile)
    if (e.dataTransfer && !uploadInProgress) {
      if(assets.length > 0){
        if(filteredFile.length === 0){
          setExpandAll(true)
        }else{
          assets.forEach((entry,assetIndex)=>{
            filteredFile.forEach((selectedfiles,fileIndex)=>{
              if(selectedfiles.name === getSourceFileData(entry).fileName){
                if(!checkFileAdded(assetIndex)){
                  setSelectedPhaseFile(current => [...current,{id:assetIndex,assetId:entry.id,sourceAssetId:entry.sourceProjectAssetId,file:selectedfiles}]);
                }else{
                  var indexToReplace = copySelectedPhaseFile.findIndex(obj => obj.id === assetIndex);
                  copySelectedPhaseFile[indexToReplace] = {id:assetIndex,file:e.dataTransfer.files[0]}
                  setSelectedPhaseFile(copySelectedPhaseFile)
                }
              }
            })
          })
        }
      }
    }
  }
  const phaseFileMultiSelection = (e,assets) =>{
    var files = Array.from(e.target.files);
    var filteredFile = files.filter((addedFile)=>{
      return assets.some(item => addedFile.name === getSourceFileData(item).fileName)
    })
    var copySelectedPhaseFile = structuredClone(selectedPhaseFile)
    if (files.length > 0 && !uploadInProgress) {
      if(assets.length > 0){
        if(filteredFile.length === 0){
          setExpandAll(true)
        }else{
          assets.forEach((entry,assetIndex)=>{
            filteredFile.forEach((selectedfiles,fileIndex)=>{
              if(selectedfiles.name === getSourceFileData(entry).fileName){
                if(!checkFileAdded(assetIndex)){
                  setSelectedPhaseFile(current => [...current,{id:assetIndex,assetId:entry.id,sourceAssetId:entry.sourceProjectAssetId,file:selectedfiles}]);
                }else{
                  var indexToReplace = copySelectedPhaseFile.findIndex(obj => obj.id === assetIndex);
                  copySelectedPhaseFile[indexToReplace] = {id:assetIndex,file:e.dataTransfer.files[0]}
                  setSelectedPhaseFile(copySelectedPhaseFile)
                }
              }
            })
          })
        }
      }
    }
  }
  const phaseFileSelection = (e,assetId,sourceAssetId) => {
    setUploadDisabled(false)
    setCurrentFileIndex(null)
    setIgnoreValidation(null);
    if (e.target) {
      var indexId = Number(e.target.id)
      var copySelectedPhaseFile = structuredClone(selectedPhaseFile)
      setShowSelectedFile(current => [...current,e.target.id]);

      if(!checkFileAdded(indexId)){
        setSelectedPhaseFile(current => [...current,{id:indexId,assetId:assetId,sourceAssetId:sourceAssetId,file:e.target.files[0]}]);
      }else{
        var indexToReplace = copySelectedPhaseFile.findIndex(obj => obj.id === indexId);
        copySelectedPhaseFile[indexToReplace] = {id:indexId,assetId:assetId,sourceAssetId:sourceAssetId,file:e.target.files[0]}
        setSelectedPhaseFile(copySelectedPhaseFile)
      }
      //setSelectedPhaseFile(e.target.files[0]);
    }
  };
  const checkFileAdded = (val) => {
     var matched = selectedPhaseFile.filter((files)=>{
      return files.id == val
    })
    return matched.length > 0
  }
  const uploadPhaseAsset = (fileIndex) => {
    setUploadInProgress(true)
    setUploadDisabled(true)
    const params = new URLSearchParams();
    params.set("name", "TRANSLATED_PART_ASSET");
    params.set("project.id", parseInt(param.id));
    params.set("docType", "TRANSLATED_PART_ASSET");

    postAxiosResponse(
      APIUrls.UPLOAD_ASSET_META(param.id) + "?" + params.toString()
    ).then((res) => {
      setDocumentVariant(res.data.documentFileId);
      if(fileIndex === ''){
        setCurrentFileIndex(0);
      }else{
        setCurrentFileIndex(fileIndex)
      }
    }).catch(err=>{
      console.error(err)
    })
  };

  useEffect(() => {
    if (currentFileIndex !== null) {
      setCurrentFileChunkIndex(0);
    }
  }, [currentFileIndex]);

  useEffect(() => {
    if (currentFileChunkIndex !== null && currentFileChunkIndex !== -1 && selectedPhaseFile.length !== 0) {
        setShowPhaseFileProgress(selectedPhaseFile[currentFileIndex].assetId);
        readAndUploadPhaseFileCurrentChunk();
    }
  }, [currentFileChunkIndex]);

  const readAndUploadPhaseFileCurrentChunk = () => {
    const file = selectedPhaseFile[currentFileIndex].file;
    if (file && documentVariant !== "") {
      const reader = new FileReader();
      const from = currentFileChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadPhaseFileChunk(e);
      reader.readAsDataURL(blob);
    } else {
      uploadChunk(null);
    }
  };

  const onIgnoreValidation = (e) => {
    let checked = e.target.checked;
    setIgnoreValidation(checked);
    setUploadDisabled(!checked);
  }

  const uploadPhaseFileChunk = (readerEvent) => {
    const file = selectedPhaseFile[currentFileIndex].file;
    var uploadPhaseAssetId = selectedPhaseFile[currentFileIndex].sourceAssetId
    const data = readerEvent ? readerEvent.target.result : {};
    const params = new URLSearchParams();
    params.set("name", file.name);
    setUploadingFileName(file.name)
    params.set("size", file.size);
    params.set("docFileId", documentVariant);
    params.set("currentChunkIndex", currentFileChunkIndex);
    params.set("totalChunks", Math.ceil(file.size / chunkSize));
    params.set("ignoreValidations", ignoreValidation === null ? false : ignoreValidation);
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    var urlPart =
      APIUrls.UPLOAD_ASSET_DATA(param.id, langCode, uploadPhaseAssetId) +
      `?${params.toString()}`;
    const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
    axios.post(url, data, { headers }).then((response) => {
      if (response.data !== "") {
        if (selectedPhaseFile !== "") {
          const filesize = selectedPhaseFile[currentFileIndex].file.size;
          const chunks = Math.ceil(filesize / chunkSize) - 1;
          const isLastChunk = currentFileChunkIndex === chunks;
          if (isLastChunk) {
            setCurrentFileChunkIndex(null);
            setPhaseFileUploadProgress(100);
            setIgnoreValidation(null);
            if(response.data && response.data.data && response.data.data.body && !response.data.data.body.success){
              setUplodResponseError({sourceProjectAssetId : uploadPhaseAssetId, message :response.data.data.body.detail})
              if(response.data.data.body.errorType === "xliff_structure_mismatch"){
                setIgnoreValidation(false);
              }
              setUploadInProgress(false)
              setShowPhaseFileProgress('')
              setCurrentChunkIndex(-1)
              setCurrentFileIndex(null)
              if(selectedPhaseFile.length > currentFileIndex+1){
                setPhaseFileUploadProgress(0);
              }
            }else{
            if(selectedPhaseFile.length > currentFileIndex+1){
              setPhaseFileUploadProgress(0);
              uploadPhaseAsset(currentFileIndex+1)
            }
            if(selectedPhaseFile.length === currentFileIndex+1){
                setSelectedPhaseFile([])
                setUploadInProgress(false)
              setTimeout(() => {
                setShowPhaseFileProgress('')
                 fetchLanguageDetail(langCode, "force");
              }, 1000);
            }
          }
          } else {
            const chunks = Math.ceil(filesize / chunkSize);
            setPhaseFileUploadProgress(
              Math.round((currentFileChunkIndex / chunks) * 100)
            );
            setCurrentFileChunkIndex(currentFileChunkIndex + 1);
          }
        } else {
          setCurrentChunkIndex(null);
        }
      }
    });
  };
  const postMsg = () => {
    document.getElementById("msg-content").value = "";
    const params = new URLSearchParams();
    if (selectedfile === "") {
      params.set("description", requestRevisionMessage);
      params.set("requestDueDate", revisionRequestDueDate);
      params.set("assetId", assetId);
      params.set("phaseId", workflowPhase.phaseId);
      params.set("projectId", projectId);
      params.set("documentFileId", "");
      params.set("doRequestRevision", true);
      params.set("hasDocument", false);
    } else {
      params.set("description", requestRevisionMessage);
      params.set("requestDueDate", revisionRequestDueDate);
      params.set("assetId", assetId);
      params.set("phaseId", workflowPhase.phaseId);
      params.set("projectId", projectId);
      params.set("documentFileId", "");
      params.set("doRequestRevision", true);
      params.set("hasDocument", true);
    }

    const urlWithParams = `${APIUrls.COMPLETE_REVIEW_META_DATA(
      projectId,
      assetId
    )}?${params.toString()}`;
    postAxiosResponse(urlWithParams).then((res) => {
      setDocumentFileId(res.data.documentFileId);
      setCurrentChunkIndex(0);
    }).catch(err=>{
      console.error(err)
    })
  };

  useEffect(() => {
    if (currentChunkIndex !== null && currentChunkIndex !== -1) {
      setShowProgress(true);
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);

  const readAndUploadCurrentChunk = () => {
    const file = selectedfile;
    if (file) {
      const reader = new FileReader();
      const from = currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadChunk(e);
      reader.readAsDataURL(blob);
    } else {
      uploadChunk(null);
    }
  };

  const uploadChunk = (readerEvent) => {
    const file = selectedfile;
    const data = readerEvent ? readerEvent.target.result : {};
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    let params = getMetadataParams();
    var urlPart = "";
    if (file) {
      urlPart =
        APIUrls.COMLETE_REVIEW_BINARY(projectId, assetId) +
        `?${params.toString()}`;
    } else {
      urlPart =
        APIUrls.COMLETE_REVIEW_BINARY(projectId, assetId).replace(
          "/upload",
          ""
        ) + `?${params.toString()}`;
    }
    const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
    axios.post(url, data, { headers }).then((res) => {
      if (res.data !== "") {
        if (selectedfile !== "") {
          const filesize = selectedfile.size;
          const chunks = Math.ceil(filesize / chunkSize) - 1;
          const isLastChunk = currentChunkIndex === chunks;
          if (isLastChunk) {
            setCurrentChunkIndex(null);
            setFileUploadProgress(100);
            prop.refresh();
          } else {
            const chunks = Math.ceil(filesize / chunkSize);
            setFileUploadProgress(
              Math.round((currentChunkIndex / chunks) * 100)
            );
            setCurrentChunkIndex(currentChunkIndex + 1);
          }
        } else {
          setCurrentChunkIndex(null);
          prop.refresh();
        }
      }
    }).catch(err=>{
      console.error(err)
    })
  };

  useEffect(()=>{
    getAxiosResponse(APIUrls.REVIEWABLE_ASSIGNEES(projectData?.userGroup?.id)).then(res=>{
      if (res.data.code === 200) {
        const reviewAssignees = res.data.data.map(({ customerUser}) => ({label:customerUser.firstName+' '+customerUser.lastName,value:customerUser}));
        setReviewAssigneeList(reviewAssignees);
      }   
    }).catch(err=>{
      console.error(err)
    })
  },[])
  const getPhaseAssignee = (selectedPhaseId, phase) => {
    var copyAssignees = [];
    var assignees = []
    var phaseUsers = phaseAssigneeUsers?.filter((phase) => {
      return phase?.phaseId == selectedPhaseId;
    }); 
    if (phase?.assignedToVendor) {
      copyAssignees = structuredClone(assignees);
    }
    else {
      copyAssignees= projectFollowers.filter(y => !phaseUsers[0].users.some(x => x.userId === y.userId))
    }
   
    var filtered = [];
    
    if (typeof phaseUsers[0]?.users !== "string") {
      filtered = copyAssignees.filter((user) =>
          !phaseUsers[0]?.users?.some((follower) => follower?.userId === user?.userId)
      );
      if(filtered.length === 0){
        filtered = projectFollowers.filter((user) =>
          !phaseUsers[0]?.users?.some((follower) => follower?.userId === user?.userId)
      );
      filtered.forEach((user)=>{
        assignees.push({label:user.firstName+' '+user.lastName,value:user})
      })
      }else{
        filtered.forEach((user)=>{
          assignees.push({label:user.firstName+' '+user.lastName,value:user})
        })
      }
    } else if (typeof phaseUsers[0]?.users === "string") {
      return [];
    } else {
      copyAssignees.forEach((user)=>{
        assignees.push({label:user.firstName+' '+user.lastName,value:user})
      })
    }
    if (phaseUsers && phaseUsers.length > 0 && reviewAssigneeList && reviewAssigneeList.length > 0) {
      assignees=reviewAssigneeList?.filter(y => !phaseUsers[0].users.some(x => x.userId === y?.value?.userId));
    }
    return assignees
  };

  const getMetadataParams = () => {
    const params = new URLSearchParams();

    if (selectedfile === "") {
      params.set("description", requestRevisionMessage);
      params.set("requestDueDate", revisionRequestDueDate);
      params.set("assetId", assetId);
      params.set("phaseId", workflowPhase?.phaseId);
      params.set("projectId", projectId);
      params.set("documentFileId", "");
      params.set("doRequestRevision", true);
      params.set("hasDocument", false);
    } else {
      params.set("name", selectedfile.name);
      params.set("size", selectedfile.size);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
      params.set("description", requestRevisionMessage);
      params.set("requestDueDate", revisionRequestDueDate);
      params.set("assetId", assetId);
      params.set("phaseId", workflowPhase?.phaseId);
      params.set("projectId", projectId);
      params.set("doRequestRevision", true);
      params.set("hasDocument", true);
      params.set("fileDataAttribute", "attachment.fileData");
      params.set(
        "documentFileId",
        documentFieldId !== -1 ? documentFieldId : ""
      );
    }

    return params;
  };

  const postDeliverableApproveMsg = () => {
    const params = new URLSearchParams();
    if (selectedAttachmentFile === "") {
      var data = {
        approveWithChanges: false,
        childAssetIds: [],
        feedback: feedBackMessage,
        feedbackNotes: null,
        documentFileId: null,
        language: selectedTranslatedAsset.language,
        rating: {},
        ratingValue: null,
        hasDocument: false,
      };
    } else {
      var data = {
        approveWithChanges: false,
        childAssetIds: [],
        feedback: feedBackMessage,
        feedbackNotes: null,
        documentFileId: null,
        language: selectedTranslatedAsset.language,
        rating: {},
        ratingValue: null,
        hasDocument: true,
      };
    }
    if (offlineReviewFeedbackType === "approve") {
      data.approveWithChanges = false;
    }
    var payload = transformBlankToNull(data);
    const urlWithParams = `${APIUrls.SUBMIT_ASSET_FEEDBACK(
      projectId,
      assetId
    )}?${params.toString()}`;
    postAxiosResponse(
      APIUrls.SUBMIT_ASSET_FEEDBACK(projectId, assetId),
      payload
    ).then((res) => {
      setFeebackDocumentFileId(res.data.data.documentFileId);
      setAttachmentCurrentChunkIndex(0);
    }).catch(err=>{
      console.error(err)
    })
  };
  useEffect(() => {
    if (attachmentCurrentChunkIndex !== null) {
      setAttachmentShowProgress(true);
      readAndUploadAttachmentCurrentChunk();
    }
  }, [attachmentCurrentChunkIndex]);

  const readAndUploadAttachmentCurrentChunk = () => {
    const file = selectedAttachmentFile;
    if (file) {
      const reader = new FileReader();
      const from = attachmentCurrentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadAttachmentChunk(e);
      reader.readAsDataURL(blob);
    } else {
      uploadAttachmentChunk(null);
    }
  };

  const uploadAttachmentChunk = (readerEvent) => {
    const file = selectedAttachmentFile;
    const data = readerEvent ? readerEvent.target.result : {};
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    let params = getAttachmentMetadataParams();
    var urlPart = "";
    if (assetId !== "") {
      if (file) {
        urlPart =
          APIUrls.SUBMIT_ASSET_FEEDBACK_ATTACHMENT(projectId, assetId) +
          `?${params.toString()}`;
      } else {
        urlPart =
          APIUrls.SUBMIT_ASSET_FEEDBACK_ATTACHMENT(projectId, assetId).replace(
            "/upload",
            ""
          ) + `?${params.toString()}`;
      }

      const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
      axios.post(url, data, { headers }).then((res) => {
        if (res.data.data) {
          if (selectedAttachmentFile !== "") {
            const filesize = selectedAttachmentFile.size;
            const chunks = Math.ceil(filesize / chunkSize) - 1;
            const isLastChunk = attachmentCurrentChunkIndex === chunks;
            if (isLastChunk) {
              setAttachmentCurrentChunkIndex(null);
              setAttachmentFileUploadProgress(100);
              if (langCode !== "") {
                fetchLanguageDetail(langCode);
                hideModel();
              }
              setSelectedAttachmentFile("");
              cancelFeedback();
              prop.refresh();
            } else {
              const chunks = Math.ceil(filesize / chunkSize);
              setAttachmentFileUploadProgress(
                Math.round((attachmentCurrentChunkIndex / chunks) * 100)
              );
              setAttachmentCurrentChunkIndex(attachmentCurrentChunkIndex + 1);
            }
          } else {
            setAttachmentCurrentChunkIndex(null);
            cancelFeedback();
            if (langCode !== "") {
              fetchLanguageDetail(langCode);
              prop.refresh();
            }
          }
        }
      }).catch(err=>{
        console.error(err)
      })
    }
  };

  const getAttachmentMetadataParams = () => {
    const params = new URLSearchParams();

    if (selectedAttachmentFile === "") {
      params.set("approveWithChanges", false);
      params.set("childAssetIds", []);
      params.set("feedback", feedBackMessage);
      params.set("feedbackNotes", feedBackMessage);
      params.set("language", selectedTranslatedAsset.language);
      params.set("ratingValue", 0);
      params.set("hasDocument", false);
    } else {
      params.set("name", selectedAttachmentFile.name);
      params.set("size", selectedAttachmentFile.size);
      params.set("currentChunkIndex", attachmentCurrentChunkIndex);
      params.set(
        "totalChunks",
        Math.ceil(selectedAttachmentFile.size / chunkSize)
      );
      params.set("feedbackNotes", feedBackMessage);
      params.set("approveWithChanges", false);
      params.set("hasDocument", true);
      params.set("ratingValue", 0);
      // params.set("fileDataAttribute", "attachment.fileData");
      params.set(
        "documentFileId",
        feebackDocumentFileId !== -1 ? feebackDocumentFileId : ""
      );
    }

    return params;
  };

  const validations = {
    message: {
      maxLength: {
        value: 3500,
        message: "Message must be 3500 characters long",
      },
    },
  };
  const fileSelection = (e) => {
    if (e.target) {
      setSelectedFile(e.target.files[0]);
    }
  };
  
  const assetFileSelection = (e) => {
    if (e.target) {
      setSelectedAttachmentFile(e.target.files[0]);
    }
  };
  const downloadHistoryAsset = (url, filename) => {
    downloadFile(url, filename);
  };

  const getLangStatus = (code) => {
    var matched = projLangDetail.filter((lang) => {
      return Object.keys(lang.resource)[0] === code;
    });
    return matched;
  };
  const autoVendorSelect = (e) => {
    e.target.checked ? setAutoVendor(true) : setAutoVendor(false);
  };
  const showOneTm = (e) => {
    e.preventDefault();
    navigate("/one-tm", { state: { projectDetail: projectResource } });
  };
  const getExtension = (name) => {
    if (name.documentFile) {
      name = name.documentFile;
    }

    var fileExtenstion;

    if (name.filename) {
      name = name.filename;
    }

    if (name.endsWith(".pdf.html")) {
      fileExtenstion = "pdf";
    } else {
      fileExtenstion = name.substr(name.lastIndexOf(".") + 1);
    }
    return fileExtenstion;
  };
  const getSourceFileData = (asset) => {
    var translatedFile = asset.files?.TRANSLATABLE || asset.files?.FINAL;
    if (translatedFile) {
      return {
        fileName: translatedFile.documentFile.filename,
        created: translatedFile.createdDate.date,
      };
    }

    var sourceFile = asset.source.files?.TRANSLATABLE || asset.source.files?.FINAL || asset.source.files?.INTERMEDIATE;
    if (sourceFile) {
      return {
        fileName: sourceFile.documentFile.filename,
        created: sourceFile.createdDate.date,
      };
    }
  };

  

  const cancelRequestRevision = () => {
    toggleRequestRevision(false);
    hideModel();
    $('.requestRevision').trigger('focus');
  };
  const cancelFeedback = () => {
    setShowDeliverableApprovePopup(false);
    hideModel();
  };

  const getTaskPhase = () => {
    let latestTask = null;
    let latestTime = 0;
  
    const updateLatestTask = (taskType) => {
      phaseTask.forEach(task => {
        if (task.type.originalEnum === taskType && task.createdDate.utcTimestamp > latestTime) {
          latestTask = task;
          latestTime = task.createdDate.utcTimestamp;
        }
      });
    };
  
    if (selectedTranslatedAsset.status === "IN_REVISION") {
      updateLatestTask("REVISE_PROJECT_ASSETS");
    } 
    else if (selectedTranslatedAsset.status === "APPROVED") {
      updateLatestTask("REVIEW_APPROVED_ASSET_NOTES");
  
      if (!latestTask) {
        updateLatestTask("REVIEW_PROJECT_ASSETS");
      }
    } 
    else {
      updateLatestTask("REVIEW_PROJECT_ASSETS");
    }
    return latestTask;
  };

  const reopenWorkflow = () => {
    postAxiosResponse(
      APIUrls.PROJECT_WORKFLOW_REOPEN(projectId, langCode)
    ).then((res) => {
      prop.refresh();
    }).catch(err=>{
      console.error(err)
    })
  };
  const downloadAsset = (event, item, fileName) => {
    event.preventDefault();
    var newFileName = fileName;
    if (item.text.endsWith(" (.xlf)")) {
      newFileName = item.fileName;
    }
    if (item.text.endsWith(" (.docx)")) {
      newFileName = item.fileName;
    }
    if (item.text === Constants.SOURCE_PREVIEW_BUNDLE) {
      newFileName = item.fileName;
    }
    if (item.text === Constants.TARGET_PREVIEW_BUNDLE) {
      newFileName = item.fileName;
    }
    if (item.text === "Bilingual review file") {
      newFileName = `Review-${newFileName}.docx`;
    }
    downloadFile(APIUrls.DOWNLOAD_ASSET_FILES(item.link), newFileName);
  };
  const onKeyDownloadAsset = (event, item, fileName) => {
    if (event.key === Constants.ENTER) {
      downloadAsset(event, item, fileName)
    }
  }
  
  useEffect(() => {
    if (!roleArray.includes("ROLE_CUSTOMER_REVIEWER")) {
      getAxiosResponse(
        APIUrls.PREFERRED_VENDORS(projectResource.userGroup.id)
      ).then((res) => {
        const options = res?.data?.data?.map((preferredVendor) => ({
          label: preferredVendor.vendor.name,
          value: {
            id: preferredVendor.vendor.id,
            name: preferredVendor.vendor.name,
          },
        }));
        setPreferredVendorRaw(res.data.data)
        setPreferredVendors(options);
      }).catch(err=>{
        console.error(err)
      })
    }
  }, [projectResource]);

  useEffect(() => {
    prop.refreshActivityData();
    getAxiosResponse(APIUrls.LANGUAGES_FOR_MAPPING).then(res=>{
      if(res?.data?.status==="success"){
       setLanguageForMapping(res.data.data)
      }
   })
    updateTmFile();

    getAxiosResponse(APIUrls.INTERNAL_REQUEST(param.id)).then((res) => {
      if (res.data !== "") {
        setInternalTranslationRequest(res.data.data);
      }
    }).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setUserBootstrapData(res.data.data);
    }).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.GET_LATEST_MASTER_DELIVERABLE_FILE(param.id)).then(
      (res) => {
        if (res.data !== "") {
          setMasterDeliverableFile(res.data.data);
        }
      }
    ).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.USER_ALERT_COUNT + `?projectId=${param.id}`).then(
      (res) => {
        if (res?.data?.data?.all !== 0) {
          setUserAlert(res?.data?.data);
        }
      }
    ).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.TARGET_ASSET_DATA_COUNT(param.id))
      .then((res) => {
        if (res.data !== "") {
          var uniqueLangs = [];
          res.data.data.map((lang, index) => {
            if (index === 0) {
              uniqueLangs.push(lang);
            } else if (
              uniqueLangs.length > 0 &&
              JSON.stringify(uniqueLangs[uniqueLangs.length - 1].resource) ===
                JSON.stringify(lang.resource)
            ) {
              uniqueLangs[uniqueLangs.length - 1].displayName.push(
                lang.displayName[0]
              );
            } else {
              uniqueLangs.push(lang);
            }
          });
          setProjLangDetail(uniqueLangs);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.PROJECT_PENDING_TASK(param.id)).then((res) => {
      if (res.data !== "" && res.data !== undefined) {
        setMyTasks(res.data.data);
      }
    }).catch(err=>{
      console.error(err)
    })
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setOptions(res.data.data);
    }).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.PROJECT_DELIVERABLE_STATUS(param.id)).then(
      (res) => {
        if (res.data !== "" && res.data !== undefined) {
          setProjectDeliverableStatus(res.data.data);
          var languagesToReview = [];
          var languagesStillInTranslation = [];
          var languagesStillInRevision = [];
          var languagesAlreadyApproved = [];
          res.data.data.map((lang) => {
            if (
              lang.resource.languageStatus === "TO_REVIEW" &&
              lang.resource.assignedToContextSilo
            ) {
              languagesToReview.push(lang);
            } else if (
              lang.resource.languageStatustus === "IN_TRANSLATION" &&
              !lang.resource.assignedToContextSilo
            ) {
              languagesStillInTranslation.push(lang.displayName[0]);
            } else if (
              lang.resource.languageStatus === "IN_REVISION" &&
              !lang.resource.assignedToContextSilo
            ) {
              languagesStillInRevision.push(lang.displayName[0]);
            } else if (lang.resource.languageStatus === "APPROVED") {
              languagesAlreadyApproved.push(lang.displayName[0]);
            }
          });
          setLanguageToReview(languagesToReview);
          setLanguagesStillInTranslation(languagesToReview);
          setLanguagesStillInRevision(languagesToReview);
          setLanguagesAlreadyApproved(languagesToReview);
        }
      }
    ).catch(err=>{
      console.error(err)
    })
    getAxiosResponse(APIUrls.CUSTOMER_DEPARTMENT_USERS_REVIEW(projectId)).then(
      (res) => {
        if (res.data.code === 200) {
          var users = [];
          res.data.data.map((data) => {
            users.push(data.resource.customerUser);
          });
          setPotentialWorkflowAssignees(users);
          setConstAssignees(users);
        }
      }
    ).catch(err=>{
      console.error(err)
    })
    getAxiosResponse(APIUrls.PROJECT_VISIBILITY_USER(projectId)).then((res) => {
      if (res.data.code === 200) {
        var users = [];
        res.data.data.map((data) => {
          users.push(data.resource);
        });
        setAssignees(users);
        setConstAssignees(users);
      }
    }).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(APIUrls.OFFLINE_PREVIEW_WITHOUT_FILEID(param.id,"SOURCE_PREVIEW_BUNDLE"))
    .then((res) => {
      if (res.data.data) {
       setSourcePreviewBundle(res.data.data)
      }
    }).catch(err=>{
      console.error(err)
    })
    
    getAxiosResponse(APIUrls.OFFLINE_PREVIEW_WITHOUT_FILEID(param.id,"TARGET_PREVIEW_BUNDLE"))
    .then((res) => {
      if (res.data.data) {
       setTargetPreviewBundle(res.data.data)
      }
    }).catch(err=>{
      console.error(err)
    })
    
  }, []);

  const clearHistoryRecord = () => {
    setFileHistory([]);
    setTranslatedAsset([]);
    toggleRequestRevision(false);
  };
  const fetchLanguageHistory = (assetId, phase) => {
    getAxiosResponse(
      APIUrls.GET_PROJECT_ASSET_FILE_HISTORY(param.id, assetId)
    ).then((res) => {
      if (res.data.data !== "") {
        setAssetFileHistory(res.data.data);
      }
    }).catch(err=>{
      console.error(err)
    })
    getAxiosResponse(
      APIUrls.PROJECT_TRANSLATED_ASSETS_BY_LANG(param.id, langCode, phase.id)
    ).then((res) => {
      
      setTranslatedAsset(res?.data?.data?.result);
    }).catch(err=>{
      console.error(err)
    })
    getAxiosResponse(APIUrls.GET_REVISION_REQUEST(param.id, assetId)).then(
      (res) => {
        setRevisionRequest(res.data.data);
      }
    ).catch(err=>{
      console.error(err)
    })
    getAxiosResponse(APIUrls.GET_ASSET_FFEDBACK(param.id, assetId)).then(
      (res) => {
        setAssetFeedback(res.data.data);
      }
    ).catch(err=>{
      console.error(err)
    })
  };
  const createReviewLink = (phaseId, entry, targetAssetData, selectedPhase,access) => {
    getAxiosResponse(
      APIUrls.PHASE_ASIGNEE(param.id, entry.id, selectedPhase.phaseId)
    ).then((res) => {
      setReviewAssignees(res.data.data);
    }).catch(err=>{
      console.error(err)
    })

    getAxiosResponse(
      APIUrls.ALL_TASKS + `?phaseId=${phaseId}&onlyFollowed=false`
    )
      .then((res) => {
        if (res.data !== "") {
          setPhaseTask(res.data.data?.result);
          setTimeout(() => {
            if ($('#reviewBack').length) {
              $('#reviewBack').trigger('focus');
            }
          }, 300);
        } else {
          setPhaseTask([]);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    setSelectedTranslatedAsset(entry);
    setAssetId(entry.id);
    var assetPhase = [];
    setWorkFlowPhase(selectedPhase);

    languageDetail.steps.forEach((step) => {
      if (step.stepNumber == selectedPhase.stepNumber) {
        step.phases.forEach((phase) => {
          if (phase.id == phaseId) {
            assetPhase = phase;
          }
        });
      }
    });
    setlanguagePhase(assetPhase);
    if (entry.reviewId) {
      if (entry.lineByLineEnabled) {
        navigate(`/project/${projectId}/review/${phaseId}/${langCode}/${entry.reviewId}`,{state:{'access':access}});
      } else {
        fetchLanguageHistory(entry.id, assetPhase);
      }
    }else{
      fetchLanguageHistory(entry.id, selectedPhase);
    }
  };

  useEffect(() => {
    if (translatedAsset && assetFileHistory &&
      translatedAsset?.length !== 0 &&
      assetFileHistory.length !== 0 &&
      assetId !== ""
    ) {
      var fileHistoryArray = [];
      assetFileHistory.map((assetFile) => {
        if (assetFile.asset.sourceAssetId !== "") {
          fileHistoryArray.push({
            title: `${assetFile.asset.language} Translation`,
            dateText: `Uploaded by ${
              assetFile.documentFile.creatorUser.firstName +
              " " +
              assetFile.documentFile.creatorUser.lastName
            }${" "}${dateUtil.format(assetFile.documentFile.createdDate, null,null)}`,
            docFile: assetFile.documentFile,
            docURL:
              APIUrls.DOWNLOAD_CUSTOMER_DOCUMENT(
                assetFile.documentFile.fileId
              ) + `?entityType=PROJECT&entityId=${projectId}`,
            createdDate: moment(assetFile.createdDate).tz(
              custBootstrapDataRedux.user?.timeZone
            ),
          });
        }
      });

      revisionRequests.map((revisionRequest) => {
        fileHistoryArray.push({
          title: "Revision request",
          dateText: `Requested by ${
            revisionRequest.creatorUser.firstName +
            " " +
            revisionRequest.creatorUser.lastName
          }${" "}${dateUtil.format(revisionRequest.createdDate,null,null)}`,
          docFile: revisionRequest.attachment,
          docURL: APIUrls.DOWNLOAD_URL(
            revisionRequest.attachment.contentPath
          ),
          description: revisionRequest.description,
          createdDate: moment(revisionRequest.createdDate).tz(
            custBootstrapDataRedux.user?.timeZone
          ),
          dueDate:
            revisionRequest.dueDate !== ""
              ? dateUtil.format(
                  revisionRequest.dueDate,
                 null,
                  custBootstrapDataRedux.user?.timeZone
                )
              : null,
        });
      });

      assetFeedback.map((feedback) => {
        fileHistoryArray.push({
          title: "Review Feedback",
          dateText: `Submitted by ${
            feedback.creatorUser.firstName + " " + feedback.creatorUser.lastName
          }${" "}${dateUtil.format(
            feedback.createdDate,null,null
          )}`,
          docFile: feedback.attachment,
          docURL: APIUrls.DOWNLOAD_CUSTOMER_DOCUMENT(
              feedback.attachment.fileId
          ) + `?entityType=PROJECT&entityId=${projectId}`,
          description: feedback.feedback,
          createdDate: utcDateTimeWithTimeZone(
            feedback.createdDate,
            custBootstrapDataRedux.user?.timeZone
          ),
          rating:
            feedback.rating && feedback.rating.value ? feedback.rating : null,
        });
      });

      var sourceProjectAsset = translatedAsset.filter((asset) => {
        return asset.id == assetId;
      });

      sourceProjectAsset = sourceProjectAsset[0].source;
      fileHistoryArray.push({
        title: `${sourceProjectAsset.language} source`,
        dateText: `Uploaded by ${
          sourceProjectAsset.files.FINAL.documentFile.creatorUser.firstName +
          " " +
          sourceProjectAsset.files.FINAL.documentFile.creatorUser.lastName
        }${" "}${dateUtil.format(sourceProjectAsset.files.FINAL.documentFile.createdDate,null,null)}`,
        docFile: sourceProjectAsset.files.FINAL.documentFile,
        docURL:
          APIUrls.DOWNLOAD_CUSTOMER_DOCUMENT(
            sourceProjectAsset.files.FINAL.documentFile.fileId
          ) + `?entityType=PROJECT&entityId=${projectId}`,
        createdDate: moment(
          sourceProjectAsset.files.FINAL.documentFile.createdDate
        ).tz(custBootstrapDataRedux.user?.timeZone),
      });

      var shortedHistory = fileHistoryArray.sort(
        (a, b) => b.createdDate - a.createdDate
      );
      setFileHistory(shortedHistory);
    }
  }, [
    assetId,
    translatedAsset,
    assetFileHistory,
    assetFeedback,
    revisionRequests,
  ]);

  const openDeliverableApprovePopup = (type) => {
    setOfflineReviewFeedbackType(type);
    showModel();
    setShowDeliverableApprovePopup(true);
    
    setTimeout(() => {
      $(".cancelApproveLang").trigger("focus");
      $("#msg-content").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
            e.preventDefault();
            $("#submitApproveLang").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          cancelFeedback();
          $('.focusAdd').trigger('focus');
          $('.approveClickBtn').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const handleKeyApproveLang = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#msg-content").trigger("focus");
      }
    }
  };
  const handleTooltip = (event) => {
    if (event.key === Constants.ESCAPE) {
      $(event.target).find('.wrap-tooltip-content').css('display', 'none');
    } else if (event.key === Constants.TAB) {
      $(event.target).find('.wrap-tooltip-content').css('display', '');
    }
  };
  $(document).on("click",".approveClickBtn",function() {
    $(this).addClass('focusAdd');
  });
  $(document).on("click",".modal-footer .cancelApproveLang",function() {
   $('.focusAdd').trigger('focus');
   $('.approveClickBtn').removeClass('focusAdd');
 });
  const phaseCompletedStatus = (currentStep, currentPhase) => {
    return languageDetail.steps.map((step, stepIndex) => {
      return step.phases.map((phase, phaseIndex) => {
        return isPhaseCompleted(
          phase,
          step.stepNumber,
          currentStep,
          currentPhase
        );
      });
    });
  };
  useEffect(()=>{
    if(prop.languageCode){
      fetchLanguageDetail(prop.languageCode);
    }
  },[prop.languageCode])

  useEffect(() => {
    if (prop.trigger) {
      fetchLanguageDetail(prop.trigger);
    }
  }, [prop.trigger]);

  const showChatBox=(val,entry)=>{
    setPopUpValue("");
    setTargetDataIdForDiscussion(entry?.id)
    setShowChatPopup(val);
    showModel();
     setTimeout(() => {
      $(".cancelDiscussionPopup").trigger("focus");
      $(".discusstionTextarea").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
             e.preventDefault();
             $(".cancelDiscussionPopup").trigger("focus");
           }
        }
      });
     $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          if (!$('.escCloseDropdown').length || $('.escCloseDropdown').find('input').attr('aria-expanded') === 'false') {
              $("body").removeClass("modal-open");
              $('.focusAdd').trigger('focus');
              $('.focusAdd').removeClass('focusAdd');
            }
         
        }
      });
      $(".cancelDiscussionPopup").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === false) {
            e.preventDefault();
            $(".discusstionTextarea").trigger("focus");
          }
        }
      });
    }, 500);
    
   
  }
  const matchCustomCode = (langcode,matchCode) =>{
    if(languageForMapping.length > 0){
      var result = languageForMapping.find(( value ) => value.customCode === langcode);
      if(result && result.language.code === matchCode){
        return true
      }
      else if(langcode === matchCode){
          return true
      }
      else{
        return false
      }
    }else{ 
      if(langcode === matchCode){
        return true
      }
      else{
        return false
      }
    }
  }
  const getSelectedLanguageDisplayName = () =>{
    var selectedLang = {}
    if(langCode !== ''){
      selectedLang = prop.projectDetail.displayName[0].targetLanguages.filter((lang)=>{
        return lang.code === langCode
      })
    }
    return selectedLang
  }

  const updateTmFile = () => {
    getAxiosResponse(APIUrls.GET_TM_FILE(param.id)).then((res) => {
      if (res.data) {
        setTranslationMemoryFile(res.data.data);
      }
    }).catch(err=>{
      console.error(err)
    })
  }

  const clearValue = (e) => {
     e.target.value = null;
   };

   $(document).on("click",".chat",function() {
      $(this).addClass('focusAdd');
    });
    $(document).on("click",".modal-footer .cancelDiscussionPopup",function() {
     $('.focusAdd').trigger('focus');
     $('.focusAdd').removeClass('focusAdd');
   });

   const getTranslationMemoryMessage = () => {
    if (projectStatus.inCancellation || projectStatus.cancelled) {
      const cancellationMessage = options.roleSet?.vendorType || isTranslator()
        ? "This project has been canceled, and therefore you are not requested to upload the translation memory for it."
        : "This project has been canceled, and therefore the translator will not be requested to upload the translation memory for it.";
      
      return cancellationMessage;
    } 
    if (projectResource?.skipTmUpload) {
      let message;
      if (projectResource.status.code === "project_closed") {
        message = Constants.OVERVIEW_SKIP_TM_TASK_MESSAGE_PROJECT_CLOSED;
      }
      else {
        message = Constants.OVERVIEW_SKIP_TM_TASK_MESSAGE;
      }
      
      return (
        <div className="no-data-display align-center">
          <i className="nodata-icon"></i>
          <p>{message}</p>
        </div>
      );
    }
    return (
      <div className="no-data-display align-center">
        <i className="nodata-icon"></i>
        <p>{Constants.TASK_TRANSLATION_MEMORY}</p>
      </div>
    );
  }

  return (
    <div className="listing-content">
      {fileHistory?.length === 0 ? (
        <div className="project-detail-overview-inner">
          <div className="listing-content relative">
            <OverviewAlerts
              project={prop.projectDetail}
              funct={showAlertModel}
              requestTranslationAgainFunct={
                showRequestTranslationAgainAlertModel
              }
              refresh={refreshProject}
              showProjectDetail={fetchLanguageDetail}
            />
          </div>
          {prop.projectDetail.displayName[0].targetLanguages && prop.projectDetail.displayName[0].targetLanguages?.length !== 0 ? (
            <div className="detail-header flex-center">
              <div className="detail-header-left">
                <div className="translate-box flex">
                  {prop.projectDetail.displayName[0].targetLanguages.map(
                    (lang, targetLangindex) => {
                      return (
                        <div
                          className="translate-box-list"
                          ref={langBoxRef}
                          id={lang.code}
                          key={targetLangindex}
                          role="none"
                        >
                          <Link
                            to="#"
                            role="button"
                            className={langCode === lang.code || matchCustomCode(langCode,lang.code) ? "active" : ""}
                            aria-expanded={langCode === lang.code ? "true" : "false"}
                            aria-label={langCode === lang.code ? lang.display : lang.display}
                            onClick={() => fetchLanguageDetail(lang.code, "")}
                            projectdetail-tour="expand-lang"
                          >
                            {langCode === lang.code && showLangLoader ? (
                              <div className='sending_msg' aria-label='loading details' tabIndex="0">
                                <RotatingLines
                                  strokeColor="#1D4ED8"
                                  strokeWidth="5"
                                  animationDuration="0.75"
                                  width="22"
                                  visible={true}
                                />
                              </div>
                            ) : (
                              <>
                                <span>{lang.display}</span>
                                {/* {lang.code &&
                                  getLangStatus(lang.code)[0]?.displayName.map(
                                    (status, langIndex) => {
                                      return (
                                        <p key={langIndex}>{status.label}</p>
                                      );
                                    }
                                  )} */}
                              </>
                            )}
                          </Link>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
              {showDetail ? (
                ""
              ) : (
                <div className="detail-header-right flex-column flex">
                  {projectDeliverableStatus.length > 0 &&
                  projectDeliverableStatus[0]?.resource?.projectWorkflow?.steps.length === 1 &&
                  userBootstrapData?.permissions?.PROJECT_LANGUAGE_APPROVE_OR_REQUEST_REVISION ? (
                    <button
                      className="btn-bold flex-center approveClick"
                      onClick={() => {
                        setPopUpValue("assetApprove");
                        showModel();
                      }}
                    >
                      Approve
                    </button>
                  ) : null}
                  {masterDeliverableFile?.id !== undefined ? (
                    <button
                      className="btn-bold flex-center"
                      aria-label="download translation"
                      onClick={() =>
                        downloadTranslation(masterDeliverableFile?.filename)
                      }
                    >
                      Download
                    </button>
                  ) : null}
                </div>
              )}
            </div>
          ) : (
            ""
          )}

          {showDetail ? (
            <React.Fragment>
              <div className="translate-box-content">
                <div className="button-tab flex relative">
                  <div className="btn-wrap">
                    <button
                      className="btn-bold fill-white arrow_box"
                      id="activeId3"
                      onClick={filterFunctionthree}
                      aria-expanded="false"
                      tabIndex="0"
                      aria-label="workflow"
                      projectdetail-tour="workflow-btn"
                    >
                      Workflow
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="18"
                        viewBox="0 0 17 18"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.25 2.25C0.25 1.85218 0.408035 1.47064 0.68934 1.18934C0.970645 0.908035 1.35218 0.75 1.75 0.75H6.625C7.02283 0.75 7.40436 0.908035 7.68566 1.18934C7.96697 1.47064 8.125 1.85218 8.125 2.25V7.125C8.125 7.52283 7.96697 7.90436 7.68566 8.18566C7.40436 8.46697 7.02283 8.625 6.625 8.625H4.75V11.6723C4.75 12.2663 5.233 12.75 5.8285 12.75H8.875V10.875C8.875 10.4772 9.03304 10.0956 9.31434 9.81434C9.59565 9.53304 9.97718 9.375 10.375 9.375H15.25C15.6478 9.375 16.0294 9.53304 16.3107 9.81434C16.592 10.0956 16.75 10.4772 16.75 10.875V15.75C16.75 16.1478 16.592 16.5294 16.3107 16.8107C16.0294 17.092 15.6478 17.25 15.25 17.25H10.375C9.97718 17.25 9.59565 17.092 9.31434 16.8107C9.03304 16.5294 8.875 16.1478 8.875 15.75V13.875H5.82775C5.24348 13.8748 4.6832 13.6426 4.27013 13.2293C3.85705 12.8161 3.625 12.2558 3.625 11.6715V8.625H1.75C1.35218 8.625 0.970645 8.46697 0.68934 8.18566C0.408035 7.90436 0.25 7.52283 0.25 7.125V2.25ZM1.75 1.875C1.65054 1.875 1.55516 1.91451 1.48484 1.98484C1.41451 2.05516 1.375 2.15054 1.375 2.25V7.125C1.375 7.22446 1.41451 7.31984 1.48484 7.39017C1.55516 7.46049 1.65054 7.5 1.75 7.5H6.625C6.72446 7.5 6.81984 7.46049 6.89017 7.39017C6.96049 7.31984 7 7.22446 7 7.125V2.25C7 2.15054 6.96049 2.05516 6.89017 1.98484C6.81984 1.91451 6.72446 1.875 6.625 1.875H1.75ZM10.375 10.5C10.2755 10.5 10.1802 10.5395 10.1098 10.6098C10.0395 10.6802 10 10.7755 10 10.875V15.75C10 15.8495 10.0395 15.9448 10.1098 16.0152C10.1802 16.0855 10.2755 16.125 10.375 16.125H15.25C15.3495 16.125 15.4448 16.0855 15.5152 16.0152C15.5855 15.9448 15.625 15.8495 15.625 15.75V10.875C15.625 10.7755 15.5855 10.6802 15.5152 10.6098C15.4448 10.5395 15.3495 10.5 15.25 10.5H10.375Z"
                          fill="#1D4ED8"
                        />
                      </svg>
                    </button>
                    <div
                      className="filter-content workflow-block flex arrow"
                      id="filterBtn3"
                    >
                      {languageDetail.steps && languageDetail.steps.length !== 0 ? (
                        <div className="workflow-main">
                          {languageDetail.steps.map((step, stepIndex) => {
                            return (
                              <div className={`workflow-tab-content ${stepIndex}`} key={stepIndex} >
                                <h4>{step.name}</h4>
                                <ul className="workflow-content-list">
                                  {step.phases.map((phase, phaseIndex) => {
                                    return (
                                      <li key={phaseIndex}>
                                        <div className="workflow-item">
                                          {phase.name !== "" ? (
                                            <p className="title">{phase.name}</p>
                                          ) : stepIndex === languageDetail.steps.length - 1 && phaseIndex === step.phases.length - 1 ? 
                                          (
                                            <p className="title">
                                              Final Review
                                            </p>
                                          ) : languageDetail.currentPhaseId === phase.id ? 
                                          (
                                            <p className="title">
                                              In {phase.phaseType.display}
                                            </p>
                                          ) : phase.phaseType.display !== "" ? (
                                            phase.phaseType.code === "review" && step.phases.length > 2 ? 
                                            (
                                              <p className="title">
                                                {phase.phaseType.display} {phaseIndex}
                                              </p>
                                            ) : 
                                            (
                                              <p className="title">
                                                {phase.phaseType.display}
                                              </p>
                                            )
                                          ) : (
                                            <p className="title">
                                              {phase.phaseType.display}
                                            </p>
                                          )}
                                          <ConditionalBlock condition={phase.phaseType.originalEnum === "POST_EDITING" && skipPostEditing}>
                                              <span className="align-center">{SkipIcon}</span>
                                          </ConditionalBlock>
                                          <ConditionalBlock condition={!(phase.phaseType.originalEnum === "POST_EDITING" && skipPostEditing)}>
                                          {phase.closedDate !== "" ? (
                                            <button className="date step-cal flex-center readonly" aria-label="calender" aria-expanded="false" >
                                              {(phaseCompletedStatus(step,phase) || languageDetail.status === "COMPLETED") && phase.closedDate !== ""  &&                                                                                           
                                              GreenTickIcon }                                              
                                              <span style={{ padding: "0 5px" }} >
                                                {phase.closedDate.date}
                                              </span>
                                            </button>
                                          ) : phase.dueDate !== "" ? (                                            
                                            <button className="date" aria-label="calender" aria-expanded="false"  >                                              
                                              {"Due " + phase.dueDate.dateWithTime}                                            
                                            </button>
                                          ) : (
                                            ""
                                          )}
                                          </ConditionalBlock>
                                          <p className="1">{prop.getAssignee(phase)}</p>
                                          <button className="user mr-15">
                                         {phase.allowMultiAssignee ? ActiveMultiAssigneeIconWorkFlow : ActiveAssigneeManIcon}
                                          </button>
                                          {phase.approvalPhase ? (
                                            <div className="content">
                                              Approval
                                            </div>
                                          ) : (
                                            ""
                                          )}

                                          <Link to="#" className="arrow-refresh" >
                                            {!phase.allowRevision && (
                                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none" >
                                                <path d="M13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967L8.75736 0.696699C8.46447 0.403806 7.98959 0.403806 7.6967 0.696699C7.40381 0.989593 7.40381 1.46447 7.6967 1.75736L11.9393 6L7.6967 10.2426C7.40381 10.5355 7.40381 11.0104 7.6967 11.3033C7.98959 11.5962 8.46447 11.5962 8.75736 11.3033L13.5303 6.53033ZM0 6.75H13V5.25H0V6.75Z"
                                                  fill="#97A2AC" />
                                              </svg>
                                            )}
                                            {phase.allowRevision && (
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="19"
                                                height="19"
                                                viewBox="0 0 19 19"
                                                fill="none"
                                              >
                                                <path
                                                  d="M8.10432 11.8976L9.15748 12.9512H5.82617C4.91086 12.9512 4.03304 12.5876 3.38582 11.9403C2.7386 11.2931 2.375 10.4153 2.375 9.5C2.375 8.58469 2.7386 7.70687 3.38582 7.05965C4.03304 6.41243 4.91086 6.04883 5.82617 6.04883H6.49414V4.93555H5.82617C4.6156 4.93555 3.45462 5.41644 2.59862 6.27244C1.74261 7.12845 1.26172 8.28943 1.26172 9.5C1.26172 10.7106 1.74261 11.8716 2.59862 12.7276C3.45462 13.5836 4.6156 14.0645 5.82617 14.0645H9.15748L8.10432 15.1176L8.89178 15.9054L11.2894 13.5078L8.89178 11.1102L8.10432 11.8976Z"
                                                  fill="#97A2AC"
                                                ></path>
                                                <path
                                                  d="M13.1742 4.9367H9.84287L10.896 3.88354L10.1086 3.0957L7.71094 5.49334L10.1086 7.89098L10.896 7.10352L9.84287 6.04998H13.1742C14.0895 6.04998 14.9673 6.41359 15.6145 7.06081C16.2617 7.70803 16.6253 8.58584 16.6253 9.50115C16.6253 10.4165 16.2617 11.2943 15.6145 11.9415C14.9673 12.5887 14.0895 12.9523 13.1742 12.9523H12.4854V14.0656H13.1742C14.3847 14.0656 15.5457 13.5847 16.4017 12.7287C17.2577 11.8727 17.7386 10.7117 17.7386 9.50115C17.7386 8.29058 17.2577 7.1296 16.4017 6.2736C15.5457 5.4176 14.3847 4.9367 13.1742 4.9367Z"
                                                  fill="#97A2AC"
                                                ></path>
                                              </svg>
                                            )}
                                          </Link>
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {sourceReferenceData.length !== 0 ? (
                    <div className="btn-wrap relative">
                      <button
                        className="btn-bold fill-white reference"
                        id="reference"
                        onClick={referenceShow}
                        onKeyDown={(e) => ReferenceEscFocus(e)}
                        aria-label="Reference Materials"
                        aria-expanded="false"
                      >
                        Reference Materials
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="12"
                          viewBox="0 0 18 12"
                          fill="none"
                        >
                          <path
                            d="M0.5375 11.25V11.4H0.6875H11.375H11.525V11.25V10.0625V9.9125H11.375H0.6875H0.5375V10.0625V11.25ZM0.6875 5.1625H0.5375V5.3125V6.5V6.65H0.6875H17.3125H17.4625V6.5V5.3125V5.1625H17.3125H0.6875ZM13.9 0.5625V0.4125H13.75H0.6875H0.5375V0.5625V1.75V1.9H0.6875H13.75H13.9V1.75V0.5625Z"
                            fill="#1D4ED8"
                            stroke="#1D4ED8"
                            strokeWidth="0.3"
                          />
                        </svg>
                      </button>
                      <div className="download-display downloaddisplayId" onKeyDown={(e) => ReferenceModalFocus(e)}>
                        <p>Download File</p>
                        {sourceReferenceData.map((reference, index) => {
                          return (
                            <button
                              className="download-file"
                              key={index}
                              aria-label={reference.filename + " Download"}
                              onClick={() =>
                                downloadResource(
                                  reference.filename,
                                  reference.id
                                )
                              }
                            >
                              {reference.filename}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {latestProjectSourceFiles.id !== undefined ? (
                    <>
                      {masterDeliverableFile?.filename !== undefined ? (
                        <a
                          className="btn-bold"
                          href={downloadLangaugeTranslationLink()}
                          projectdetail-tour="download-btn"
                        >
                          Download Translations
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="17"
                            viewBox="0 0 20 17"
                            fill="none"
                          >
                            <path
                              d="M9.9987 10.875V1.375M9.9987 10.875L6.33203 7.70833M9.9987 10.875L13.6654 7.70833M0.832031 12.4583L1.40128 14.4256C1.50042 14.7682 1.72929 15.0723 2.0515 15.2896C2.37372 15.5069 2.77079 15.6249 3.17961 15.625H16.8178C17.2266 15.6249 17.6237 15.5069 17.9459 15.2896C18.2681 15.0723 18.497 14.7682 18.5961 14.4256L19.1654 12.4583"
                              stroke="#1D4ED8"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      ) : (
                        ""
                      )}
                      <button
                        className="btn-bold"
                        onClick={() =>
                          downloadBilinguals(
                            Constants.BILINGUAL_FILE_NAME +
                              `${projectId}-language_${langCode}` +
                              Constants.ZIP_FILE_EXTENSION
                          )
                        }
                      >
                        {" "}
                        {billingualDownloadError === ""
                          ? "Download Bilinguals"
                          : billingualDownloadError}
                        {downloadStart ? (
                          <div>
                            <RotatingLines
                              strokeColor="#d6d9df"
                              strokeWidth="5"
                              animationDuration="0.75"
                              width="16"
                              visible={true}
                            />
                          </div>
                        ) : billingualDownloadError === "" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="17"
                            viewBox="0 0 20 17"
                            fill="none"
                          >
                            <path
                              d="M9.9987 10.875V1.375M9.9987 10.875L6.33203 7.70833M9.9987 10.875L13.6654 7.70833M0.832031 12.4583L1.40128 14.4256C1.50042 14.7682 1.72929 15.0723 2.0515 15.2896C2.37372 15.5069 2.77079 15.6249 3.17961 15.625H16.8178C17.2266 15.6249 17.6237 15.5069 17.9459 15.2896C18.2681 15.0723 18.497 14.7682 18.5961 14.4256L19.1654 12.4583"
                              stroke="#1D4ED8"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          ""
                        )}
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="translation-box-sub-content">
                {syncErrors.length > 0 ? (
                  <>
                    <div className="header-second flex-center">
                      <span
                        aria-label="Asset Sync Error"
                        className="alert-text"
                      >
                        Asset Sync Error
                      </span>
                      <p>
                        {" "}
                        There's a problem with these assets. They're not moving
                        through the workflow.{" "}
                        <Link to="#">Click here for more information.</Link>
                      </p>
                      {Object.keys(syncErrors).length > 1 ? (
                        <button
                          className="blue-btn active"
                          onClick={() =>
                            retryMultipleSyncError("retry", "", contextId)
                          }
                        >
                          Retry Asset Sync
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                    {Object.keys(syncErrors).map((syncError, index) => {
                      return (
                        <div key={index}>
                          {syncErrors[syncError].syncErrorStatus !==
                          "SYNCING" ? (
                            <div className="header-third flex-center">
                              <Link to="#" className="download-file" tabIndex="-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="22"
                                  viewBox="0 0 18 22"
                                  fill="none"
                                >
                                  <path
                                    d="M6 12H12M6 16H9M1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7.342C17 7.07556 16.9467 6.81181 16.8433 6.56624C16.7399 6.32068 16.5885 6.09824 16.398 5.912L11.958 1.57C11.5844 1.20466 11.0826 1.00007 10.56 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V3Z"
                                    stroke="#4E6380"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                {syncErrors[syncError].asset.name}
                              </Link>
                              <div className="global-dropdown-select SyncError-expandLabel button-dropdown">
                                <button
                                  className="drop-down-btn gb-dropBtn"
                                  aria-expanded="false"
                                  onClick={() =>
                                    showSyncErrorAction(
                                      syncErrors[syncError].asset.id
                                    )
                                  }
                                  onKeyDown={(e) => syncErrorEscFocus(e)}
                                >
                                  <span>Actions</span>
                                  <svg
                                    style={
                                      syncErrorAction ===
                                      syncErrors[syncError].asset.id
                                        ? { transform: "rotate(-360deg)" }
                                        : { transform: "rotate(-180deg)" }
                                    }
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="6"
                                    viewBox="0 0 10 6"
                                    fill="none"
                                  >
                                    <path
                                      d="M1 1L5 5L9 1"
                                      stroke="#ABB5BE"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </button>
                                <div
                                  className={
                                    syncErrorAction ===
                                    syncErrors[syncError].asset.id
                                      ? "global-dropdown action-display2 show"
                                      : "global-dropdown action-display2"
                                  }
                                >
                                  <ul className="sync-error-action" onKeyDown={(e) => syncErrorModalFocus(e)}>
                                    <li>
                                      <button
                                        className="download-file"
                                        onClick={() => confirmSyncErrorActions("request-revision",syncErrors[syncError],syncError)}
                                      >
                                        Request Revision
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className="download-file"
                                        onClick={() =>
                                          confirmSyncErrorActions(
                                            "cancel",
                                            syncErrors[syncError],
                                            syncError
                                          )
                                        }
                                      >
                                        Cancel Translation
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className="download-file"
                                        onClick={() =>
                                          confirmSyncErrorActions(
                                            "retry",
                                            syncErrors[syncError],
                                            syncError
                                          )
                                        }
                                      >
                                        Retry
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className="download-file"
                                        onClick={() => generateTicket()}
                                      >
                                        Create Ticket
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      );
                    })}
                  </>
                ) : (
                  ""
                )}
              </div>
              {assetApproveErrorMsg ? <div className="p-10">
                <h4>Unable to complete request</h4>
                <p className="error ">{assetApproveErrorMsg}</p>
              </div> : ''}
              <div className="translate-main">
                {languageDetail?.steps?.map((step, stepIndex) => {
                  return (
                    <div
                      id={`step-${stepIndex}`}
                      key={stepIndex}
                      className={
                        showSteps.includes(step.stepNumber) ? "" : "hide"
                      }
                    >
                      <div className="translate-sub-main" key={stepIndex}>
                        <h4>{step.name}</h4>
                        <div className="translate-table mCalender">
                          <div className="flex header-first flex-nowrap">
                            <div>{translate("project_listing.name")}</div>
                            <div>{translate("project_listing.assignee")}</div>
                            <div>{translate("project_listing.status")}</div>
                            <div>{translate("project_listing.action")}</div>
                          </div>
                          <div className="">
                            <div className="wrap-translate-table">
                              {phaseDetail?.map((phase,phaseIndex) => {
                                var template = [];
                                if (phase.stepNumber === stepIndex + 1) {
                                  if (phase.phaseType.originalEnum === "WORK") {
                                    if (phase.work.current.length > 0) {
                                      template.push(
                                        <React.Fragment key={phaseIndex + 5}>
                                          <div
                                            className="translate-table-list work-current"
                                            key={phaseIndex}
                                          >
                                            <div className="head">
                                              {phase.phaseName!== ""?phase.phaseName:phase.phaseType.display}
                                            </div>
                                            <AssigneeEditableReadOnly
                                              step={step}
                                              phase={phase}
                                              phaseIndex={phaseIndex}
                                              name={phase.phaseName}
                                            />
                                            <div className="global-dropdown-block block-div m-0">
                                              {phase.phaseDueDate ? (
                                                <button className="progress progress-green">
                                                  {"Due " + dateUtil.format(phase.phaseDueDate)}
                                                </button>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                            <div className="btn-txt">
                                              {!phase.assignedToSilo ||
                                              (phase.assignedToSilo &&
                                                projectResource.projectVendorType ===
                                                  "INTERNAL") ? (
                                                options?.permissions
                                                  ?.PROJECT_CUD ? (
                                                  <button
                                                    className="blue-btn active white-space cancelTranslation"
                                                    onClick={() =>
                                                      showCancelTranslation(
                                                        phase
                                                      )
                                                    }
                                                  >
                                                    Cancel Translation
                                                  </button>
                                                ) : null
                                              ) : null}
                                            </div>
                                          </div>
                                          {phase.assignedToSilo || (roleArray.includes("ROLE_CUSTOMER_REVIEWER") &&  phase.assigneeType.code === "customer_user") ?
                                            (phase.work.current.length < 3 || (selectedPhaseFile.length !== 0 || expandAll)  || uplodResponseError !== null)
                                            ?
                                            phase.work.current.map(
                                                (entry, index) => {
                                                  return (
                                                    <React.Fragment key={index + 11}>
                                                      <div className="translate-sub-main-footer flex-center mar-bot16 file-upload">
                                                        <div className="left">
                                                          <div
                                                           className="download-file show-whitetext"
                                                          >
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width="18"
                                                              height="22"
                                                              viewBox="0 0 18 22"
                                                              fill="none"
                                                            >
                                                              <path
                                                                d="M6 12H12M6 16H9M1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7.342C17 7.07556 16.9467 6.81181 16.8433 6.56624C16.7399 6.32068 16.5885 6.09824 16.398 5.912L11.958 1.57C11.5844 1.20466 11.0826 1.00007 10.56 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V3Z"
                                                                stroke="#4E6380"
                                                                strokeWidth="1.3"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                              ></path>
                                                            </svg>
                                                            <div>
                                                            <span className="uplaodedfile-name" style={{display:"block"}}>
                                                              {getSourceFileData(entry).fileName}
                                                            </span>
                                                           {entry.files.FINAL ?
                                                           <>
                                                            <span style={{fontSize:"smaller"}}>
                                                              Translation "{entry.files.FINAL.documentFile.filename}"
                                                              uploaded on
                                                              <span className="font-zero">
                                                                <DateFormat date={entry.files.FINAL.documentFile.createdDate} />
                                                              </span>
                                                              <span aria-hidden="true" >
                                                                {" "}
                                                                <DateFormat date={entry.files.FINAL.documentFile.createdDate} />
                                                              </span>
                                                            </span>
                                                          </> : ''}
                                                          {uplodResponseError !== null && (uploadingFileName === getSourceFileData(entry).fileName || entry.sourceProjectAssetId === uplodResponseError?.sourceProjectAssetId) ?
                                                          <p className="error" dangerouslySetInnerHTML={{__html: uplodResponseError.message}}></p> : ''}
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div id={index} className="center" onDragOver={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        onDragLeave={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        onDrop={(e) => {setUplodResponseError(null);handleDrop(e,entry.id,entry.sourceProjectAssetId)}}>
                                                          <div className="flex wrap-dropdown file-btn mb-0">
                                                            <div className="input-file mb-0" style={{width:"auto"}}>
                                                              <input
                                                                type="file"
                                                                id={index}
                                                                disabled={uploadInProgress}
                                                                onChange={(e)=> {setUplodResponseError(null);phaseFileSelection(e,entry.id,entry.sourceProjectAssetId)}
                                                                }
                                                                onClick={(e) => clearValue(e)}
                                                              />
                                                              <label
                                                                className="file-button "
                                                                style={selectedPhaseFile.length !== 0 ?{width:"325px",textAlign:"center"}:{textAlign:"center"}}
                                                                htmlFor="files"
                                                              >
                                                                {selectedPhaseFile.length !== 0 && checkFileAdded(index)
                                                                  ? "Drag your file here or select to replace"
                                                                  : "Drag your file here or choose File"}
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="right flex-center">
                                                          <div className="global-dropdown-select mr-15 width-auto"></div>
                                                          <button
                                                            aria-label="Discussions"
                                                            className="chat mr-15"
                                                            onClick={() =>
                                                              showChatBox(true,entry)
                                                            }
                                                          >
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width="20"
                                                              height="20"
                                                              viewBox="0 0 20 20"
                                                              fill="none"
                                                            >
                                                              <path
                                                                d="M2.5 1.25C2.16848 1.25 1.85054 1.3817 1.61612 1.61612C1.3817 1.85054 1.25 2.16848 1.25 2.5V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H14.4825C15.1455 13.7501 15.7813 14.0136 16.25 14.4825L18.75 16.9825V2.5C18.75 2.16848 18.6183 1.85054 18.3839 1.61612C18.1495 1.3817 17.8315 1.25 17.5 1.25H2.5ZM17.5 0C18.163 0 18.7989 0.263392 19.2678 0.732233C19.7366 1.20107 20 1.83696 20 2.5V18.4913C20 18.6149 19.9633 18.7358 19.8945 18.8386C19.8257 18.9414 19.728 19.0215 19.6138 19.0687C19.4995 19.116 19.3737 19.1282 19.2525 19.104C19.1312 19.0797 19.0198 19.0201 18.9325 18.9325L15.3663 15.3663C15.1319 15.1318 14.814 15.0001 14.4825 15H2.5C1.83696 15 1.20107 14.7366 0.732233 14.2678C0.263392 13.7989 0 13.163 0 12.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L17.5 0Z"
                                                                fill="#1D4ED8"
                                                              ></path>
                                                              <path
                                                                d="M3.75 4.375C3.75 4.20924 3.81585 4.05027 3.93306 3.93306C4.05027 3.81585 4.20924 3.75 4.375 3.75H15.625C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375C16.25 4.54076 16.1842 4.69973 16.0669 4.81694C15.9497 4.93415 15.7908 5 15.625 5H4.375C4.20924 5 4.05027 4.93415 3.93306 4.81694C3.81585 4.69973 3.75 4.54076 3.75 4.375ZM3.75 7.5C3.75 7.33424 3.81585 7.17527 3.93306 7.05806C4.05027 6.94085 4.20924 6.875 4.375 6.875H15.625C15.7908 6.875 15.9497 6.94085 16.0669 7.05806C16.1842 7.17527 16.25 7.33424 16.25 7.5C16.25 7.66576 16.1842 7.82473 16.0669 7.94194C15.9497 8.05915 15.7908 8.125 15.625 8.125H4.375C4.20924 8.125 4.05027 8.05915 3.93306 7.94194C3.81585 7.82473 3.75 7.66576 3.75 7.5ZM3.75 10.625C3.75 10.4592 3.81585 10.3003 3.93306 10.1831C4.05027 10.0658 4.20924 10 4.375 10H10.625C10.7908 10 10.9497 10.0658 11.0669 10.1831C11.1842 10.3003 11.25 10.4592 11.25 10.625C11.25 10.7908 11.1842 10.9497 11.0669 11.0669C10.9497 11.1842 10.7908 11.25 10.625 11.25H4.375C4.20924 11.25 4.05027 11.1842 3.93306 11.0669C3.81585 10.9497 3.75 10.7908 3.75 10.625Z"
                                                                fill="#1D4ED8"
                                                              ></path>
                                                            </svg>
                                                          </button>
                                                          <div className="btn-txt"></div>
                                                        </div>
                                                      </div>
                                                      <div className="overview-file-upload">
                                                          { selectedPhaseFile.length > 0 && selectedPhaseFile[0].file &&  selectedPhaseFile.map((file,selectedFileIndex)=>{
                                                              if(file.id == index){
                                                                return (
                                                                  <div className="file-input " key={selectedFileIndex}>
                                                            <div className="uploading-file-list mb-0">
                                                              <div className="left-file-desc flex-center w-d100">
                                                                <div className="file-text">
                                                                  <span className="ext-name">
                                                                    {file?.file?.name}
                                                                  </span>
                                                                  <strong>
                                                                    <span className="file-size">
                                                                      {formatBytes(
                                                                        file?.file?.size
                                                                      )}
                                                                    </span>
                                                                  </strong>
                                                                  {file && !matchFileExtension(file?.file?.name,getSourceFileData(entry).fileName) ? 
                                                                  <span className="warning px-10">{Constants.INVALID_FILE_EXTENSION}</span> : ''}
                                                                  
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div
                                                              className={
                                                                showPhaseFileProgress == entry.id
                                                                  ? "right-progressbar w-d100"
                                                                  : "right-progressbar hide"
                                                              }
                                                            >
                                                              <CustomProgressBar
                                                                completed={
                                                                  phaseFileUploadProgress
                                                                }
                                                                labelLineHeight="1px"
                                                                labelSize="14px"
                                                                width="100%"
                                                                labelClassName="progressBarLabel"
                                                                borderRadius="30px"
                                                                labelAlignment="outside"
                                                                labelColor="rgba(0,0,0,0.87)"
                                                                height="10px"
                                                                className="file_upload_progress"
                                                                bgColor="#06B878"
                                                                baseBgColor="#D1DEF0"
                                                                ariaValuetext={
                                                                  phaseFileUploadProgress
                                                                }
                                                                aria-label=""
                                                                aria-valuenow={
                                                                  phaseFileUploadProgress
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                                )
                                                              }
                                                          
                                                          })
                                                        }
                                                      </div>
                                                      {
                                                        phase.work.current.length === index+1 ? 
                                                        <div>
                                                        <div className="flex justify-space-between border-bottom">
                                                         <div className="left ">
                                                          <ConditionalBlock  condition={ignoreValidation !== null}>
                                                              <>
                                                                <input type="checkbox" id="ignoreValidation" name="ignoreValidation" value="Ignore the validation and proceed" onChange={onIgnoreValidation} checked={ignoreValidation} />
                                                                <span className="inline-block">Ignore the validation and proceed</span>
                                                              </>
                                                          </ConditionalBlock>

                                                          </div>
                                                        <div className="right flex-center">
                                                          <button
                                                            className={
                                                              selectedPhaseFile.length>0
                                                                ? "blue-btn active"
                                                                : "blue-btn"
                                                            }
                                                            disabled={selectedPhaseFile.length === 0 || uploadDisabled}
                                                            onClick={() => uploadPhaseAsset('')}
                                                          >
                                                            Upload
                                                          </button>
                                                        </div>
                                                      </div></div> : ''
                                                      }
                                                    </React.Fragment>
                                                  );
                                                }
                                              ) :
                                                <div className="translate-sub-main-footer flex-center mar-bot16 multi-file-upload">
                                                <div className="multi-file-left">
                                               { setUploadBoxHeight()}{
                                               phase.work.current.map(
                                                (entry, index) => {
                                                  return (
                                                  <div className="files flex justify-center" > 
                                                    <div className="download-file show-whitetext">
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="18"
                                                          height="22"
                                                          viewBox="0 0 18 22"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M6 12H12M6 16H9M1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7.342C17 7.07556 16.9467 6.81181 16.8433 6.56624C16.7399 6.32068 16.5885 6.09824 16.398 5.912L11.958 1.57C11.5844 1.20466 11.0826 1.00007 10.56 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V3Z"
                                                            stroke="#4E6380"
                                                            strokeWidth="1.3"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                          ></path>
                                                        </svg>
                                                      <span className="uplaodedfile-name" style={{display:"block",width:'100%'}}>
                                                        {getSourceFileData(entry).fileName}
                                                      </span>
                                                  </div>
                                                  <div>
                                                      <button
                                                          aria-label="Discussions"
                                                          className="chat"
                                                          onClick={() =>
                                                            showChatBox(true,entry)
                                                          }
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                          >
                                                            <path
                                                              d="M2.5 1.25C2.16848 1.25 1.85054 1.3817 1.61612 1.61612C1.3817 1.85054 1.25 2.16848 1.25 2.5V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H14.4825C15.1455 13.7501 15.7813 14.0136 16.25 14.4825L18.75 16.9825V2.5C18.75 2.16848 18.6183 1.85054 18.3839 1.61612C18.1495 1.3817 17.8315 1.25 17.5 1.25H2.5ZM17.5 0C18.163 0 18.7989 0.263392 19.2678 0.732233C19.7366 1.20107 20 1.83696 20 2.5V18.4913C20 18.6149 19.9633 18.7358 19.8945 18.8386C19.8257 18.9414 19.728 19.0215 19.6138 19.0687C19.4995 19.116 19.3737 19.1282 19.2525 19.104C19.1312 19.0797 19.0198 19.0201 18.9325 18.9325L15.3663 15.3663C15.1319 15.1318 14.814 15.0001 14.4825 15H2.5C1.83696 15 1.20107 14.7366 0.732233 14.2678C0.263392 13.7989 0 13.163 0 12.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L17.5 0Z"
                                                              fill="#1D4ED8"
                                                            ></path>
                                                            <path
                                                              d="M3.75 4.375C3.75 4.20924 3.81585 4.05027 3.93306 3.93306C4.05027 3.81585 4.20924 3.75 4.375 3.75H15.625C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375C16.25 4.54076 16.1842 4.69973 16.0669 4.81694C15.9497 4.93415 15.7908 5 15.625 5H4.375C4.20924 5 4.05027 4.93415 3.93306 4.81694C3.81585 4.69973 3.75 4.54076 3.75 4.375ZM3.75 7.5C3.75 7.33424 3.81585 7.17527 3.93306 7.05806C4.05027 6.94085 4.20924 6.875 4.375 6.875H15.625C15.7908 6.875 15.9497 6.94085 16.0669 7.05806C16.1842 7.17527 16.25 7.33424 16.25 7.5C16.25 7.66576 16.1842 7.82473 16.0669 7.94194C15.9497 8.05915 15.7908 8.125 15.625 8.125H4.375C4.20924 8.125 4.05027 8.05915 3.93306 7.94194C3.81585 7.82473 3.75 7.66576 3.75 7.5ZM3.75 10.625C3.75 10.4592 3.81585 10.3003 3.93306 10.1831C4.05027 10.0658 4.20924 10 4.375 10H10.625C10.7908 10 10.9497 10.0658 11.0669 10.1831C11.1842 10.3003 11.25 10.4592 11.25 10.625C11.25 10.7908 11.1842 10.9497 11.0669 11.0669C10.9497 11.1842 10.7908 11.25 10.625 11.25H4.375C4.20924 11.25 4.05027 11.1842 3.93306 11.0669C3.81585 10.9497 3.75 10.7908 3.75 10.625Z"
                                                              fill="#1D4ED8"
                                                            ></path>
                                                          </svg>
                                                        </button>
                                                      </div>
                                                   {entry.files.FINAL ? 
                                                   <> 
                                                    <span style={{fontSize:"smaller"}}>
                                                      Translation "{entry.files.FINAL.documentFile.filename}"
                                                      uploaded on
                                                      <span className="font-zero">
                                                        <DateFormat date={entry.files.FINAL.documentFile.createdDate} />
                                                      </span>
                                                      <span aria-hidden="true" >
                                                        {" "}
                                                        <DateFormat date={entry.files.FINAL.documentFile.createdDate} />
                                                      </span>
                                                    </span>
                                                  </> : ''}
                                                  
                                                  </div> 
                                                  
                                              )}
                                               )}
                                               </div>
                                               <div id="multifile-dropDown" className="right flex-center" 
                                               onDragOver={(e) => {
                                                e.preventDefault();
                                                e.target.style.border = "4px dotted green";
                                              }}
                                              onDragLeave={(e) => {
                                                e.preventDefault();
                                                e.target.style.border = "2px dashed #c0c0c0";
                                              }}
                                              onDragEnd={(e) => {
                                                e.preventDefault();
                                              }}
                                              onDrop={(e) => {setUplodResponseError(null);handleDropMultiFile(e,phase.work.current)}}
                                               >
                                               <div  className="center" >
                                                          <div className="flex wrap-dropdown file-btn mb-0">
                                                            <div className="input-file mb-0" style={{width:"auto"}}>
                                                              <input
                                                                type="file"
                                                                multiple
                                                                disabled={uploadInProgress}
                                                                onChange={(e)=> {setUplodResponseError(null);phaseFileMultiSelection(e,phase.work.current)}
                                                                }
                                                              />
                                                              <label
                                                                className="file-button "
                                                                style={selectedPhaseFile.length !== 0 ?{width:"325px",textAlign:"center"}:{textAlign:"center"}}
                                                                htmlFor="files"
                                                              >
                                                                {selectedPhaseFile.length !== 0 && checkFileAdded()
                                                                  ? "Drag your file here or select to replace"
                                                                  : "Drag your file here or choose File"}
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                               </div>
                                            </div>   
                                            
                                            : phase.work.current.map(
                                                (entry, index) => {
                                                  return (
                                                    <div
                                                      className="translate-sub-main-footer flex-center 1"
                                                      key={index}
                                                    >
                                                      <div className="left">
                                                        <div
                                                          className="download-file show-whitetext"
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="18"
                                                            height="22"
                                                            viewBox="0 0 18 22"
                                                            fill="none"
                                                          >
                                                            <path
                                                              d="M6 12H12M6 16H9M1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7.342C17 7.07556 16.9467 6.81181 16.8433 6.56624C16.7399 6.32068 16.5885 6.09824 16.398 5.912L11.958 1.57C11.5844 1.20466 11.0826 1.00007 10.56 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V3Z"
                                                              stroke="#4E6380"
                                                              strokeWidth="1.3"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                            ></path>
                                                          </svg>
                                                          {entry.name}
                                                        </div>
                                                        
                                                      </div>
                                                      <div className="right flex-center">
                                                        <div className="global-dropdown-select mr-15 width-auto">
                                                          <button
                                                            aria-label="download"
                                                            className="download mar-top6 downloadLangdoc"
                                                            aria-expanded={dropDownOptionId === entry.id ? "true" : "false"}
                                                            onClick={() =>
                                                              showDownloadOptions(
                                                                entry.id
                                                              )
                                                            }
                                                            onKeyDown={(e) => handleEscFocus(e)}
                                                          >
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width="20"
                                                              height="17"
                                                              viewBox="0 0 20 17"
                                                              fill="none"
                                                            >
                                                              <path
                                                                d="M9.9987 10.875V1.375M9.9987 10.875L6.33203 7.70833M9.9987 10.875L13.6654 7.70833M0.832031 12.4583L1.40128 14.4256C1.50042 14.7682 1.72929 15.0723 2.0515 15.2896C2.37372 15.5069 2.77079 15.6249 3.17961 15.625H16.8178C17.2266 15.6249 17.6237 15.5069 17.9459 15.2896C18.2681 15.0723 18.497 14.7682 18.5961 14.4256L19.1654 12.4583"
                                                                stroke="#1D4ED8"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                              ></path>
                                                            </svg>
                                                          </button>

                                                          <div
                                                            className={
                                                              dropDownOptionId ===
                                                              entry.id
                                                                ? "global-dropdown action-display2 width246 show"
                                                                : "global-dropdown action-display2 width246 hide"
                                                            }
                                                            onKeyDown={(e) => handleModalFocus(e)}
                                                          >
                                                            <ul className="addDynamicId">
                                                            {/* <RenderDownloadMenuItems asset={entry}/> */}
                                                            <FileDownloadMenuItems 
                                                            entry={entry} 
                                                            projectId={param.id} 
                                                            translatedAsset={targetAssetData}
                                                            sourcePreviewBundle={sourcePreviewBundle}
                                                            targetPreviewBundle={targetPreviewBundle}
                                                            />
                                                            </ul>
                                                          </div>
                                                        </div>
                                                        <button
                                                          aria-label="Discussions"
                                                          className="chat"
                                                          onClick={() =>
                                                            showChatBox(true,entry)
                                                          }
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                          >
                                                            <path
                                                              d="M2.5 1.25C2.16848 1.25 1.85054 1.3817 1.61612 1.61612C1.3817 1.85054 1.25 2.16848 1.25 2.5V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H14.4825C15.1455 13.7501 15.7813 14.0136 16.25 14.4825L18.75 16.9825V2.5C18.75 2.16848 18.6183 1.85054 18.3839 1.61612C18.1495 1.3817 17.8315 1.25 17.5 1.25H2.5ZM17.5 0C18.163 0 18.7989 0.263392 19.2678 0.732233C19.7366 1.20107 20 1.83696 20 2.5V18.4913C20 18.6149 19.9633 18.7358 19.8945 18.8386C19.8257 18.9414 19.728 19.0215 19.6138 19.0687C19.4995 19.116 19.3737 19.1282 19.2525 19.104C19.1312 19.0797 19.0198 19.0201 18.9325 18.9325L15.3663 15.3663C15.1319 15.1318 14.814 15.0001 14.4825 15H2.5C1.83696 15 1.20107 14.7366 0.732233 14.2678C0.263392 13.7989 0 13.163 0 12.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L17.5 0Z"
                                                              fill="#1D4ED8"
                                                            ></path>
                                                            <path
                                                              d="M3.75 4.375C3.75 4.20924 3.81585 4.05027 3.93306 3.93306C4.05027 3.81585 4.20924 3.75 4.375 3.75H15.625C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375C16.25 4.54076 16.1842 4.69973 16.0669 4.81694C15.9497 4.93415 15.7908 5 15.625 5H4.375C4.20924 5 4.05027 4.93415 3.93306 4.81694C3.81585 4.69973 3.75 4.54076 3.75 4.375ZM3.75 7.5C3.75 7.33424 3.81585 7.17527 3.93306 7.05806C4.05027 6.94085 4.20924 6.875 4.375 6.875H15.625C15.7908 6.875 15.9497 6.94085 16.0669 7.05806C16.1842 7.17527 16.25 7.33424 16.25 7.5C16.25 7.66576 16.1842 7.82473 16.0669 7.94194C15.9497 8.05915 15.7908 8.125 15.625 8.125H4.375C4.20924 8.125 4.05027 8.05915 3.93306 7.94194C3.81585 7.82473 3.75 7.66576 3.75 7.5ZM3.75 10.625C3.75 10.4592 3.81585 10.3003 3.93306 10.1831C4.05027 10.0658 4.20924 10 4.375 10H10.625C10.7908 10 10.9497 10.0658 11.0669 10.1831C11.1842 10.3003 11.25 10.4592 11.25 10.625C11.25 10.7908 11.1842 10.9497 11.0669 11.0669C10.9497 11.1842 10.7908 11.25 10.625 11.25H4.375C4.20924 11.25 4.05027 11.1842 3.93306 11.0669C3.81585 10.9497 3.75 10.7908 3.75 10.625Z"
                                                              fill="#1D4ED8"
                                                            ></path>
                                                          </svg>
                                                        </button>
                                                        {/* <div className="btn-txt">
                                                    {!phase.assignedToSilo ||
                                                    (phase.assignedToSilo &&
                                                      projectResource.projectVendorType ===
                                                        "INTERNAL") ? (
                                                      options.permissions
                                                        .PROJECT_CUD ? (
                                                        <button className="btn" onClick={()=>showCancelTranslation(phase)}>
                                                          Cancel Translation
                                                        </button>
                                                      ) : null
                                                    ) : null}
                                                  </div> */}
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                        </React.Fragment>
                                      );
                                    } else if (phase.work.complete.length > 0) {
                                      template.push(
                                        <div
                                          className="translate-table-list work-complete"
                                          key={phaseIndex + 1}
                                        >
                                          <div className="head">
                                            {phase.phaseName!== ""?phase.phaseName:phase.phaseType.display}
                                          </div>

                                          <AssigneeEditableReadOnly
                                            step={step}
                                            phase={phase}
                                            phaseIndex={phaseIndex}
                                            name={phase.phaseName}
                                            assigneName={prop.getAssignee(phase)}
                                          />

                                          <div className="block-div">
                                            <button
                                              className="progress readonly progress-green"
                                              tabIndex="-1"
                                            >
                                              {phase.phaseClosedDate ? "Completed " + dateUtil.format(phase.phaseClosedDate) :
                                                  phase.phaseDueDate ? "Due " + dateUtil.format(phase.phaseDueDate) : ""}
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    }
                                    if (
                                      Object.keys(phase.revision.complete)
                                        .length !== 0 &&
                                      phase.revision.complete[1] !== undefined
                                    ) {
                                      let key = Object.keys(
                                        phase.revision.complete
                                      )[0];
                                      let revisionArray =
                                        phase.revision.complete[key];
                                      Object.keys(phase.revision.complete).map(
                                        (round, roundNum) => {
                                          template.push(
                                            <div
                                              className={`translate-table-list work-revision-complete ${round}`}
                                              key={roundNum + 3 + phaseIndex}
                                            >
                                              <div className="head">
                                                {"Revision " + Number(round)}
                                              </div>
                                              <div className="name 3">
                                              {phase.revisionPhaseTasks && phase.revisionPhaseTasks.REVISE_PROJECT_ASSETS && phase.revisionPhaseTasks.REVISE_PROJECT_ASSETS.assigneeUserName}
                                              </div>
                                              <div className="block-div">
                                                {phase.revision.complete[
                                                  round
                                                ][0]?.closeDate !== "" ? (
                                                  <button className="progress progress-green">
                                                    {`Completed ${dateUtil.format(phase.revision.complete[round][0]?.closedDate)}`}
                                                  </button>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                              {/* <div></div> */}
                                            </div>
                                          );
                                        }
                                      );
                                    }
                                    if (phase.revision.current.length > 0) {
                                      template.push(
                                        <React.Fragment key={phaseIndex + 2}>
                                          <div
                                            className="translate-table-list work-revision-current"
                                            key={phaseIndex}
                                          >
                                            <div className="head">
                                              In Revision
                                            </div>
                                            <div className="name 4">
                                              <AssigneeEditableReadOnly
                                                step={step}
                                                phase={phase}
                                                phaseIndex={phaseIndex}
                                                name={"In Revision"}
                                              />
                                            </div>
                                            <div className="block-div"></div>
                                            {phase.assignedToSilo ? (
                                              <div>
                                                <div className="global-dropdown-select add-expandLabel button-dropdown">
                                                  <button
                                                    className={
                                                      phaseId ===
                                                      phase.phaseId +
                                                        "-" +
                                                        phaseIndex
                                                        ? "drop-down-btn gb-dropBtn active"
                                                        : "drop-down-btn gb-dropBtn"
                                                    }
                                                    projectdetail-tour="action-btn"
                                                    aria-expanded="false"
                                                    onClick={() =>
                                                      showAction(
                                                        phase.phaseId +
                                                          "-" +
                                                          phaseIndex
                                                      )
                                                    }onKeyDown={(e) => actionEscFocus(e)}
                                                   
                                                  >
                                                    <span className="actionReview">
                                                      Actions
                                                    </span>
                                                    <svg
                                                      style={
                                                        !(
                                                          phaseId ===
                                                          phase.phaseId +
                                                            "-" +
                                                            phaseIndex
                                                        )
                                                          ? {
                                                              transform:
                                                                "rotate(-360deg)",
                                                            }
                                                          : {
                                                              transform:
                                                                "rotate(-180deg)",
                                                            }
                                                      }
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="10"
                                                      height="6"
                                                      viewBox="0 0 10 6"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M1 1L5 5L9 1"
                                                        stroke="#ABB5BE"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                      ></path>
                                                    </svg>
                                                  </button>
                                                  <div
                                                    className={
                                                      phaseId ===
                                                      phase.phaseId +
                                                        "-" +
                                                        phaseIndex
                                                        ? "global-dropdown action-display2"
                                                        : "global-dropdown action-display2 hide"
                                                    }
                                                  >
                                                    <ul onKeyDown={(e) => actionModalFocus(e)}>
                                                      {/* {requestRevisionPossible() ? (
                                                          <li>
                                                            <Link
                                                              onClick={() =>
                                                                toggleRequestRevision(
                                                                  true
                                                                )
                                                              }
                                                            >
                                                              Request Revision
                                                            </Link>
                                                          </li>
                                                        ) : null} */}
                                                      {phase.assignedToSilo ? (
                                                        <li>
                                                          <Link
                                                            onClick={(e) =>
                                                              uploadTranslation(
                                                                phase?.revision
                                                                  ?.current[0]
                                                                  ?.source.id,
                                                                phase?.revision,
                                                                "IN_REVISION"
                                                              )
                                                            }
                                                          >
                                                            Upload Revised
                                                            Translation
                                                          </Link>
                                                        </li>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </ul>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            {/* <div></div> */}
                                          </div>
                                          {phase.revision.current.map(
                                            (entry, i) => {
                                              return (
                                                <div
                                                  className="translate-sub-main-footer flex-center"
                                                  key={i + 2}
                                                >
                                                  <div className="left">
                                                    <div
                                                      className="download-file show-whitetext"
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="22"
                                                        viewBox="0 0 18 22"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M6 12H12M6 16H9M1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7.342C17 7.07556 16.9467 6.81181 16.8433 6.56624C16.7399 6.32068 16.5885 6.09824 16.398 5.912L11.958 1.57C11.5844 1.20466 11.0826 1.00007 10.56 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V3Z"
                                                          stroke="#4E6380"
                                                          strokeWidth="1.3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        ></path>
                                                      </svg>
                                                      {entry.name}
                                                    </div>
                                                  </div>
                                                  <div className="right flex-center">
                                                    <button
                                                      aria-label="user"
                                                      className="user mr-15"
                                                    >
                                                      {phase.phaseIsMultiAssignee ? 
                                                          <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="24"
                                                          height="19"
                                                          viewBox="0 0 24 19"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                                            fill="#64748B"
                                                            stroke="#64748B"
                                                            strokeWidth="0.2"
                                                          />
                                                        </svg> : 
                                                        <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="22"
                                                        height="22"
                                                        viewBox="0 0 22 22"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M11 5.5C10.3201 5.5 9.65552 5.70161 9.09023 6.07932C8.52494 6.45704 8.08434 6.9939 7.82417 7.62203C7.56399 8.25015 7.49592 8.94131 7.62855 9.60812C7.76119 10.2749 8.08858 10.8874 8.56932 11.3682C9.05007 11.8489 9.66257 12.1763 10.3294 12.3089C10.9962 12.4416 11.6874 12.3735 12.3155 12.1133C12.9436 11.8532 13.4805 11.4126 13.8582 10.8473C14.2359 10.282 14.4375 9.61737 14.4375 8.9375C14.4375 8.02582 14.0753 7.15148 13.4307 6.50682C12.786 5.86216 11.9117 5.5 11 5.5ZM11 11C10.5921 11 10.1933 10.879 9.85414 10.6524C9.51496 10.4258 9.25061 10.1037 9.0945 9.72678C8.93839 9.34991 8.89755 8.93521 8.97713 8.53513C9.05671 8.13504 9.25315 7.76754 9.54159 7.47909C9.83004 7.19065 10.1975 6.99421 10.5976 6.91463C10.9977 6.83505 11.4124 6.87589 11.7893 7.032C12.1662 7.1881 12.4883 7.45246 12.7149 7.79164C12.9415 8.13081 13.0625 8.52958 13.0625 8.9375C13.062 9.48434 12.8445 10.0086 12.4578 10.3953C12.0711 10.782 11.5468 10.9995 11 11Z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                        <path
                                                          d="M11 1.375C9.09636 1.375 7.23546 1.9395 5.65264 2.99711C4.06982 4.05471 2.83616 5.55793 2.10766 7.31667C1.37917 9.07541 1.18856 11.0107 1.55995 12.8777C1.93133 14.7448 2.84802 16.4598 4.1941 17.8059C5.54018 19.152 7.25519 20.0687 9.12226 20.4401C10.9893 20.8114 12.9246 20.6208 14.6833 19.8923C16.4421 19.1638 17.9453 17.9302 19.0029 16.3474C20.0605 14.7645 20.625 12.9036 20.625 11C20.6221 8.44818 19.6071 6.00172 17.8027 4.19731C15.9983 2.39291 13.5518 1.37791 11 1.375ZM6.875 18.1342V17.1875C6.87555 16.6407 7.09302 16.1164 7.4797 15.7297C7.86638 15.343 8.39066 15.1255 8.9375 15.125H13.0625C13.6093 15.1255 14.1336 15.343 14.5203 15.7297C14.907 16.1164 15.1245 16.6407 15.125 17.1875V18.1342C13.8732 18.8651 12.4496 19.2503 11 19.2503C9.5504 19.2503 8.12683 18.8651 6.875 18.1342ZM16.4945 17.1366C16.4808 16.2349 16.1134 15.3746 15.4714 14.7411C14.8295 14.1076 13.9644 13.7517 13.0625 13.75H8.9375C8.03563 13.7517 7.17052 14.1076 6.52857 14.7411C5.88661 15.3746 5.51921 16.2349 5.5055 17.1366C4.25877 16.0234 3.37957 14.5577 2.98433 12.9337C2.58909 11.3097 2.69645 9.60392 3.29219 8.04228C3.88794 6.48063 4.94397 5.13677 6.32045 4.18864C7.69693 3.24051 9.32893 2.73283 11.0003 2.73283C12.6718 2.73283 14.3038 3.24051 15.6802 4.18864C17.0567 5.13677 18.1128 6.48063 18.7085 8.04228C19.3042 9.60392 19.4116 11.3097 19.0164 12.9337C18.6211 14.5577 17.7419 16.0234 16.4952 17.1366H16.4945Z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                      </svg>
                                                        }
                                                    </button>
                                                    <div className="global-dropdown-select mr-15 width-auto">
                                                      <button
                                                        aria-label="download"
                                                        className="download mar-top6 2"
                                                        onClick={() =>
                                                          showDownloadOptions(
                                                            entry.id
                                                          )
                                                        }
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="20"
                                                          height="17"
                                                          viewBox="0 0 20 17"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M9.9987 10.875V1.375M9.9987 10.875L6.33203 7.70833M9.9987 10.875L13.6654 7.70833M0.832031 12.4583L1.40128 14.4256C1.50042 14.7682 1.72929 15.0723 2.0515 15.2896C2.37372 15.5069 2.77079 15.6249 3.17961 15.625H16.8178C17.2266 15.6249 17.6237 15.5069 17.9459 15.2896C18.2681 15.0723 18.497 14.7682 18.5961 14.4256L19.1654 12.4583"
                                                            stroke="#1D4ED8"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                          ></path>
                                                        </svg>
                                                      </button>
                                                      <div
                                                        className={
                                                          dropDownOptionId ===
                                                          entry.id
                                                            ? "global-dropdown action-display2 width246 show"
                                                            : "global-dropdown action-display2 width246 hide"
                                                        }
                                                      >
                                                        <ul className="addDynamicId">
                                                        {/* <RenderDownloadMenuItems asset={entry}/> */}
                                                        <FileDownloadMenuItems 
                                                            entry={entry} 
                                                            projectId={param.id} 
                                                            translatedAsset={targetAssetData}
                                                            sourcePreviewBundle={sourcePreviewBundle}
                                                            targetPreviewBundle={targetPreviewBundle}/>
                                                        </ul>
                                                        
                                                      </div>
                                                    </div>
                                                    <button
                                                      aria-label="Discussions"
                                                      className="chat mr-15"
                                                      onClick={() =>
                                                        showChatBox(true,entry)
                                                      }
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M2.5 1.25C2.16848 1.25 1.85054 1.3817 1.61612 1.61612C1.3817 1.85054 1.25 2.16848 1.25 2.5V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H14.4825C15.1455 13.7501 15.7813 14.0136 16.25 14.4825L18.75 16.9825V2.5C18.75 2.16848 18.6183 1.85054 18.3839 1.61612C18.1495 1.3817 17.8315 1.25 17.5 1.25H2.5ZM17.5 0C18.163 0 18.7989 0.263392 19.2678 0.732233C19.7366 1.20107 20 1.83696 20 2.5V18.4913C20 18.6149 19.9633 18.7358 19.8945 18.8386C19.8257 18.9414 19.728 19.0215 19.6138 19.0687C19.4995 19.116 19.3737 19.1282 19.2525 19.104C19.1312 19.0797 19.0198 19.0201 18.9325 18.9325L15.3663 15.3663C15.1319 15.1318 14.814 15.0001 14.4825 15H2.5C1.83696 15 1.20107 14.7366 0.732233 14.2678C0.263392 13.7989 0 13.163 0 12.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L17.5 0Z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                        <path
                                                          d="M3.75 4.375C3.75 4.20924 3.81585 4.05027 3.93306 3.93306C4.05027 3.81585 4.20924 3.75 4.375 3.75H15.625C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375C16.25 4.54076 16.1842 4.69973 16.0669 4.81694C15.9497 4.93415 15.7908 5 15.625 5H4.375C4.20924 5 4.05027 4.93415 3.93306 4.81694C3.81585 4.69973 3.75 4.54076 3.75 4.375ZM3.75 7.5C3.75 7.33424 3.81585 7.17527 3.93306 7.05806C4.05027 6.94085 4.20924 6.875 4.375 6.875H15.625C15.7908 6.875 15.9497 6.94085 16.0669 7.05806C16.1842 7.17527 16.25 7.33424 16.25 7.5C16.25 7.66576 16.1842 7.82473 16.0669 7.94194C15.9497 8.05915 15.7908 8.125 15.625 8.125H4.375C4.20924 8.125 4.05027 8.05915 3.93306 7.94194C3.81585 7.82473 3.75 7.66576 3.75 7.5ZM3.75 10.625C3.75 10.4592 3.81585 10.3003 3.93306 10.1831C4.05027 10.0658 4.20924 10 4.375 10H10.625C10.7908 10 10.9497 10.0658 11.0669 10.1831C11.1842 10.3003 11.25 10.4592 11.25 10.625C11.25 10.7908 11.1842 10.9497 11.0669 11.0669C10.9497 11.1842 10.7908 11.25 10.625 11.25H4.375C4.20924 11.25 4.05027 11.1842 3.93306 11.0669C3.81585 10.9497 3.75 10.7908 3.75 10.625Z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                      </svg>
                                                    </button>
                                                    <div className="btn-txt 4">
                                                      {!entry.lineByLineEnabled  ? (
                                                        <button
                                                          className="btn width98 1"
                                                          onClick={() =>
                                                            createReviewLink(
                                                              entry.currentPhaseId,
                                                              entry,
                                                              targetAssetData,
                                                              phase,"view"
                                                            )
                                                          }
                                                        >
                                                         { phase.assignedToSilo? 'Review' : 'View'}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="btn width98 1"
                                                          onClick={() =>
                                                            createReviewLink(
                                                              entry.currentPhaseId,
                                                              entry,
                                                              targetAssetData,
                                                              phase,'review'
                                                            )
                                                          }
                                                        >
                                                           { phase.assignedToSilo? 'Review' : 'View'}
                                                        </button>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </React.Fragment>
                                      );
                                    }
                                  } else if (
                                    phase.phaseType.originalEnum === "REVIEW" || phase.phaseType.originalEnum === "POST_EDITING"
                                  ) {
                                    if (!phase.review.current.length) {
                                      let reviewKey = Object.keys(
                                        phase.review.current
                                      );

                                      var lastPhase = Object.keys(
                                        phase?.review?.current
                                      ).map((round, roundNum) => {
                                        return (
                                          <div
                                            key={roundNum + "-" + phase.phaseId}
                                            className={'review-current round-'+round}
                                          >
                                            <div className="translate-table-list">
                                              <div className="head">
                                                                                                                                  
                                                {phase.phaseName!== ""?phase.phaseName:phase.phaseType.display}{" "}

                                                {round > 1
                                                  ? round +
                                                    getOrdinal(round) +
                                                    " Round"
                                                  : ""}
                                              </div>
                                              <div className={`name global-dropdown-select max-heightInherit ${phase.phaseNumber}`}>
                                                <AssigneeEditableReadOnly
                                                  step={step}
                                                  phase={phase}
                                                  phaseIndex={phaseIndex}
                                                  round={round}
                                                  name={phase.phaseName}
                                                />
                                              </div>
                                              <div className="global-dropdown-block m-0 0 firstCal">
                                                <button
                                                  id='calFirstFocus'
                                                  aria-expanded={calPhaseId === phase.phaseId + "-" + roundNum ? 'true':'false'}
                                                  aria-label={phase.phaseDueDate !== '' ?  `due date ${dateUtil.format(phase.phaseDueDate)} selected`:'no due date selected'}
                                                  className={
                                                    !options.roleSet
                                                      ?.customerType ||
                                                    !phase.assignedToSilo ||
                                                    !options.permissions
                                                      ?.PROJECT_CUD ||
                                                    !doesPhaseHaveOpenReviewAssets(
                                                      phase.phaseId
                                                    )
                                                      ? "progress readonly progress-green"
                                                      : "progress progress-green"
                                                  }
                                                  onClick={
                                                    !options.roleSet
                                                      ?.customerType ||
                                                    !phase.assignedToSilo ||
                                                    !options.permissions
                                                      ?.PROJECT_CUD ||
                                                    !doesPhaseHaveOpenReviewAssets(
                                                      phase.phaseId
                                                    )
                                                      ? null
                                                      : () =>
                                                          showDueDateCal(
                                                            phase.phaseId +
                                                              "-" +
                                                              roundNum
                                                          )
                                                  }
                                                  
                                                >
                                                  { phase.phaseType.originalEnum === "POST_EDITING" && skipPostEditing? ("Skipped") : (phase.phaseClosedDate &&
                                                  phase.phaseClosedDate !== "" ? ("Completed " + dateUtil.format(phase.phaseClosedDate)) :
                                                      phase.phaseDueDate ? ("Due " + dateUtil.format(phase.phaseDueDate)) : (
                                                    <>
                                                      <svg
                                                        className="calender-icon"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 14 14"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                                                          fill="#3564EB"
                                                        ></path>
                                                      </svg>
                                                      <span
                                                        style={{
                                                          paddingLeft: "5px",
                                                        }}
                                                      >
                                                        No Due Date
                                                      </span>
                                                    </>
                                                  ))}
                                                </button>

                                                {calPhaseId ===
                                                phase.phaseId +
                                                  "-" +
                                                  roundNum ? (
                                                  <div
                                                    ref={refCalendar}
                                                    onKeyDown={(e) => {
                                                      closeCalendar(e);
                                                    }}
                                                    style={{
                                                      position: "absolute",
                                                      zIndex: "9",
                                                    }}
                                                  >
                                                    <Calendar
                                                      minDate={new Date()}
                                                      className="dashCalendarDeadLine"
                                                      nextAriaLabel={nextAriaLabel}
                                                      prevAriaLabel={prevAriaLabel}
                                                      next2AriaLabel={next2AriaLabel}
                                                      prev2AriaLabel={prev2AriaLabel}
                                                      onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
                                                      value={
                                                        phase.phaseDueDate
                                                          ? new Date(
                                                              phase.phaseDueDate.utcTimestamp
                                                            )
                                                          : new Date()
                                                      }
                                                      onChange={(e) =>
                                                        setReviewPhaseDueDate(
                                                          e,
                                                          phase
                                                        )
                                                      }
                                                    ></Calendar>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                              {phase.assignedToSilo ? (
                                                <div>
                                                  <div className="global-dropdown-select add-expandLabel button-dropdown">
                                                    <button
                                                      className={
                                                        phaseId ===
                                                        phase.phaseId +
                                                          "-" +
                                                          roundNum
                                                          ? "drop-down-btn gb-dropBtn active"
                                                          : "drop-down-btn gb-dropBtn"
                                                      }
                                                      projectdetail-tour="action-btn"
                                                      aria-expanded={
                                                        phaseId === phase.phaseId + "-" + roundNum ? "true" : "false"
                                                      }
                                                      onClick={() =>
                                                        showAction(
                                                          phase.phaseId +
                                                            "-" +
                                                            roundNum
                                                        )
                                                      }
                                                      onKeyDown={(e) => actionEscFocus(e)}
                                                    >
                                                      <span className="actionReview">
                                                        Actions
                                                      </span>
                                                      <svg
                                                        style={
                                                          !(
                                                            phaseId ===
                                                            phase.phaseId +
                                                              "-" +
                                                              roundNum
                                                          )
                                                            ? {
                                                                transform:
                                                                  "rotate(-360deg)",
                                                              }
                                                            : {
                                                                transform:
                                                                  "rotate(-180deg)",
                                                              }
                                                        }
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="10"
                                                        height="6"
                                                        viewBox="0 0 10 6"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M1 1L5 5L9 1"
                                                          stroke="#ABB5BE"
                                                          strokeWidth="2"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        ></path>
                                                      </svg>
                                                    </button>
                                                    <div
                                                      className={
                                                        phaseId ===
                                                        phase.phaseId +
                                                          "-" +
                                                          roundNum
                                                          ? "global-dropdown action-display2"
                                                          : "global-dropdown action-display2 hide"
                                                      }
                                                    >
                                                      <ul onKeyDown={(e) => actionModalFocus(e)}>
                                                        {requestRevisionPossible() ? (
                                                          <li>
                                                            <Link
                                                              onClick={() =>
                                                                toggleRequestRevision(
                                                                  true
                                                                )
                                                              }
                                                             
                                                            >
                                                              Request Revision
                                                            </Link>
                                                          </li>
                                                        ) : null}
                                                        {<ConditionalBlock condition={(options.permissions?.PROJECT_CUD || options.roleSet?.vendorType)}>
                                                          <li>
                                                            <Link className="approve approveAction" 
                                                            onClick={(e) => bulkApprove( phase.phaseId, phase?.review?.current[round],
                                                                  phase.review.current, e, phase.phaseIsMultiAssignee ) } >
                                                              {phase.phaseIsMultiAssignee ? "Advance Workflow Phase" : "Approve Translation"}
                                                            </Link>
                                                          </li>
                                                        </ConditionalBlock>}
                                                        {phase.stepWorkPhaseAssignedToSilo ? (
                                                          <li>
                                                            <Link
                                                              className="uploadRevised"
                                                              onClick={(e) =>
                                                                uploadTranslation(
                                                                  phase?.review
                                                                    ?.current[
                                                                    round
                                                                  ][roundNum]
                                                                    .sourceProjectAssetId,
                                                                  phase?.review
                                                                    ?.current[
                                                                    round
                                                                  ],
                                                                  "IN_REVIEW"
                                                                )
                                                              }
                                                            >
                                                              Upload Revised
                                                              Translation
                                                            </Link>
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {phase.assignedToSilo &&
                                                        phase.phaseNumber > 2 &&
                                                        !phase.approvalPhase &&
                                                        options?.permissions &&
                                                        options?.permissions
                                                          ?.PROJECT_CUD ? (
                                                          <li>
                                                            {phase.approvalPhase && 
                                                              <Link>
                                                                Reject Asset
                                                              </Link>
                                                             }                                                              
                                                              { (!phase.approvalPhase && !skipPostEditing) &&
                                                              <Link
                                                                className="moveAssetBack"
                                                                onClick={(e) =>
                                                                  moveAssetBack(
                                                                    phase.phaseId,
                                                                    phase
                                                                      ?.review
                                                                      ?.current[
                                                                      round
                                                                    ],
                                                                    phase.review
                                                                      .current,
                                                                    e
                                                                  )
                                                                }
                                                              >
                                                                Move Asset Back
                                                              </Link>}                                                            
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div></div>
                                              )}
                                            </div>
                                            {phase?.review?.current[round]?.map(
                                              (entry, i) => {
                                                return (
                                                  <div
                                                    className={`translate-sub-main-footer flex-center ${i}`}
                                                    key={i + 8}
                                                  >
                                                    <div className="left">
                                                      <div
                                                        className="download-file show-whitetext"
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="18"
                                                          height="22"
                                                          viewBox="0 0 18 22"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M6 12H12M6 16H9M1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7.342C17 7.07556 16.9467 6.81181 16.8433 6.56624C16.7399 6.32068 16.5885 6.09824 16.398 5.912L11.958 1.57C11.5844 1.20466 11.0826 1.00007 10.56 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V3Z"
                                                            stroke="#4E6380"
                                                            strokeWidth="1.3"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                          ></path>
                                                        </svg>
                                                        <span>{entry.name}</span> <span className="ml-10 show-flex">{entry.lockedForPostEditing &&
                                                        <>
                                                         <button data-tip data-for="skip-pencil-icon-tool-tip">{SkipPostEditingPencilIcon}</button>
                                                            <ReactTooltip id="skip-pencil-icon-tool-tip">
                                                                <span class="parent-span">
                                                                <span class="aiqe-icon">{AiqeToolTipIcon}</span> <span>Post-Editing Skipped</span>
                                                                </span>
                                                          </ReactTooltip>
                                                          </>
                                                         }</span>
                                                      </div>
                                                    </div>                                                                                                                                                                                                                                                                                                      
                                                    {entry.comment !== '' ? 
                                                  <div className="center">
                                                    <span className="error">{entry.comment}</span>
                                                  </div>  : ''
                                                  }
                                                    <div className="right flex-center ">
                                                      <div className="global-dropdown-select mr-15 width-auto">
                                                        <button
                                                          aria-label="assignee"
                                                          className="user mr-15 1"
                                                          onKeyDown={(e) => handleUserEscFocus(e)}
                                                          aria-expanded={
                                                            showstaticReviewers ===
                                                            phase.phaseId +
                                                              "-" +
                                                              entry.id
                                                              ? "true"
                                                              : "false"
                                                          }
                                                          onClick={(e) =>
                                                            openStaticReviewers(
                                                              phase.phaseId +
                                                                "-" +
                                                                entry.id
                                                            )
                                                          }
                                                        >
                                                          {phase.phaseIsMultiAssignee ? 
                                                          <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="24"
                                                          height="19"
                                                          viewBox="0 0 24 19"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                                            fill="#64748B"
                                                            stroke="#64748B"
                                                            strokeWidth="0.2"
                                                          />
                                                        </svg> : 
                                                        <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="22"
                                                        height="22"
                                                        viewBox="0 0 22 22"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M11 5.5C10.3201 5.5 9.65552 5.70161 9.09023 6.07932C8.52494 6.45704 8.08434 6.9939 7.82417 7.62203C7.56399 8.25015 7.49592 8.94131 7.62855 9.60812C7.76119 10.2749 8.08858 10.8874 8.56932 11.3682C9.05007 11.8489 9.66257 12.1763 10.3294 12.3089C10.9962 12.4416 11.6874 12.3735 12.3155 12.1133C12.9436 11.8532 13.4805 11.4126 13.8582 10.8473C14.2359 10.282 14.4375 9.61737 14.4375 8.9375C14.4375 8.02582 14.0753 7.15148 13.4307 6.50682C12.786 5.86216 11.9117 5.5 11 5.5ZM11 11C10.5921 11 10.1933 10.879 9.85414 10.6524C9.51496 10.4258 9.25061 10.1037 9.0945 9.72678C8.93839 9.34991 8.89755 8.93521 8.97713 8.53513C9.05671 8.13504 9.25315 7.76754 9.54159 7.47909C9.83004 7.19065 10.1975 6.99421 10.5976 6.91463C10.9977 6.83505 11.4124 6.87589 11.7893 7.032C12.1662 7.1881 12.4883 7.45246 12.7149 7.79164C12.9415 8.13081 13.0625 8.52958 13.0625 8.9375C13.062 9.48434 12.8445 10.0086 12.4578 10.3953C12.0711 10.782 11.5468 10.9995 11 11Z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                        <path
                                                          d="M11 1.375C9.09636 1.375 7.23546 1.9395 5.65264 2.99711C4.06982 4.05471 2.83616 5.55793 2.10766 7.31667C1.37917 9.07541 1.18856 11.0107 1.55995 12.8777C1.93133 14.7448 2.84802 16.4598 4.1941 17.8059C5.54018 19.152 7.25519 20.0687 9.12226 20.4401C10.9893 20.8114 12.9246 20.6208 14.6833 19.8923C16.4421 19.1638 17.9453 17.9302 19.0029 16.3474C20.0605 14.7645 20.625 12.9036 20.625 11C20.6221 8.44818 19.6071 6.00172 17.8027 4.19731C15.9983 2.39291 13.5518 1.37791 11 1.375ZM6.875 18.1342V17.1875C6.87555 16.6407 7.09302 16.1164 7.4797 15.7297C7.86638 15.343 8.39066 15.1255 8.9375 15.125H13.0625C13.6093 15.1255 14.1336 15.343 14.5203 15.7297C14.907 16.1164 15.1245 16.6407 15.125 17.1875V18.1342C13.8732 18.8651 12.4496 19.2503 11 19.2503C9.5504 19.2503 8.12683 18.8651 6.875 18.1342ZM16.4945 17.1366C16.4808 16.2349 16.1134 15.3746 15.4714 14.7411C14.8295 14.1076 13.9644 13.7517 13.0625 13.75H8.9375C8.03563 13.7517 7.17052 14.1076 6.52857 14.7411C5.88661 15.3746 5.51921 16.2349 5.5055 17.1366C4.25877 16.0234 3.37957 14.5577 2.98433 12.9337C2.58909 11.3097 2.69645 9.60392 3.29219 8.04228C3.88794 6.48063 4.94397 5.13677 6.32045 4.18864C7.69693 3.24051 9.32893 2.73283 11.0003 2.73283C12.6718 2.73283 14.3038 3.24051 15.6802 4.18864C17.0567 5.13677 18.1128 6.48063 18.7085 8.04228C19.3042 9.60392 19.4116 11.3097 19.0164 12.9337C18.6211 14.5577 17.7419 16.0234 16.4952 17.1366H16.4945Z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                      </svg>
                                                        }
                                                          
                                                        </button>
                                                        <div
                                                          id={showstaticReviewers === phase.phaseId + "-" + entry.id?"assigneeDetails":""}
                                                          className={
                                                            showstaticReviewers ===
                                                            phase.phaseId +
                                                              "-" +
                                                              entry.id
                                                              ? "global-dropdown action-display2 width246 show p-5 max-heightInherit"
                                                              : "global-dropdown action-display2 width246 hide"
                                                          }
                                                        >
                                                          <ul>
                                                          {phaseAssignee.length > 0 ?
                                                            phaseAssignee.map((assignee,index) => {
                                                              if(assignee.asset.id === entry.id){
                                                                return (
                                                                  <li className="p-5" key={index}>{assignee.user.firstName +" "+assignee.user.lastName}{" "}
                                                                  <strong>({assignee.status === "OPEN" || assignee.status === "OPENED" ? Constants.IN_PROGRESS :  humanize(assignee.status) } )
                                                                  </strong> </li>
                                                                );
                                                              }
                                                              }
                                                            ):phase.assigneeVendor!=="" && (phase.assigneeVendor.name)}
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="global-dropdown-select mr-15 width-auto">
                                                        <button
                                                          aria-label="downloads"
                                                          className="download mar-top6 downloadLangdoc"
                                                          aria-expanded={dropDownOptionId === entry.id ? "true" : "false"}
                                                          onClick={() =>
                                                            showDownloadOptions(
                                                              entry.id
                                                            )
                                                          }
                                                          onKeyDown={(e) => handleEscFocus(e)}
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="17"
                                                            viewBox="0 0 20 17"
                                                            fill="none"
                                                          >
                                                            <path
                                                              d="M9.9987 10.875V1.375M9.9987 10.875L6.33203 7.70833M9.9987 10.875L13.6654 7.70833M0.832031 12.4583L1.40128 14.4256C1.50042 14.7682 1.72929 15.0723 2.0515 15.2896C2.37372 15.5069 2.77079 15.6249 3.17961 15.625H16.8178C17.2266 15.6249 17.6237 15.5069 17.9459 15.2896C18.2681 15.0723 18.497 14.7682 18.5961 14.4256L19.1654 12.4583"
                                                              stroke="#1D4ED8"
                                                              strokeWidth="1.5"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                            ></path>
                                                          </svg>
                                                        </button>
                                                        <div
                                                          className={
                                                            dropDownOptionId ===
                                                            entry.id
                                                              ? "global-dropdown action-display2 width246 show"
                                                              : "global-dropdown action-display2 width246 hide"
                                                          }
                                                          id={entry.id}
                                                          onKeyDown={(e) => handleModalFocus(e)}
                                                        >
                                                          <ul className="addDynamicId">
                                                            {/* <RenderDownloadMenuItems asset={entry} /> */}
                                                            <FileDownloadMenuItems 
                                                            entry={entry} 
                                                            projectId={param.id} 
                                                            translatedAsset={targetAssetData}
                                                            sourcePreviewBundle={sourcePreviewBundle}
                                                            targetPreviewBundle={targetPreviewBundle} />
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <button
                                                        aria-label="Discussions"
                                                        className="chat mr-15"
                                                        onClick={() =>
                                                          showChatBox(true,entry)
                                                        }
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="20"
                                                          height="20"
                                                          viewBox="0 0 20 20"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M2.5 1.25C2.16848 1.25 1.85054 1.3817 1.61612 1.61612C1.3817 1.85054 1.25 2.16848 1.25 2.5V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H14.4825C15.1455 13.7501 15.7813 14.0136 16.25 14.4825L18.75 16.9825V2.5C18.75 2.16848 18.6183 1.85054 18.3839 1.61612C18.1495 1.3817 17.8315 1.25 17.5 1.25H2.5ZM17.5 0C18.163 0 18.7989 0.263392 19.2678 0.732233C19.7366 1.20107 20 1.83696 20 2.5V18.4913C20 18.6149 19.9633 18.7358 19.8945 18.8386C19.8257 18.9414 19.728 19.0215 19.6138 19.0687C19.4995 19.116 19.3737 19.1282 19.2525 19.104C19.1312 19.0797 19.0198 19.0201 18.9325 18.9325L15.3663 15.3663C15.1319 15.1318 14.814 15.0001 14.4825 15H2.5C1.83696 15 1.20107 14.7366 0.732233 14.2678C0.263392 13.7989 0 13.163 0 12.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L17.5 0Z"
                                                            fill="#1D4ED8"
                                                          ></path>
                                                          <path
                                                            d="M3.75 4.375C3.75 4.20924 3.81585 4.05027 3.93306 3.93306C4.05027 3.81585 4.20924 3.75 4.375 3.75H15.625C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375C16.25 4.54076 16.1842 4.69973 16.0669 4.81694C15.9497 4.93415 15.7908 5 15.625 5H4.375C4.20924 5 4.05027 4.93415 3.93306 4.81694C3.81585 4.69973 3.75 4.54076 3.75 4.375ZM3.75 7.5C3.75 7.33424 3.81585 7.17527 3.93306 7.05806C4.05027 6.94085 4.20924 6.875 4.375 6.875H15.625C15.7908 6.875 15.9497 6.94085 16.0669 7.05806C16.1842 7.17527 16.25 7.33424 16.25 7.5C16.25 7.66576 16.1842 7.82473 16.0669 7.94194C15.9497 8.05915 15.7908 8.125 15.625 8.125H4.375C4.20924 8.125 4.05027 8.05915 3.93306 7.94194C3.81585 7.82473 3.75 7.66576 3.75 7.5ZM3.75 10.625C3.75 10.4592 3.81585 10.3003 3.93306 10.1831C4.05027 10.0658 4.20924 10 4.375 10H10.625C10.7908 10 10.9497 10.0658 11.0669 10.1831C11.1842 10.3003 11.25 10.4592 11.25 10.625C11.25 10.7908 11.1842 10.9497 11.0669 11.0669C10.9497 11.1842 10.7908 11.25 10.625 11.25H4.375C4.20924 11.25 4.05027 11.1842 3.93306 11.0669C3.81585 10.9497 3.75 10.7908 3.75 10.625Z"
                                                            fill="#1D4ED8"
                                                          ></path>
                                                        </svg>
                                                      </button>
                                                      {(() => {
                                                        if (entry.status === "IN_REVIEW") {
                                                          <div className="btn-txt">
                                                            {options.reviewerMode && !entry.lineByLineEnabled ? (
                                                              <button></button>
                                                            ) : (
                                                              <button
                                                                className="btn width98 2"
                                                                onClick={() =>
                                                                  createReviewLink(
                                                                    phase.phaseId,
                                                                    entry,
                                                                    targetAssetData,
                                                                    phase,'review'
                                                                  )
                                                                }
                                                              >
                                                                Review{" "}
                                                              </button>
                                                            )}
                                                          </div>;
                                                          
                                                          if (
                                                            phase.phaseIsMultiAssignee && phase.assignedToSilo && phase.assigneeVendor === ""
                                                          ) {
                                                            return(
                                                              getEntryUserAssigneeStatue(phase.phaseId,entry.id) === "NOT_STARTED" ||
                                                              getEntryUserAssigneeStatue(phase.phaseId,entry.id) === "OPENED" ?
                                                            <button
                                                              className="btn width98 3"
                                                              onClick={() =>
                                                                createReviewLink(
                                                                  phase.phaseId,
                                                                  entry,
                                                                  targetAssetData,
                                                                  phase,'review'
                                                                )
                                                              }
                                                            >Review
                                                            </button> : 
                                                            <button
                                                            className="btn width98"
                                                            onClick={() =>
                                                              createReviewLink(
                                                                phase.phaseId,
                                                                entry,
                                                                targetAssetData,
                                                                phase,'view'
                                                              )
                                                            }
                                                          >View
                                                          </button>);
                                                          } else if (
                                                            phase.approvalPhase
                                                          ) {
                                                            if (phase.assignedToContextUser) 
                                                            {
                                                              return (
                                                                <button
                                                                  className="btn width98"
                                                                  onClick={() =>
                                                                    createReviewLink(
                                                                      phase.phaseId,
                                                                      entry,
                                                                      targetAssetData,
                                                                      phase,'approve'
                                                                    )
                                                                  }
                                                                >
                                                                  Approve
                                                                </button>
                                                              );
                                                            } else {
                                                              return (
                                                                <button
                                                                  className="btn width98"
                                                                  onClick={() =>
                                                                    createReviewLink(
                                                                      phase.phaseId,
                                                                      entry,
                                                                      targetAssetData,
                                                                      phase,'view'
                                                                    )
                                                                  }
                                                                >
                                                                  View{" "}
                                                                </button>
                                                              );
                                                            }
                                                          } else {
                                                            if (
                                                              phase.assignedToSilo &&
                                                              isCurrentUser(
                                                                step,
                                                                phase.phaseId
                                                              )
                                                            ) {
                                                              return (
                                                                <button
                                                                  className="btn width98 4"
                                                                  projectdetail-tour="review-btn"
                                                                  onClick={() =>
                                                                    createReviewLink(
                                                                      phase.phaseId,
                                                                      entry,
                                                                      targetAssetData,
                                                                      phase,'review'
                                                                    )
                                                                  }
                                                                >
                                                                  Review{" "}
                                                                </button>
                                                              );
                                                            } else {
                                                              return (
                                                                <button
                                                                  className="btn width98"
                                                                  onClick={() =>
                                                                    createReviewLink(
                                                                      phase.phaseId,
                                                                      entry,
                                                                      targetAssetData,
                                                                      phase,'view'
                                                                    )
                                                                  }
                                                                >
                                                                  View
                                                                </button>
                                                              );
                                                            }
                                                          }
                                                        } else {
                                                          return (
                                                            <strong>
                                                              {entry.status ===
                                                              "HELD"
                                                                ? "Processing"
                                                                : humanize(
                                                                    entry.status
                                                                  )}
                                                            </strong>
                                                          );
                                                        }
                                                      })()}
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </div>
                                        );
                                      });
                                      template.push(lastPhase);
                                    }
                                    if (phase.review.complete.length > 0) {
                                      template.push(
                                        <div
                                          className={`translate-table-list review-complete ${phase.phaseNumber}`}
                                          key={phaseIndex + 5}
                                        >
                                          <div className="head">
                                             {phase.phaseName}
                                          </div>
                                          <div className="name 7">
                                            <AssigneeEditableReadOnly
                                              step={step}
                                              phase={phase}
                                              phaseIndex={phaseIndex}
                                              name={phase.phaseName}
                                            />
                                          </div>
                                          <div className="block-div">
                                            {(!skipPostEditing  && phase.phaseType.originalEnum === "POST_EDITING") && 
                                              <button
                                                className="progress readonly progress-green"
                                                tabIndex="-1"
                                              >
                                                {"Completed " + dateUtil.format(phase.phaseClosedDate)}
                                              </button>
                                            }  
                                            
                                            { (skipPostEditing && phase.phaseType.originalEnum === "POST_EDITING") &&
                                              <button
                                                className="progress readonly progress-green"
                                                tabIndex="-1"
                                              >{"Skipped"}</button>
                                            }
                                          </div>
                                          {/* <div></div> */}
                                        </div>
                                      );
                                    }
                                    if (phase.approved?.length > 0) {
                                      template.push(
                                        <div key={phaseIndex + 7}>
                                          <div className="translate-table-list review-complete">
                                            <div className="head">Approved</div>
                                            <div className="name"></div>
                                            <div></div>
                                            {phase.assignedToSilo &&
                                            projectStatus.open ? (
                                              <div className="assignsilo">
                                                {userBootstrapData.permissions
                                                  ?.REOPEN_LANGUAGE  ? (
                                                  <button
                                                    className="btn-bold active"
                                                    onClick={() =>
                                                      confirmSyncErrorActions(
                                                        "reopen-language",
                                                        ""
                                                      )
                                                    }
                                                  >
                                                    Reopen Language
                                                  </button>
                                                ) : null}
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {phase.approved.map((entry, i) => {
                                            return (
                                              <div
                                                className="translate-sub-main-footer flex-center mar-bot16"
                                                key={i + 1}
                                              >
                                                <div className="left">
                                                  <div
                                                    className="download-file show-whitetext"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="18"
                                                      height="22"
                                                      viewBox="0 0 18 22"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M6 12H12M6 16H9M1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7.342C17 7.07556 16.9467 6.81181 16.8433 6.56624C16.7399 6.32068 16.5885 6.09824 16.398 5.912L11.958 1.57C11.5844 1.20466 11.0826 1.00007 10.56 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V3Z"
                                                        stroke="#4E6380"
                                                        strokeWidth="1.3"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                      ></path>
                                                    </svg>
                                                    <span className="uplaodedfile-name">
                                                      {entry.name}
                                                    </span>
                                                  </div>
                                                </div>
                                                <div className="right flex-center">
                                                  <div className="global-dropdown-select mr-15 width-auto">
                                                    <button
                                                      aria-label="download"
                                                      className="download mar-top6 4"
                                                      onClick={() =>
                                                        showDownloadOptions(
                                                          entry.id
                                                        )
                                                      }
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="17"
                                                        viewBox="0 0 20 17"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M9.9987 10.875V1.375M9.9987 10.875L6.33203 7.70833M9.9987 10.875L13.6654 7.70833M0.832031 12.4583L1.40128 14.4256C1.50042 14.7682 1.72929 15.0723 2.0515 15.2896C2.37372 15.5069 2.77079 15.6249 3.17961 15.625H16.8178C17.2266 15.6249 17.6237 15.5069 17.9459 15.2896C18.2681 15.0723 18.497 14.7682 18.5961 14.4256L19.1654 12.4583"
                                                          stroke="#1D4ED8"
                                                          strokeWidth="1.5"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        ></path>
                                                      </svg>
                                                    </button>
                                                    <div
                                                      className={
                                                        dropDownOptionId ===
                                                        entry.id
                                                          ? "global-dropdown action-display2 width246 show"
                                                          : "global-dropdown action-display2 width246 hide"
                                                      }
                                                    >
                                                      <ul className="addDynamicId">
                                                        {/* <RenderDownloadMenuItems asset={entry}/> */}
                                                        <FileDownloadMenuItems 
                                                        entry={entry} 
                                                        projectId={param.id} 
                                                        translatedAsset={targetAssetData} 
                                                        sourcePreviewBundle={sourcePreviewBundle}
                                                        targetPreviewBundle={targetPreviewBundle} />
                                                      </ul>
                                                      
                                                    </div>
                                                  </div>
                                                  <button
                                                    aria-label="Discussions"
                                                    className="chat mr-15"
                                                    onClick={() =>
                                                      showChatBox(true,entry)
                                                    }
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="20"
                                                      height="20"
                                                      viewBox="0 0 20 20"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M2.5 1.25C2.16848 1.25 1.85054 1.3817 1.61612 1.61612C1.3817 1.85054 1.25 2.16848 1.25 2.5V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H14.4825C15.1455 13.7501 15.7813 14.0136 16.25 14.4825L18.75 16.9825V2.5C18.75 2.16848 18.6183 1.85054 18.3839 1.61612C18.1495 1.3817 17.8315 1.25 17.5 1.25H2.5ZM17.5 0C18.163 0 18.7989 0.263392 19.2678 0.732233C19.7366 1.20107 20 1.83696 20 2.5V18.4913C20 18.6149 19.9633 18.7358 19.8945 18.8386C19.8257 18.9414 19.728 19.0215 19.6138 19.0687C19.4995 19.116 19.3737 19.1282 19.2525 19.104C19.1312 19.0797 19.0198 19.0201 18.9325 18.9325L15.3663 15.3663C15.1319 15.1318 14.814 15.0001 14.4825 15H2.5C1.83696 15 1.20107 14.7366 0.732233 14.2678C0.263392 13.7989 0 13.163 0 12.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L17.5 0Z"
                                                        fill="#1D4ED8"
                                                      ></path>
                                                      <path
                                                        d="M3.75 4.375C3.75 4.20924 3.81585 4.05027 3.93306 3.93306C4.05027 3.81585 4.20924 3.75 4.375 3.75H15.625C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375C16.25 4.54076 16.1842 4.69973 16.0669 4.81694C15.9497 4.93415 15.7908 5 15.625 5H4.375C4.20924 5 4.05027 4.93415 3.93306 4.81694C3.81585 4.69973 3.75 4.54076 3.75 4.375ZM3.75 7.5C3.75 7.33424 3.81585 7.17527 3.93306 7.05806C4.05027 6.94085 4.20924 6.875 4.375 6.875H15.625C15.7908 6.875 15.9497 6.94085 16.0669 7.05806C16.1842 7.17527 16.25 7.33424 16.25 7.5C16.25 7.66576 16.1842 7.82473 16.0669 7.94194C15.9497 8.05915 15.7908 8.125 15.625 8.125H4.375C4.20924 8.125 4.05027 8.05915 3.93306 7.94194C3.81585 7.82473 3.75 7.66576 3.75 7.5ZM3.75 10.625C3.75 10.4592 3.81585 10.3003 3.93306 10.1831C4.05027 10.0658 4.20924 10 4.375 10H10.625C10.7908 10 10.9497 10.0658 11.0669 10.1831C11.1842 10.3003 11.25 10.4592 11.25 10.625C11.25 10.7908 11.1842 10.9497 11.0669 11.0669C10.9497 11.1842 10.7908 11.25 10.625 11.25H4.375C4.20924 11.25 4.05027 11.1842 3.93306 11.0669C3.81585 10.9497 3.75 10.7908 3.75 10.625Z"
                                                        fill="#1D4ED8"
                                                      ></path>
                                                    </svg>
                                                  </button>
                                                  <div className="btn-txt">
                                                    {!entry.lineByLineEnabled ? (
                                                      <button
                                                        className="btn width98"
                                                        onClick={() =>
                                                          createReviewLink(
                                                            phase.phaseId,
                                                            entry,
                                                            targetAssetData,
                                                            phase,
                                                            'view'
                                                          )
                                                        }
                                                      >
                                                        View
                                                      </button>
                                                    ) : (
                                                      <button
                                                        className="btn width98"
                                                        onClick={() =>
                                                          createReviewLink(
                                                            phase.phaseId,
                                                            entry,
                                                            targetAssetData,
                                                            phase,
                                                            'view'
                                                          )
                                                        }
                                                      >
                                                        View
                                                      </button>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      );
                                    }
                                  }
                                } else {
                                  template.push("");
                                }
                                return template;
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                      {languageDetail.steps.length - 1 > stepIndex && showSteps.includes(step.stepNumber+1)? (
                        <div className="cust-arrow-vert"></div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
              {targetAssetData.length === 0 ? (
                <p>
                  Once your project is in Translation, you will see that status
                  of all your {selectedLanguageDisplayName} files here.
                </p>
              ) : (
                ""
              )}
            </React.Fragment>
          ) : null}

          <div
            className="detail-footer flex-center"
            projectdetail-tour="alert-task"
          >
            <div className="detail-footer-left">
              <div className="task-assign-block">
                <div className="task-assign-heading flex-center">
                  {getPermissions.includes("TASK_ASSIGNED_TO_ME") ? (
                    <div className="flex-left flex-center">
                      <h4> {translate("project_listing.task_assigned")}</h4>
                    </div>
                  ) : null}
                </div>
                <div className="tab-content">
                  <div className="inner-tab-content">
                    {myTasks?.length > 0 ? (
                      myTasks.map((task, index) => {
                        return (
                          <div key={index + 3}>
                            <UserTaskList showTabWithId ={prop.showTabWithId} task={task} key={index} showPopup={showBidUpdatePopup} projectDetail={prop.projectDetail}
                              use="projectDetail" funct={prop.funct} />
                          </div>
                        );
                      })
                    ) : (
                      <div className="no-data-display align-center">
                        <i className="nodata-icon"></i>
                        <p>{Constants.TASK_ASSIGN}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="detail-footer-right">
              <div className="notification-board">
                <div className="notification-list">
                  <h4>{translate("project_listing.alerts")}</h4>
                  {userAlert && userAlert?.length > 0 || userAlert?.all > 0 ? (
                    <UserAlert
                      alerts={userAlert}
                      projectDetail={prop.projectDetail}
                      funct={prop.funct}
                      redirect={goToTab}
                    />
                  ) : (
                    <div className="no-data-display align-center">
                      <i className="nodata-icon"></i>
                      <p>{Constants.TASK_ALERTS}</p>
                    </div>
                  )}
                </div>
                <div className="notification-list">
                  <h4>{translate("project_listing.tm")}</h4>
                  {translationMemoryFile && translationMemoryFile?.length !== 0 ? (
                    <div>
                      <div className="date">
                        <strong>Uploaded on</strong> :
                        <strong>
                          {" " + campaignDetailDate(translationMemoryFile.createdDate)}
                        </strong>
                      </div>
                      <p>{translationMemoryFile.filename}</p>
                      <div className="links">
                        <Link onClick={(e) => showOneTm(e)}>Browse TM</Link> |{" "}


                        {userBootstrapData?.roleSet?.customerInternalTranslator && <>
                          <Link onClick={()=>{setShowUploadTM(true); showModel()}}>Replace</Link> |{" "}
                        </>}

                        <Link
                          to="#"
                          onClick={() =>
                            downloadTm(translationMemoryFile.filename)
                          }
                        >

                          Download
                        </Link>
                      </div>
                    </div>

                  ) : (getTranslationMemoryMessage())}

                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="offlineReview offlineReview-block">
          <div className="left-content-header" style={{ padding: "20px 10px" }}>
            <div className="campaign-name">
              <button
                id="reviewBack"
                aria-label="back"
                className="back-btn"
                onClick={() => clearHistoryRecord()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                >
                  <path
                    d="M6.46967 12.9697C6.17678 13.2626 6.17678 13.7374 6.46967 14.0303L11.2426 18.8033C11.5355 19.0962 12.0104 19.0962 12.3033 18.8033C12.5962 18.5104 12.5962 18.0355 12.3033 17.7426L8.06066 13.5L12.3033 9.25736C12.5962 8.96447 12.5962 8.48959 12.3033 8.1967C12.0104 7.90381 11.5355 7.90381 11.2426 8.1967L6.46967 12.9697ZM7 14.25H20V12.75H7V14.25Z"
                    fill="#4D4D4D"
                  ></path>
                </svg>
              </button>
              {translatedAsset.map((assets, index) => {
                if (assets.id === assetId) {
                  return (
                    <h3 key={index}>
                      {assets?.name + " (" + assets?.language + ")"}
                    </h3>
                  );
                }
              })}
            </div>
          </div>
          <div className="action-div flex">
            <div className="left flex btn-gap">
              <div className="progress progress-green readonly" style={{margin:"auto 0"}}>
              <span aria-hidden="true">
                {phaseTask[phaseTask.length - 1]?.closedDate &&
                phaseTask[phaseTask.length - 1]?.closedDate !== ""
                  ? `Completed  ${dateUtil.format(
                      phaseTask[phaseTask.length - 1]?.closedDate,
                      null,
                      null
                    )}`
                  : `Due ${dateUtil.format(
                      phaseTask[phaseTask.length - 1]?.dueDate,
                      null,
                      null
                    )}`}</span>
                    <span className="font-zero">
                    {phaseTask[phaseTask.length - 1]?.closedDate &&
                phaseTask[phaseTask.length - 1]?.closedDate !== ""
                  ? `Completed  ${dateUtil.format(
                      phaseTask[phaseTask.length - 1]?.closedDate,
                      null,
                      null
                    )}`
                  : `Due ${dateUtil.format(
                      phaseTask[phaseTask.length - 1]?.dueDate,
                      null,
                      null
                    )}`}
                    </span>
              </div>
              <div className="name">
                <div className="inline-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M8.5 17C10.7704 17 12.905 16.1158 14.5104 14.5104C16.1158 12.905 17 10.7704 17 8.5C17 6.22957 16.1158 4.09504 14.5104 2.48957C12.905 0.884166 10.7704 0 8.5 0C6.22957 0 4.09504 0.884166 2.48957 2.48957C0.884167 4.09504 0 6.22957 0 8.5C0 10.7704 0.884167 12.905 2.48957 14.5104C4.09504 16.1158 6.22957 17 8.5 17ZM8.5 1.32812C12.4546 1.32812 15.6719 4.54541 15.6719 8.5C15.6719 12.4546 12.4546 15.6719 8.5 15.6719C4.54541 15.6719 1.32812 12.4546 1.32812 8.5C1.32812 4.54541 4.54541 1.32812 8.5 1.32812ZM8.5332 9.13086C10.2908 9.13086 11.7207 7.70097 11.7207 5.94336C11.7207 4.18575 10.2908 2.75586 8.5332 2.75586C6.7756 2.75586 5.3457 4.18575 5.3457 5.94336C5.3457 7.70097 6.7756 9.13086 8.5332 9.13086ZM8.5332 4.08398C9.55848 4.08398 10.3926 4.91811 10.3926 5.94336C10.3926 6.96861 9.55848 7.80273 8.5332 7.80273C7.50792 7.80273 6.67383 6.96861 6.67383 5.94336C6.67383 4.91811 7.50792 4.08398 8.5332 4.08398Z"
                      fill="#1D4ED8"
                    ></path>
                    <path
                      d="M4.74697 13.1484C4.93919 13.1484 5.12977 13.0654 5.26109 12.9052C5.9468 12.068 6.95976 11.5879 8.04026 11.5879H8.82817C9.90866 11.5879 10.9216 12.068 11.6073 12.9052C11.8397 13.1888 12.2581 13.2305 12.5418 12.9981C12.8256 12.7657 12.8672 12.3473 12.6348 12.0636C11.6958 10.9172 10.3083 10.2598 8.82817 10.2598H8.04026C6.5601 10.2598 5.17264 10.9172 4.23365 12.0636C4.00126 12.3473 4.04287 12.7657 4.32662 12.9981C4.45 13.0992 4.59895 13.1484 4.74697 13.1484Z"
                      fill="#1D4ED8"
                    ></path>
                  </svg>{" "}
                </div>
                {getAssigneAndStatus()}
              </div>
              <button
                aria-label="Discussions"
                className="chat"
                onClick={() => showChatBox(true,selectedTranslatedAsset)}
              >
                {ChatIcon}
              </button>
              <div className="global-dropdown-select width-auto outsideClick" >
                <button
                  aria-label="downloads"
                  className="download offlinedownloadLangdoc"
                  aria-expanded={historyDownload ? 'true':'false'}
                  onClick={showHistoryDownloadOptions}
                  onKeyDown={(e) => handleofflineEscFocus(e)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                    fill="none"
                  >
                    <path
                      d="M9.9987 10.875V1.375M9.9987 10.875L6.33203 7.70833M9.9987 10.875L13.6654 7.70833M0.832031 12.4583L1.40128 14.4256C1.50042 14.7682 1.72929 15.0723 2.0515 15.2896C2.37372 15.5069 2.77079 15.6249 3.17961 15.625H16.8178C17.2266 15.6249 17.6237 15.5069 17.9459 15.2896C18.2681 15.0723 18.497 14.7682 18.5961 14.4256L19.1654 12.4583"
                      stroke="#1D4ED8"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </button>
                <div
                  className={
                    historyDownload
                      ? "global-dropdown action-display2 width246 show"
                      : "global-dropdown action-display2 width246 hide"
                  }
                  onKeyDown={(e) => handleofflineModalFocus(e)}
                >
                  <ul className="addDynamicId">
                  <FileDownloadMenuItems 
                    entry={selectedTranslatedAsset} 
                    projectId={param.id} 
                    translatedAsset={targetAssetData}
                    sourcePreviewBundle={sourcePreviewBundle}
                    targetPreviewBundle={targetPreviewBundle}
                    />
                  </ul>
                </div>
              </div>
            </div>
            <div className="right flex-right">
              {(() => {
                var taskPhase = getTaskPhase();
                var entryUserAssigneeStatus = getEntryUserAssigneeStatue(selectedTranslatedAsset?.currentPhaseId, selectedTranslatedAsset?.assets[0]?.id);
                if (
                  selectedTranslatedAsset?.status === "IN_REVIEW" &&
                  !vendorMode
                ) {
                  if (
                    custBootstrapDataRedux?.permissions
                      ?.PROJECT_LANGUAGE_APPROVE_OR_REQUEST_REVISION
                  ) {
                    if (
                      entryUserAssigneeStatus === "NOT_STARTED" ||
                      entryUserAssigneeStatus === "OPENED" ||
                      entryUserAssigneeStatus === "NOT_ASSIGNEE"
                    ) {
                      if (currentPhase?.allowRevision ) {
                        return (
                          <div className="flex btn-gap">
                            <button
                              className="blue-btn active approveClickBtn"
                              onClick={() =>
                                openDeliverableApprovePopup("approve")
                              }
                            >
                              Approve
                            </button>
                            <button
                              className="blue-btn requestRevision"
                              onClick={() => toggleRequestRevision(true)}
                            >
                              Request Revision
                            </button>
                          </div>
                        );
                      } else {
                        return (
                          <button
                            className="btn blue-btn"
                            onClick={() =>
                              openDeliverableApprovePopup("feedback")
                            }
                          >
                            Submit Feedback
                          </button>
                        );
                      }
                    }
                  }
                  if (
                    languagePhase.assignedToVendor &&
                    taskPhase?.type === "REVIEW_PROJECT_ASSETS"
                  ) {
                    if (!languagePhase?.allowMultiAssignee) {
                      <div className="flex btn-gap">
                        <button className="btn blue-btn">Approve</button>
                        <button
                          className="btn blue-btn"
                          onClick={() => toggleRequestRevision(true)}
                        >
                          Request Revision
                        </button>
                      </div>;
                    }
                  }
                } else if (selectedTranslatedAsset?.status === "IN_REVISION") {
                  if (!vendorMode) {
                    if (taskPhase?.status?.originalEnum === "OPEN") {
                      return (
                        <button
                          className="btn blue-btn"
                          onClick={() =>
                            uploadTranslation(
                              selectedTranslatedAsset.id,
                              selectedTranslatedAsset,
                              "IN_REVISION_OFFLINE"
                            )
                          }
                        >
                          Upload Revision
                        </button>
                      );
                    } else if (taskPhase?.status?.originalEnum === "CLOSED") {
                      return (
                        <button className="btn blue-btn ">
                          Review completed on{" "}
                          {dateUtil.format(selectedTranslatedAsset.lastModifiedDate,null,null)}
                        </button>
                      );
                    }
                  } else {
                    return (
                      <p>
                        Revision requested{" "}
                        {dateUtil.format(selectedTranslatedAsset.lastModifiedDate,null,null)}
                      </p>
                    );
                  }
                } else if (selectedTranslatedAsset?.status === "APPROVED") {
                  return (
                    <div className="reviewDatetext">
                      <span aria-hidden="true">
                      Review completed on :{" "}
                      {dateUtil.format(selectedTranslatedAsset.lastModifiedDate,null,null)}
                      </span>
                      <span className="font-zero">
                      Review completed on :{" "}
                      {dateUtil.format(selectedTranslatedAsset.lastModifiedDate,null,null)}
                      </span>
                    </div>
                  );
                }
              })()}
            </div>
          </div>
          <div className="heading">
            <p>
              {(() => {
                if (
                  selectedTranslatedAsset?.files.FINAL &&
                  selectedTranslatedAsset?.files.FINAL.asset &&
                  selectedTranslatedAsset?.files.FINAL.asset.url &&
                  selectedTranslatedAsset?.files.FINAL.asset.assetType &&
                  selectedTranslatedAsset?.files.FINAL.asset.assetType ===
                    "IMAGE"
                ) {
                  return (
                    <img
                      alt={selectedTranslatedAsset.files.FINAL.asset.name}
                      src={`${
                        selectedTranslatedAsset?.files?.FINAL?.asset?.url
                      }?${Date.now()}`}
                    />
                  );
                } else {
                  if (selectedTranslatedAsset?.status === "APPROVED") {
                    return `Review completed on  ${dateUtil.format(
                      selectedTranslatedAsset.lastModifiedDate,null,null)
                      }`;
                  } else {
                    var taskPhase = getTaskPhase();
                    if (
                      taskPhase?.type?.originalEnum === "REVISE_PROJECT_ASSETS"
                    ) {
                      if (vendorMode) {
                        return `The ${selectedTranslatedAsset?.language} translation file is in revision`;
                      } else {
                        return `Upload the revised ${selectedTranslatedAsset?.language} translation file to continue.`;
                      }
                    } else if (
                      taskPhase?.type?.originalEnum === "REVIEW_PROJECT_ASSETS"
                    ) {
                      if (vendorMode) {
                        return `The ${selectedTranslatedAsset?.language} translation file is in review.`;
                      } else {
                        return `Download the ${selectedTranslatedAsset?.language} translation file to begin the review.`;
                      }
                    } else if (taskPhase?.status === "IN_REVIEW") {
                      if (vendorMode) {
                        return `The ${selectedTranslatedAsset?.language} translation file is in review.`;
                      } else {
                        return `Download the ${selectedTranslatedAsset?.language} translation file to begin the review.`;
                      }
                    }
                  }
                }
              })()}
            </p>
          </div>
          {showRequestRevisionForm ? (
            <div className="request-revision-form">
              <div className="campaign_details-task-create-form discussion-form">
                <form onSubmit={handleSubmit(postMsg)}>
                  <div className="task-form-content">
                    <div className="form-group text p-0">
                      <div className="form-text">
                        <label htmlFor="msg-content">Request Revision </label>
                        <textarea
                          className="textarea"
                          id="msg-content"
                          placeholder="1000 characters limit"
                          value={requestRevisionMessage}
                          maxLength={1000}
                          {...register("message", validations.message)}
                          onChange={(event) =>
                            setRequestRevisionMessage(event.target.value)
                          }
                        ></textarea>
                        <p
                          className="error textDanger m-0"
                          aria-label="error alert"
                          role="alert"
                        >
                          {errors.message?.message}
                        </p>
                      </div>
                    </div>
                    <div className="form-group form-text label-tooltip">
                      <label>
                        Due Date (Optional)
                        <div
                          className="gb-tooltip"
                          role="tooltip"
                          id="tooltipOnDate"
                          tabIndex="0"
                          onKeyDown={(e)=>handleTooltip(e)}
                        >
                          <span>
                            <svg
                              className="svg-tooltip-icon"
                              viewBox="0 0 1024 1024"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z"></path>
                            </svg>
                          </span>
                          <div className="wrap-tooltip-content">
                            <div className="gb-tooltip-content">
                              <div className="triangle"></div>
                              <strong>Due Date</strong>
                              <p>
                                This is the deadline by which the vendor must
                                complete the revision request.
                              </p>
                            </div>
                          </div>
                        </div>
                      </label>
                      <div className="flex-center w-d100 global-dropdown-block m-0 1">
                        <div className="global-dropdown-select form-group text p-0 m-0">
                          <button
                            onClick={(e) => {
                              showCalendarRevisionRequestDate(e);
                            }}
                            onKeyDown={(e) => handleShowCalendarRevisionRequestDate(e)}
                            tabIndex={0}
                            aria-label={revisionRequestDueDate !== ""
                            ? `${dateFormat(
                                revisionRequestDueDate,
                                Constants.DATE_IN_WORDS
                              )} selected`
                            : ""}
                            className="drop-down-btn gb-dropBtn"
                            id='calSecondFocus'
                            aria-expanded={toggleReferenceRequest ? 'true':'false'}
                            >
                            <span>
                              {revisionRequestDueDate !== ""
                                ? dateFormat(
                                    revisionRequestDueDate,
                                    Constants.DATE_IN_WORDS
                                  )
                                : ""}
                            </span>

                            <svg
                              className="calender-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                                fill="#3564EB"
                              />
                            </svg>
                          </button>
                        </div>
                        {toggleReferenceRequest ? (
                          <div
                            ref={refCalendar}
                            onKeyDown={(e) => {
                              closeCalendar(e);
                            }}
                          >
                            <Calendar
                              minDate={new Date()}
                              className="dashCalendarInternal"
                              onChange={(e) => setRevisonRequestDate(e)}
                              nextAriaLabel={nextAriaLabel}
                              prevAriaLabel={prevAriaLabel}
                              next2AriaLabel={next2AriaLabel}
                              prev2AriaLabel={prev2AriaLabel}
                              onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
                            ></Calendar>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="flex wrap-dropdown file-btn">
                      <div className="file-input flex w-d100">
                        <div className="input-file mar-bot16">
                          <input
                            type="file"
                            id="files"
                            onChange={fileSelection}
                          />
                          <label
                            className="file-button flex-center"
                            htmlFor="files"
                          >
                            {!selectedfile ? "Choose file" : "Replace"}
                          </label>
                        </div>
                        <div
                          className={
                            selectedfile
                              ? "uploading-files-block uploading-success w-d100"
                              : "uploading-files-block uploading-success w-d100 hide"
                          }
                        >
                          <div className="uploading-file-list flex">
                            <div className="left-file-desc flex-center">
                              <div className="icon-block">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="25"
                                  height="25"
                                  viewBox="0 0 25 25"
                                  fill="none"
                                >
                                  <path
                                    d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                                    fill="#EA6404"
                                  ></path>
                                  <path
                                    d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                                    fill="#EA6404"
                                  ></path>
                                  <path
                                    d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                                    fill="#EA6404"
                                  ></path>
                                  <path
                                    d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                                    fill="#EA6404"
                                  ></path>
                                  <path
                                    d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                                    fill="#EA6404"
                                  ></path>
                                  <path
                                    d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                                    fill="#EA6404"
                                  ></path>
                                  <path
                                    d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                                    fill="#EA6404"
                                  ></path>
                                  <path
                                    d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                                    fill="#EA6404"
                                  ></path>
                                </svg>
                              </div>
                              <div className="file-text">
                                <span className="ext-name">
                                  {selectedfile?.name}
                                </span>
                                <strong>
                                  <span className="file-size">
                                    {formatBytes(selectedfile?.size)}
                                  </span>
                                </strong>
                              </div>
                            </div>
                          </div>
                          <div
                            className={
                              showProgress
                                ? "right-progressbar"
                                : "right-progressbar hide"
                            }
                          >
                            <CustomProgressBar
                              completed={fileUploadProgress}
                              labelLineHeight="1px"
                              labelSize="14px"
                              width="100%"
                              labelClassName="progressBarLabel"
                              borderRadius="30px"
                              labelAlignment="outside"
                              labelColor="rgba(0,0,0,0.87)"
                              height="10px"
                              className="file_upload_progress"
                              bgColor="#06B878"
                              baseBgColor="#D1DEF0"
                              ariaValuetext={fileUploadProgress}
                              aria-label=""
                              aria-valuenow={fileUploadProgress}
                            />
                          </div>
                        </div>
                      </div>
                      <p className="fsize-12">
                        If you have supporting materials for your revision
                        request, please upload a file.
                      </p>
                    </div>
                  </div>
                  <div className="flex two-col justify-end">
                    <button className={"blue-btn active"} type="submit">
                      Submit
                    </button>
                    <button
                      className="blue-btn"
                      onClick={cancelRequestRevision}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          ) : null}
          <div className="wrap-translate-table content-list">
            {fileHistory.map((files, index) => {
              return (
                <div
                  className={
                    index === 0
                      ? "translate-table-list  gap first"
                      : "translate-table-list  gap"
                  }
                  key={index + 5}
                >
                  <div className="file-detail">
                    <p className={index === 0 ? "large" : "medium"}>
                      <strong>{files.title}</strong> :{" "}
                      <span className="lighter big">{files.dateText}</span>
                    </p>
                  </div>
                  {files.rating ? (
                    <div className="flex pb3">
                      <span>Rating : </span>
                      <strong>{files.rating.value}</strong>
                    </div>
                  ) : null}
                  {files.description ? (
                    <div className="flex pb3">
                      <p>
                        <strong>Description : </strong> {files.description}
                      </p>
                    </div>
                  ) : null}
                  {files.dueDate ? (
                    <div className="flex pb3">
                      <span>
                        Due : {} {files.dueDate}
                      </span>
                    </div>
                  ) : null}
                  {files.docFile ? (
                    <button
                      aria-label={files.docFile.filename + " download"}
                      className="download"
                      onClick={() => files.docURL ? downloadHistoryAsset(files.docURL, files.docFile.filename) : null}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.9987 10.875V1.375M9.9987 10.875L6.33203 7.70833M9.9987 10.875L13.6654 7.70833M0.832031 12.4583L1.40128 14.4256C1.50042 14.7682 1.72929 15.0723 2.0515 15.2896C2.37372 15.5069 2.77079 15.6249 3.17961 15.625H16.8178C17.2266 15.6249 17.6237 15.5069 17.9459 15.2896C18.2681 15.0723 18.497 14.7682 18.5961 14.4256L19.1654 12.4583"
                          stroke="#1D4ED8"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span
                        className={
                          index === 0 ? "large filename" : "medium filename"
                        }
                      >
                        {files.docFile.filename}
                      </span>
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {
        {
          'alertModel': (
              <EditProjectDateBid
                  projectResource={projectResource}
                  projectStatus={projectDetailStatus}
                  close={showAlertModel}
                  preferVendor={preferedVendors}
                  autoSelect={allowAutomaticSelect}
                  refresh={prop.refresh}
              />),
          'showBidPopup': (<BidNeedMoreTime
              showPopup={showBidUpdatePopup}
              refresh={prop.refresh}
              projectDetail={prop.projectDetail}/>),
          'cancelationAssetsLength': (
              <div id="modelPopup" className="lightbox-panel asset-popup" aria-labelledby="cancelAssetTranslation" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel pb-0">
                  <div className="modal-header flex padd-lr">
                    <strong id="cancelAssetTranslation">
                      {translate("project_listing.cancel_asset_translation")}
                    </strong>
                  </div>
                  <div className="lightbox-content cancel-translation project-request padd-22">
                    <p>
                      Select assets and click Accept to cancel In Translation assets
                    </p>
                    <div className="form-check check-all">
                      <input
                          className="form-check-input AssetTranslationCheckall"
                          type="checkbox"
                          name="checkbox"
                          value="all"
                          id="check-all"
                          onChange={(e) => selectCancelAsset(e, cancelationAssets)}
                      />
                      <label className="form-check-label" htmlFor="check-all">
                        Select All
                      </label>
                      <input
                          className="form-check-input"
                          type="checkbox"
                          name="checkbox"
                          value="remove"
                          id="uncheckall"
                          onChange={(e) => selectCancelAsset(e, cancelationAssets)}
                      />
                      <label
                          className="form-check-label"
                          htmlFor="uncheckall"
                          style={{ marginLeft: "10px" }}
                      >
                        Unselect All
                      </label>
                    </div>
                    {cancelationAssets.map((asset, index) => {
                      return (
                          <div className="form-check" key={index}>
                            <input
                                className={
                                  cancelAssetSelected(asset)
                                      ? "form-check-input select-list  selected"
                                      : "form-check-input select-list"
                                }
                                type="checkbox"
                                name="checkbox"
                                value=""
                                id={`file-${index}`}
                                checked={cancelAssetSelected(asset)}
                                onChange={(e) => selectCancelAsset(e, asset)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`file-${index}`}
                            >
                              {asset.name}
                            </label>
                          </div>
                      );
                    })}
                  </div>

                  <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold cancelBtnFocus" onClick={hideCancelAsset}>
                      Cancel
                    </button>
                    <button
                        className="btn btn-bold active"
                        onClick={() => cancelAssetForPhase()}
                        onKeyDown={handleKeyEditflow}
                        id="acceptAssetForPhase"
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
          ),
          'showAssetApproval': (
              <div id="modelPopup" className="lightbox-panel asset-popup" aria-labelledby="approveAssets" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel pb-0">
                  <div className="modal-header flex padd-lr">
                    <strong id="approveAssets">Approve Assets</strong>
                  </div>
                  <div className="lightbox-content cancel-translation project-request padd-22">
                    <p>Select assets and click Approve to approve In Review assets</p>
                    <div className="form-check check-all ">
                      <input
                          className="form-check-input approveAssetsCheckall"
                          type="checkbox"
                          name="checkbox"
                          value="all"
                          id="check-all"
                          onChange={(e) => selectApproveAsset(e, assetsForApproval)}
                      />
                      <label className="form-check-label" htmlFor="check-all">
                        Select All
                      </label>
                      <input
                          className="form-check-input"
                          type="checkbox"
                          name="checkbox"
                          value="remove"
                          id="uncheckall"
                          onChange={(e) => selectApproveAsset(e, assetsForApproval)}
                      />
                      <label
                          className="form-check-label"
                          htmlFor="uncheckall"
                          style={{ marginLeft: "10px" }}
                      >
                        Unselect All
                      </label>
                    </div>
                    {assetsForApproval.map((asset, index) => {
                      return (
                          <div className="form-check" key={index}>
                            <input
                                className={
                                  assetSelected(asset)
                                      ? "form-check-input select-list selected"
                                      : "form-check-input select-list"
                                }
                                type="checkbox"
                                name="checkbox"
                                value={asset.id}
                                checked={assetSelected(asset)}
                                id={`file-${asset.id}`}
                                onChange={(e) => selectApproveAsset(e, asset)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`file-${asset.id}`}
                            >
                              {asset.name}
                            </label>
                          </div>
                      );
                    })}
                  </div>

                  <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold cancelApproveAsset" onClick={cancelApproveAsset}>
                      Cancel
                    </button>
                    <button
                        id="approveCurrentAssets"
                        className="btn btn-bold active"
                        onClick={() => approveCurrentAssets()}
                        onKeyDown={handleKeyapproveflow}
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
          ),
          'showAssetBack': (
              <div id="modelPopup" className="lightbox-panel asset-popup" aria-labelledby="MoveAssets" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel pb-0">
                  <div className="modal-header flex padd-lr">
                    <strong id="MoveAssets">Move assets back to previous review</strong>
                  </div>
                  <div className="lightbox-content cancel-translation project-request padd-22">
                    <ConditionalBlock condition={assetToMoveBack.length == 0}>
                      <p>
                        No assets to be moved back to previous phase of the Workflow
                      </p>
                    </ConditionalBlock>
                    <ConditionalBlock condition={assetToMoveBack.length > 0}>
                    <p>
                      Select assets to be moved back to previous phase of the Workflow
                    </p>
                    <div className="form-check check-all ">
                      <input
                          className="form-check-input moveAssetsCheckall"
                          type="checkbox"
                          name="checkbox"
                          value="all"
                          id="check-all"
                          onChange={(e) => selectMoveBackAsset(e, assetToMoveBack)}
                      />
                      <label className="form-check-label" htmlFor="check-all">
                        Select All
                      </label>
                      <input
                          className="form-check-input"
                          type="checkbox"
                          name="checkbox"
                          value="remove"
                          id="uncheckall"
                          onChange={(e) => selectMoveBackAsset(e, assetToMoveBack)}
                      />
                      <label
                          className="form-check-label"
                          htmlFor="uncheckall"
                          style={{ marginLeft: "10px" }}
                      >
                        Unselect All
                      </label>
                    </div>

                    {assetToMoveBack.map((asset, index) => {
                      return (
                          <div className="form-check" key={index}>
                            <input
                                className={
                                  moveBackAssetSelected(asset)
                                      ? "form-check-input select-list selected"
                                      : "form-check-input select-list"
                                }
                                type="checkbox"
                                name="checkbox"
                                value={asset.id}
                                checked={moveBackAssetSelected(asset)}
                                id={`file-${asset.id}`}
                                onChange={(e) => selectMoveBackAsset(e, asset)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`file-${asset.id}`}
                            >
                              {asset.name}
                            </label>
                          </div>
                      );
                    })}
                    </ConditionalBlock>
                  </div>

                  <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold cancelMoveAsset" onClick={cancelMoveBackAsset}>
                      Cancel
                    </button>
                    <button
                        id="moveCurrentAssets"
                        className="btn btn-bold active"
                        disabled={selectedMoveBackAssets.length === 0}
                        onClick={() => moveBackCurrentAssets()}
                        onKeyDown={handleKeyMoveflow}

                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
          ),
          'showDeliverableApprovePopup': (
              <div id="modelPopup" className="lightbox-panel asset-popup" aria-labelledby="approveLangDeliverable" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel pb-0">
                  <div className="modal-header flex padd-lr mar-bot16">
                    {offlineReviewFeedbackType === "approve" ? (
                        <strong id="approveLangDeliverable">
                          Approve {selectedTranslatedAsset.language} Deliverable?
                        </strong>
                    ) : (
                        <strong>
                          Submit Feedback for {selectedTranslatedAsset.language}{" "}
                          Deliverable
                        </strong>
                    )}
                  </div>
                  <div className="lightbox-content p-0">
                    {offlineReviewFeedbackType === "approve" ? (
                        <p className="plr-22">
                          Click Submit to approve the {selectedTranslatedAsset.language}{" "}
                          deliverable and complete your review.
                        </p>
                    ) : (
                        ""
                    )}
                    <div className="request-revision-form">
                      {offlineReviewFeedbackType === "approve" ? (
                          <p className="plr-22">
                            Add information about changes needed to translation memory
                            related to this deliverable
                          </p>
                      ) : (
                          ""
                      )}
                      <div className="campaign_details-task-create-form p-0">
                        <form onSubmit={handleSubmit(postDeliverableApproveMsg)}>
                          <div className="task-form-content plr-22">
                            <div className="form-group text">
                              <div className="form-text">
                                <label htmlFor="msg-content">Notes </label>
                                <textarea
                                    className="textarea"
                                    id="msg-content"
                                    placeholder="1000 characters limit"
                                    value={feedBackMessage}
                                    maxLength={1000}
                                    {...register("message", validations.message)}
                                    onChange={(event) =>
                                        setFeedBackMessage(event.target.value)
                                    }
                                ></textarea>
                                <p
                                    className="error textDanger m-0"
                                    aria-label="error alert"
                                    role="alert"
                                >
                                  {errors.message?.message}
                                </p>
                              </div>
                            </div>
                            <div className="flex wrap-dropdown file-btn">
                              <div className="file-input flex w-d100">
                                <div className="input-file mar-bot16">
                                  <input
                                      type="file"
                                      id="files"
                                      onChange={assetFileSelection}
                                  />
                                  <label
                                      className="file-button flex-center"
                                      htmlFor="files"
                                  >
                                    {!selectedAttachmentFile
                                        ? "Choose file"
                                        : "Replace"}
                                  </label>
                                </div>
                                <div
                                    className={
                                      selectedAttachmentFile
                                          ? "uploading-files-block uploading-success w-d100"
                                          : "uploading-files-block uploading-success w-d100 hide"
                                    }
                                >
                                  <div className="uploading-file-list flex">
                                    <div className="left-file-desc flex-center">
                                      <div className="icon-block">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="25"
                                            height="25"
                                            viewBox="0 0 25 25"
                                            fill="none"
                                        >
                                          <path
                                              d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                                              fill="#EA6404"
                                          ></path>
                                          <path
                                              d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                                              fill="#EA6404"
                                          ></path>
                                          <path
                                              d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                                              fill="#EA6404"
                                          ></path>
                                          <path
                                              d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                                              fill="#EA6404"
                                          ></path>
                                          <path
                                              d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                                              fill="#EA6404"
                                          ></path>
                                          <path
                                              d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                                              fill="#EA6404"
                                          ></path>
                                          <path
                                              d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                                              fill="#EA6404"
                                          ></path>
                                          <path
                                              d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                                              fill="#EA6404"
                                          ></path>
                                        </svg>
                                      </div>
                                      <div className="file-text">
                                  <span className="ext-name">
                                    {selectedAttachmentFile?.name}
                                  </span>
                                        <strong>
                                    <span className="file-size">
                                      {formatBytes(
                                          selectedAttachmentFile?.size
                                      )}
                                    </span>
                                        </strong>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      className={
                                        showProgress
                                            ? "right-progressbar"
                                            : "right-progressbar hide"
                                      }
                                  >
                                    <CustomProgressBar
                                        completed={fileAttachmentUploadProgress}
                                        labelLineHeight="1px"
                                        labelSize="14px"
                                        width="100%"
                                        labelClassName="progressBarLabel"
                                        borderRadius="30px"
                                        labelAlignment="outside"
                                        labelColor="rgba(0,0,0,0.87)"
                                        height="10px"
                                        className="file_upload_progress"
                                        bgColor="#06B878"
                                        baseBgColor="#D1DEF0"
                                        ariaValuetext={fileAttachmentUploadProgress}
                                        aria-label=""
                                        aria-valuenow={fileAttachmentUploadProgress}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer modal-footer-border flex px-22">
                            <button className="blue-btn cancelApproveLang" onClick={cancelFeedback}>
                              Cancel
                            </button>
                            <button id="submitApproveLang" className="btn btn-bold active" type="submit" onKeyDown={handleKeyApproveLang}>
                              Submit
                            </button>

                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          ),
          'popUpValue': (
              <div id="modelPopup" className="lightbox-panel approved-popup" aria-labelledby="approveTranslated" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel">
                  <div className="modal-header flex">
                    <strong id="approveTranslated">Approve Translated Deliverables</strong>
                  </div>
                  {languageToReview && languageToReview.length > 0 ? (
                      <>
                        <div className="lightbox-content">
                          <p>
                            Select the languages to approve (click on a language below
                            to select or deselect)
                          </p>
                          <div>
                            <div className="form-check check-all">
                              <input
                                  className="form-check-input approveSelectAll"
                                  type="checkbox"
                                  name="checkbox"
                                  value="all"
                                  id="check-all"
                                  onChange={(e) => approveLanguages(e, "")}
                              />
                              <label className="form-check-label" htmlFor="check-all">
                                Select All
                              </label>
                              <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="checkbox"
                                  value="remove"
                                  id="uncheckall"
                                  onChange={(e) => approveLanguages(e, "")}
                              />
                              <label
                                  className="form-check-label"
                                  htmlFor="uncheckall"
                                  style={{ marginLeft: "10px" }}
                              >
                                Unselect All
                              </label>
                            </div>
                          </div>
                          <div className="translate-box flex" role="group">
                            {languageToReview && languageToReview?.length > 0 && languageToReview?.map((lang, index) => {
                              if (lang.resource.languageStatus !== "APPROVED") {
                                return (
                                    <div className="translate-box-list" key={index} role='none' >
                                      <Link
                                          role="checkbox"
                                          onClick={(e) => approveLanguages(e, lang)}
                                          onKeyDown={(e) => approveLanguagesKeydown(e, lang)}
                                          aria-checked={
                                            approvedLangs.some(
                                                (target) =>
                                                    target.targetLanguage.name ===
                                                    lang.displayName[0].name
                                            )
                                                ? "true"
                                                : "false"
                                          }
                                          className={
                                            approvedLangs?.some(
                                                (target) =>
                                                    target?.targetLanguage?.name ===
                                                    lang?.displayName[0]?.name
                                            )
                                                ? "tab"
                                                : "active"
                                          }
                                      >
                                        <span>{lang.displayName[0].display}</span>
                                        {approvedLangs?.some(
                                            (target) =>
                                                target?.targetLanguage?.name ===
                                                lang?.displayName[0]?.name
                                        ) ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="19"
                                                height="19"
                                                viewBox="0 0 19 19"
                                                fill="none"
                                            >
                                              <rect
                                                  x="0.75"
                                                  y="0.75"
                                                  width="17.5"
                                                  height="17.5"
                                                  rx="8.75"
                                                  stroke="#40AD18"
                                                  strokeWidth="1.5"
                                              ></rect>
                                              <path
                                                  d="M13.2713 6.19727L7.21686 12.8021L4.46484 9.7999"
                                                  stroke="#40AD18"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                              ></path>
                                            </svg>
                                        ) : null}
                                      </Link>
                                    </div>
                                );
                              }
                            })}
                          </div>
                          <div className="py-15">
                            <label className="form-check-label" htmlFor="language list">
                              Please confirm that the selected list of languages is
                              correct.
                            </label>
                          </div>
                          <span className="alert-icon py-15">
                    Remember, once you approve a language, you will not be able
                    to request a new revision from the vendor.
                  </span>
                          <div className="flex wrap-dropdown mb-0 project-request">
                            <div className="flex wrap-dropdown mb-0 py-15">
                              <strong>Selected language(s) : </strong>
                              {approvedLangs.map((langs, index) => {
                                if (approvedLangs.length === index + 1) {
                                  return (
                                      <React.Fragment key={index}>
                                        &nbsp;<span>{langs.targetLanguage.display} </span>
                                      </React.Fragment>
                                  );
                                } else {
                                  return (
                                      <React.Fragment key={index}>
                                        &nbsp;
                                        <span key={index}>
                                {langs.targetLanguage.display}
                                          {", "}{" "}
                              </span>
                                      </React.Fragment>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer flex">
                          <button className="btn btn-bold approveFirstFocus" onClick={hideApproveTranslatedDeliverableModel}
                                  onKeyDown={(e) => handleKeyApproveTranslateflow2(e)}
                          >
                            Cancel
                          </button>
                          <button
                              className={
                                approvedLangs.length === 0
                                    ? "btn btn-bold disabled approveSecondFocus"
                                    : "btn btn-bold active approveSecondFocus"
                              }
                              disabled={approvedLangs.length === 0}
                              onClick={() => approveTranslation()}
                              onKeyDown={handleKeyApproveTranslateflow}
                          >
                            Approve Translation
                          </button>
                        </div>
                      </>
                  ) : (
                      <>
                        <div className="lightbox-content">
                          <p>
                            Sorry, there are no languages available to be approved.{" "}
                            <Link to={Constants.LEARN_WHY_LINK}>Learn why</Link>
                          </p>
                        </div>
                        <div className="modal-footer flex">
                          <button className="btn btn-bold" onClick={hideModel}>
                            Cancel
                          </button>
                        </div>
                      </>
                  )}
                </div>
              </div>
          ),
          'syncErrorsRetry': (
              <div id="modelPopup" className="lightbox-panel asset-popup">
                <div className="inner-lightbox-panel">
                  <div className="modal-header flex">
                    <strong>Retry Asset Sync </strong>
                    <button
                        className="close"
                        aria-label="close right popup"
                        onClick={cancelRetryAsset}
                    >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                      >
                        <path
                            d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                            fill="white"
                        ></path>
                        <path
                            d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                            fill="white"
                        ></path>
                      </svg>
                    </button>
                  </div>
                  <div className="lightbox-content cancel-translation project-request">
                    <p>Select assets and click Approve to retry asset sync.</p>
                    <div className="form-check check-all">
                      <input
                          className="form-check-input"
                          type="checkbox"
                          name="checkbox"
                          value="all"
                          id="check-all"
                          onChange={(e) => selectRetryAsset(e)}
                      />
                      <label className="form-check-label" htmlFor="check-all">
                        Select All
                      </label>
                      <input
                          className="form-check-input"
                          type="checkbox"
                          name="checkbox"
                          value="remove"
                          id="uncheckall"
                          onChange={(e) => selectRetryAsset(e)}
                      />
                      <label
                          className="form-check-label"
                          htmlFor="uncheckall"
                          style={{ marginLeft: "10px" }}
                      >
                        Unselect All
                      </label>
                    </div>
                    {Object.keys(syncErrors).map((syncError, index) => {
                      return (
                          <div className="form-check" key={index}>
                            <input
                                className={
                                  retryAssetSelected(syncError)
                                      ? "form-check-input select-list  selected"
                                      : "form-check-input select-list"
                                }
                                type="checkbox"
                                name="checkbox"
                                value={syncError}
                                checked={retryAssetSelected(syncError)}
                                id={`file-${syncError}`}
                                onChange={(e) => selectRetryAsset(e, syncError)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`file-${syncError}`}
                            >
                              {syncErrors[syncError].asset.name}
                            </label>
                          </div>
                      );
                    })}
                  </div>
                  <div className="modal-footer flex">
                    <button className="btn btn-bold" onClick={cancelRetryAsset}>
                      Cancel
                    </button>
                    <button
                        className="btn btn-bold active"
                        onClick={() => approveRetryAssets()}
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
          ),
          'uploadRevisePopup': (
              <UploadReviseTranslation
                  closeUploadTranslation={closeUploadTranslation}
                  option={options}
                  projectId={param.id}
                  targetLangDisplay={getSelectedLanguageDisplayName()}
                  revisionOrReviewData={currentRevisionOrReviewData}
                  langCode={langCode}
                  refresh={refreshPage}
              />
          ),
          'showChatPopup': (
              <DiscussionOverviewPopup
                  id={param.id}
                  targetAssetId={targetDataIdForDiscussion}
                  userGroupId={projectResource.userGroup.id}
                  showChatBox={showChatBox}
                  vendorName={vendorName}/>
          ),
          'showUploadTM': (
              <UploadTmPopup
                projectId={projectId}
                tmFileId={translationMemoryFile?.id}
                uploadEndHandler={updateTmFile}
              />
          ),
        }[Object.entries({
          alertModel: alertModel,
          showBidPopup: showBidPopup,
          cancelationAssetsLength: cancelationAssets.length > 0,
          showAssetApproval: showAssetApproval,
          showAssetBack: showAssetBack,
          showDeliverableApprovePopup: showDeliverableApprovePopup,
          popUpValue: popUpValue !== "",
          syncErrorsRetry: syncErrorsRetry,
          uploadRevisePopup: uploadRevisePopup,
          showChatPopup: showChatPopup,
          showUploadTM: showUploadTM,
        }).find(([key,value]) => value)?.[0]]
      }
      {showRequestTranslationAgain && (
        <RequestTranslationAgain
          projectDetails={prop.projectDetail}
          refresh={refreshProject}
          closePopup={showRequestTranslationAgainAlertModel}
        />
      )}
      {showRequestTranslationVendor && (
        <RequestTranslationAgainVendor
          projectDetails={prop.projectDetail}
          refresh={refreshProject}
          popupState={setShowRequestTranslationVendor}
        />
      )}
    </div>
  );
};
